const lessonsHonnhan = [
{
  id: 1,
  title: "Ơn gọi hôn nhân trong chương trình của Thiên Chúa",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Hôn nhân phát xuất từ chương trình yêu thương của Thiên Chúa khi Ngài dựng nên con người có nam có nữ, mời gọi họ sống hiệp thông, yêu thương, sinh sản và giáo dục con cái.",
  content: `# 💍 BÀI 1: ƠN GỌI HÔN NHÂN TRONG CHƯƠNG TRÌNH CỦA THIÊN CHÚA

“Từ ban đầu Tạo Hoá đã dựng nên con người có nam có nữ và Ngài đã phán: Vì thế, người nam sẽ bỏ cha mẹ mà kết hợp với vợ mình, và cả hai sẽ nên một huyết nhục” (Mt 19,4-5).

Hôn nhân và gia đình là một trong những thể chế cổ xưa nhất của loài người. Ngay từ những trang đầu của Kinh Thánh, hôn nhân đã được nhắc đến (x. St 1–2), và hình ảnh hôn nhân cũng xuất hiện nơi những trang cuối (x. Kh 19–21). Điều đó cho thấy hôn nhân không chỉ là một định chế xã hội, nhưng trước hết là một phần trong chương trình yêu thương của Thiên Chúa.

---

# I. HÔN NHÂN LÀ GÌ?

Hôn nhân là một giao ước ký kết giữa một người nam và một người nữ, với ý thức tự do và trách nhiệm, để:

- Sống yêu thương và giúp đỡ nhau trong tình nghĩa vợ chồng  
- Sinh sản và giáo dục con cái trong nhiệm vụ làm cha làm mẹ  

---

# II. NGUỒN GỐC CỦA HÔN NHÂN

Nguồn gốc của hôn nhân chính là Thiên Chúa.

Sách Sáng Thế thuật lại:

“Thiên Chúa sáng tạo con người theo hình ảnh Ngài... Ngài sáng tạo họ có nam có nữ. Thiên Chúa chúc phúc cho họ và phán: Hãy sinh sôi nảy nở cho nhiều...” (St 1,26-28).

Ngoài ra, sách Sáng Thế còn mô tả cách cụ thể việc kết hiệp vợ chồng:

“Đàn ông ở một mình không tốt... Vì thế, người đàn ông sẽ lìa bỏ cha mẹ mà kết hợp với vợ mình, và cả hai nên một thân thể” (St 2,7.18.21-24).

Thiên Chúa không dựng nên con người cô độc, nhưng dựng nên họ có nam có nữ và tác hợp họ nên vợ chồng. Vì thế:

👉 Hôn nhân phát xuất từ ý muốn của Thiên Chúa.  
👉 Ơn gọi hôn nhân được khắc ghi trong chính bản tính con người.

---

# III. TÌNH YÊU – YẾU TỐ CĂN BẢN CỦA HÔN NHÂN

Thiên Chúa là Tình Yêu (x. 1 Ga 4,8).

Ngài dựng nên con người theo hình ảnh mình và mời gọi họ sống yêu thương và hiệp thông.

- Tình yêu là ơn gọi nền tảng và bẩm sinh của con người.  
- Tình yêu là nền móng của đời sống hôn nhân.  
- Sự trao hiến thân xác chỉ có ý nghĩa khi diễn tả sự tự hiến vì tình yêu.

Hôn nhân và gia đình:
- Được thiết lập do tình yêu  
- Được nuôi dưỡng nhờ tình yêu  
- Và mục đích cuối cùng cũng chính là tình yêu  

---

# IV. MỤC ĐÍCH CỦA HÔN NHÂN

Tự bản chất, hôn nhân hướng đến hai mục đích:

## 1️⃣ Yêu thương và bổ túc cho nhau

“Không còn là hai, nhưng là một xương một thịt” (Mt 19,6).

Vợ chồng được mời gọi:
- Trao hiến trọn vẹn cho nhau  
- Sống chung thủy suốt đời  
- Bổ túc và nâng đỡ nhau  

Sự hiệp thông vợ chồng được nuôi dưỡng nhờ nỗ lực sống yêu thương mỗi ngày.

---

## 2️⃣ Sinh sản và giáo dục con cái

Con cái là:
- Ân huệ cao quý nhất của hôn nhân  
- Niềm vui và hạnh phúc của cha mẹ  

Hôn nhân hướng đến:
- Cộng tác với Thiên Chúa trong việc ban sự sống  
- Giáo dục con cái về luân lý, tinh thần và đức tin  

Gia đình là nơi bảo toàn, biểu lộ và truyền đạt tình yêu.

---

# V. HẠNH PHÚC ĐỜI HÔN NHÂN

Hôn nhân luôn gắn với ước vọng trăm năm hạnh phúc.

Đối với người Kitô hữu:

- Hạnh phúc thật là được sống trong tình thân mật với Thiên Chúa.  
- Hôn nhân theo ý định của Thiên Chúa là con đường dẫn đến hạnh phúc.  

Khi đặt Thiên Chúa làm trung tâm:
- Điều gì giúp ta đến gần Ngài thì ta đón nhận  
- Điều gì làm xa Ngài thì ta dứt bỏ  

Hôn nhân trở thành con đường nên thánh và đạt tới hạnh phúc đời đời.

---

# 📌 GHI NHỚ

**1. H. Hôn nhân là gì?**  
T. Hôn nhân là giao ước ký kết giữa một người nam và một người nữ, với đầy đủ tự do ưng thuận và ý thức trách nhiệm, để trở thành vợ chồng.

**2. H. Ai đã lập nên hôn nhân?**  
T. Chính Thiên Chúa đã lập nên hôn nhân khi dựng nên loài người có nam có nữ và mời gọi họ sống yêu thương.

**3. H. Yếu tố căn bản của hôn nhân là gì?**  
T. Yếu tố căn bản của hôn nhân chính là tình yêu.

**4. H. Hôn nhân có những mục đích nào?**  
T. Có hai mục đích:
- Yêu thương và giúp đỡ lẫn nhau.  
- Cộng tác với Thiên Chúa trong việc sinh sản và giáo dục con cái.

---

# 💭 GỢI Ý SUY NGHĨ

1. Tình yêu khác gì với sự thu hút giữa nam và nữ?  
2. Tình yêu cần thiết cho hôn nhân như thế nào?  
3. Có thể kết hôn mà lại yêu người khác được không? Vì sao?

---

# 🙏 CẦU NGUYỆN

Lạy Chúa, chúng con cảm tạ Chúa vì đã dựng nên chúng con có nam có nữ, mang hình ảnh của Chúa.  

Xin dạy chúng con biết yêu thương như Chúa đã yêu thương chúng con, để đời sống hôn nhân và gia đình chúng con phản chiếu tình yêu của Chúa giữa trần gian.  

Amen.
`
},
{
  id: 2,
  title: "Hôn nhân Công giáo",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Hôn nhân Công giáo là bí tích Chúa Giêsu thiết lập để kết hợp một người nam và một người nữ thành vợ chồng trước mặt Thiên Chúa và Hội Thánh, ban ơn giúp họ sống yêu thương, trung tín và nên thánh.",
  content: `# 💒 BÀI 2: HÔN NHÂN CÔNG GIÁO

## 📖 LỜI CHÚA
“Bởi thế, người ta lìa bỏ cha mẹ mình mà kết hợp với vợ mình và cả hai nên một thân xác. Mầu nhiệm này thật lớn lao, tôi muốn nói về Đức Kitô và Hội Thánh.” (Ep 5,31-32)

## I. HÔN NHÂN CÔNG GIÁO LÀ MỘT BÍ TÍCH

Khi một người nam và một người nữ kết hôn, họ trở thành vợ chồng theo luật tự nhiên. Nhưng đối với người Kitô hữu, hôn nhân không chỉ là một khế ước tự nhiên, mà còn là một bí tích.

Thiên Chúa đã thiết lập hôn nhân ngay từ thuở ban đầu. Chúa Giêsu đã nâng hôn ước tự nhiên ấy lên hàng Bí tích, làm dấu chỉ tình yêu giữa Đức Kitô và Hội Thánh.

Qua bí tích Hôn phối:
- Hai người trở nên vợ chồng trước mặt Thiên Chúa và Hội Thánh  
- Tình yêu của họ được Thiên Chúa đóng ấn  
- Họ nhận được ơn siêu nhiên để sống ơn gọi hôn nhân  

Hôn nhân Kitô giáo là dấu chỉ giao ước giữa Đức Kitô và Hội Thánh, và thông ban ân sủng để vợ chồng yêu thương, trung thành và nên thánh.

## II. ĐẶC TÍNH CỦA HÔN NHÂN CÔNG GIÁO

Tình yêu vợ chồng Công giáo bắt nguồn từ tình yêu Thiên Chúa và mang hai đặc tính:

### 1️⃣ Đơn nhất
Đơn nhất nghĩa là một vợ một chồng.

“Họ không còn là hai, nhưng là một xương một thịt” (Mt 19,6).

Vợ chồng được mời gọi:
- Trung thành trao hiến trọn vẹn cho nhau  
- Sống bình đẳng trong yêu thương  
- Loại trừ đa thê và mọi hình thức chia rẽ  

### 2️⃣ Bất khả phân ly
Bất khả phân ly nghĩa là không thể ly dị.

“Điều gì Thiên Chúa đã kết hợp, loài người không được phân ly” (Mt 19,6).

Sự trung tín này phản ánh:
- Sự trung tín của Thiên Chúa với dân Ngài  
- Tình yêu chung thủy của Đức Kitô với Hội Thánh  

Chung thủy suốt đời là một thách đố, nhưng nhờ ơn Chúa, vợ chồng có thể vượt qua khó khăn và sống trọn giao ước hôn nhân.

## III. HIỆU QUẢ BÍ TÍCH HÔN PHỐI

Bí tích Hôn phối đem lại hai hiệu quả chính:

### 1️⃣ Dây hôn phối
- Là sự ràng buộc vĩnh viễn và độc nhất  
- Do chính Thiên Chúa đóng ấn  
- Không thể tháo gỡ khi đã thành sự và hoàn hợp  

Dây hôn phối là giao ước được Thiên Chúa bảo đảm bằng sự trung tín của Ngài.

### 2️⃣ Ân sủng bí tích
Ân sủng Hôn phối:
- Kiện toàn tình yêu vợ chồng  
- Củng cố sự hiệp nhất bất khả phân ly  
- Giúp họ nên thánh trong đời sống gia đình  
- Giúp họ đón nhận và giáo dục con cái  

Đức Kitô ở lại với vợ chồng, ban sức mạnh để họ:
- Tha thứ cho nhau  
- Mang gánh nặng cho nhau  
- Yêu thương nhau bằng tình yêu siêu nhiên  

## 📌 GHI NHỚ

**Hỏi:** Hôn nhân Công giáo là gì?  
**Trả lời:** Là bí tích Chúa Giêsu đã lập để kết hợp hai người tín hữu, một nam một nữ, thành vợ chồng trước mặt Thiên Chúa và Hội Thánh, và ban ơn giúp họ sống xứng đáng ơn gọi của mình.

**Hỏi:** Hôn nhân Công giáo có những đặc tính nào?  
**Trả lời:** Có hai đặc tính: đơn nhất (một vợ một chồng) và bất khả phân ly (trung thành trọn đời).

**Hỏi:** Bí tích Hôn phối ban ơn gì?  
**Trả lời:** Ban ơn giúp vợ chồng yêu thương như Đức Kitô yêu Hội Thánh, củng cố sự hiệp nhất và thánh hóa đời sống gia đình.

## 🤔 GỢI Ý SUY NGHĨ
1. Tôi học được gì từ tình yêu Đức Kitô dành cho Hội Thánh?  
2. Trung thành trọn đời có phải là một thách đố lớn không?  
3. Tôi có tin tưởng vào ân sủng Chúa trong đời sống hôn nhân không?  

## 🙏 CẦU NGUYỆN
Lạy Chúa Giêsu, Chúa đã yêu thương Hội Thánh đến hiến mình vì Hội Thánh. Xin cho chúng con biết yêu thương như Chúa, biết sống trung thành, quảng đại và tin tưởng vào ơn Chúa trong ơn gọi hôn nhân và gia đình. Amen.
`
},
{
  id: 3,
  title: "Giáo luật về Bí tích Hôn phối",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Giáo luật về Bí tích Hôn phối quy định các điều kiện thành sự, các ngăn trở, sự ưng thuận và thể thức cử hành hôn nhân, nhằm bảo vệ sự thánh thiêng, bền vững và hạnh phúc của gia đình Kitô giáo.",
  content: `# ⚖️ BÀI 3: GIÁO LUẬT VỀ BÍ TÍCH HÔN PHỐI

## 📖 LỜI CHÚA
“Sự gì Thiên Chúa đã kết hợp, loài người không được phân ly” (Mc 10,9).

---

## I. Ý NGHĨA GIÁO LUẬT VỀ HÔN NHÂN

Hôn nhân không chỉ liên quan đến hai người, mà còn liên quan đến gia đình và xã hội, vì gia đình là tế bào căn bản của xã hội.

Vì mang tính xã hội, hôn nhân cần được pháp luật công nhận và bảo vệ. Hội Thánh ban hành giáo luật về Hôn phối để:
- Giúp các tín hữu xây dựng gia đình bền vững và hạnh phúc  
- Bảo vệ tính thánh thiêng của Bí tích  
- Hướng dẫn con cái mình sống đúng ý định của Thiên Chúa  

---

## II. ĐIỀU KIỆN CỬ HÀNH BÍ TÍCH HÔN PHỐI

Để Bí tích Hôn phối thành sự cần có bốn điều kiện:

1️⃣ Là một người nam và một người nữ đã rửa tội  
2️⃣ Có tự do kết hôn:
   - Không bị ép buộc  
   - Không bị ngăn trở theo luật tự nhiên hoặc luật Hội Thánh  
3️⃣ Bày tỏ sự ưng thuận kết hôn  
4️⃣ Cử hành theo thể thức của Hội Thánh  

---

## III. CÁC NGĂN TRỞ HÔN PHỐI

Ngăn trở hôn phối là những hoàn cảnh làm cho cuộc hôn phối không thành sự hoặc bất hợp pháp.

Có 12 ngăn trở chính:

1️⃣ Chưa đủ tuổi kết hôn  
2️⃣ Bất lực (không thể giao hợp)  
3️⃣ Còn bị ràng buộc bởi hôn phối trước  
4️⃣ Khác tôn giáo  
5️⃣ Chức thánh  
6️⃣ Khấn dòng  
7️⃣ Bắt cóc  
8️⃣ Tội mưu sát phối ngẫu  
9️⃣ Họ máu (huyết tộc)  
🔟 Họ kết bạn  
1️⃣1️⃣ Công hạnh (liêm sỉ)  
1️⃣2️⃣ Pháp tộc (nghĩa dưỡng)

Một số ngăn trở thuộc luật tự nhiên thì Hội Thánh không thể miễn chuẩn, như:
- Bất lực  
- Đang có hôn phối trước  
- Họ máu hàng dọc  
- Họ máu hai bậc hàng ngang  

Các ngăn trở khác có thể được miễn chuẩn khi có lý do chính đáng.

---

## IV. SỰ ƯNG THUẬN KẾT HÔN

Sự ưng thuận là yếu tố làm nên hôn nhân.

Đó là hành vi tự do và ý thức, trong đó hai người tự hiến cho nhau:
“Anh nhận em làm vợ.”  
“Em nhận anh làm chồng.”

Hôn nhân không thành nếu thiếu tự do thật sự.

Các trường hợp làm cho ưng thuận không thành:
- Không đủ trí khôn  
- Thiếu phán đoán nghiêm trọng  
- Tâm thần không thể đảm nhận nghĩa vụ  
- Vô tri về hôn nhân  
- Lầm lẫn về người hoặc phẩm cách  
- Lường gạt  
- Giả vờ ưng thuận  
- Đặt điều kiện về tương lai  
- Bị cưỡng ép hoặc sợ hãi nghiêm trọng  

---

## V. THỂ THỨC HÔN PHỐI

Để hôn nhân thành sự, phải:
- Cử hành trước vị chứng hôn hợp pháp (cha xứ, linh mục hoặc phó tế được ủy quyền)  
- Có hai người làm chứng  
- Thường cử hành tại nhà thờ giáo xứ  

Sự hiện diện của thừa tác viên Hội Thánh cho thấy hôn nhân là một bậc sống trong Hội Thánh.

---

## 📌 GHI NHỚ

**Hỏi:** Để Bí tích Hôn phối thành sự phải có những điều kiện nào?  
**Trả lời:** Phải có bốn điều kiện: một nam một nữ đã rửa tội; có tự do kết hôn; bày tỏ sự ưng thuận; và cử hành theo thể thức Hội Thánh.

**Hỏi:** Ngăn trở hôn phối là gì?  
**Trả lời:** Là những hoàn cảnh làm cho hôn phối không thành sự hoặc bất hợp pháp.

**Hỏi:** Vì sao sự ưng thuận rất quan trọng?  
**Trả lời:** Vì chính sự ưng thuận tự do làm nên hôn nhân; không ai có thể thay thế được.

---

## 🤔 GỢI Ý SUY NGHĨ
1. Vì sao Hội Thánh đặt ra các điều luật về hôn nhân?  
2. Tôi hiểu thế nào về sự tự do trong hôn nhân?  
3. Tôi có tôn trọng tính thánh thiêng của Bí tích Hôn phối không?  

---

## 🙏 CẦU NGUYỆN
Lạy Chúa, Chúa đã ban cho chúng con Hội Thánh để hướng dẫn và gìn giữ đời sống hôn nhân. Xin giúp chúng con biết tôn trọng luật Chúa và giáo huấn của Hội Thánh, để xây dựng gia đình bền vững, hạnh phúc và thánh thiện. Amen.
`
},
{
  id: 4,
  title: "Hôn nhân khác tôn giáo",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Hôn nhân giữa người Công giáo và người không cùng niềm tin luôn mang theo những thách đố đặc biệt, đòi hỏi sự tôn trọng, trưởng thành đức tin và tuân giữ giáo luật Hội Thánh.",
  content: `# 💍 BÀI 4: HÔN NHÂN KHÁC TÔN GIÁO

## 📖 LỜI CHÚA
“Nếu anh em nào có vợ ngoại mà người đó thuận ở với mình, thì chớ rẫy vợ... Vì chồng ngoại được thánh hóa nhờ vợ, và vợ ngoại được thánh hóa nhờ người chồng có đạo.” (1 Cr 7,12-14)

Thế giới hôm nay với sự phát triển mạnh mẽ của truyền thông và giao lưu xã hội khiến các cuộc hôn nhân khác tôn giáo ngày càng gia tăng. Đây là một ưu tư đặc biệt của Hội Thánh vì những khác biệt niềm tin thường gây nhiều thử thách trong đời sống gia đình.

---

## I. THẾ NÀO LÀ HÔN NHÂN KHÁC TÔN GIÁO?

Hôn nhân khác tôn giáo là hôn nhân giữa một người Công giáo và một người không phải là Công giáo.

• Nếu bên kia đã được rửa tội trong Hội Thánh Tin Lành hoặc Chính Thống → gọi là **hôn nhân hỗn hợp (dị tín)**.  
• Nếu bên kia chưa được rửa tội → gọi là **hôn nhân khác đạo (dị giáo)**, ví dụ: Công giáo kết hôn với người Phật giáo, Hồi giáo, Ấn Độ giáo, Do Thái giáo hoặc không theo tôn giáo nào.

---

## II. HẬU QUẢ CÓ THỂ XẢY RA

### 1. Trường hợp tích cực
Hôn nhân sẽ hạnh phúc nếu:
- Hai bên tôn trọng niềm tin của nhau  
- “Đạo ai người ấy giữ”  
- Bên không Công giáo tạo điều kiện cho việc thực hành đức tin  
- Con cái được giáo dục theo thỏa thuận  

### 2. Trường hợp tiêu cực
Hôn nhân có thể gặp nguy hiểm nếu:
- Không nhường nhịn trước khác biệt niềm tin  
- Xảy ra xung đột trong việc giáo dục con cái  
- Người Công giáo nguội lạnh và bỏ đạo  

---

## III. GIÁO LUẬT VỀ HÔN NHÂN KHÁC ĐẠO

Hội Thánh không khuyến khích nhưng có thể cho phép chuẩn:

• Hôn nhân hỗn hợp → cần phép rõ ràng của giáo quyền  
• Hôn nhân khác đạo → cần phép chuẩn để thành sự  

Đôi bạn phải trình bày với cha xứ để xin phép chuẩn nơi Đức Giám mục giáo phận.

### Điều kiện xin phép chuẩn:
1. Hai người hiểu và chấp nhận mục đích và đặc tính của hôn nhân theo giáo lý Công giáo  
2. Bên Công giáo cam kết giữ đức tin  
3. Cam kết cho con cái được rửa tội và giáo dục trong Hội Thánh  
4. Bên không Công giáo được biết rõ những cam kết ấy  

---

## IV. VÌ SAO HỘI THÁNH DÈ DẶT?

Vì:
- Niềm tin tôn giáo ảnh hưởng sâu xa đến lối sống và giáo dục con cái  
- Khác biệt tôn giáo dễ gây căng thẳng gia đình  
- Người Công giáo nếu hôn nhân tan vỡ không thể tái hôn khi người kia còn sống  

Nếu cùng một đức tin, vợ chồng có nền tảng chung để vượt qua thử thách và xây dựng gia đình hiệp nhất.

---

## V. NHỮNG THÁI ĐỘ CẦN CÓ

### 1. Đối với nhau
- Tôn trọng và yêu thương chân thành  
- Người Công giáo làm chứng cho Tin Mừng bằng đời sống  
- Siêng năng cầu nguyện cho người bạn đời  
- Học hỏi giáo lý sâu xa hơn  

### 2. Với gia đình hai bên
- Tôn trọng truyền thống  
- Sống khiêm nhường và khôn ngoan  
- Tin tưởng vào ơn Chúa  

### 3. Với cộng đoàn giáo xứ
- Gắn bó hơn với giáo xứ  
- Tham gia sinh hoạt gia đình Công giáo  
- Tìm sự nâng đỡ thiêng liêng  

---

## VI. KỲ VỌNG CỦA HỘI THÁNH

Hội Thánh luôn cầu nguyện và tin tưởng rằng:
“Chồng ngoại được thánh hóa nhờ vợ, và vợ ngoại được thánh hóa nhờ người chồng có đạo.” (1 Cr 7,14)

Tình yêu chân thành, đời sống nhân đức và cầu nguyện có thể giúp người không Công giáo mở lòng đón nhận đức tin.

---

## 📌 GHI NHỚ

**Hỏi:** Tôn giáo có vai trò nào trong đời sống hôn nhân?  
**Trả lời:** Ảnh hưởng đến lối suy nghĩ, cách xử sự và việc giáo dục con cái.

**Hỏi:** Hội Thánh có cho phép kết hôn với người ngoài Công giáo không?  
**Trả lời:** Có, nhưng phải xin phép chuẩn và đáp ứng các điều kiện theo luật Hội Thánh.

**Hỏi:** Người Công giáo có thể gặp nguy hiểm nào khi kết hôn khác đạo?  
**Trả lời:** Dễ nguội lạnh đức tin, gia đình bất đồng và dễ tan vỡ.

**Hỏi:** Người Công giáo cần sống thế nào?  
**Trả lời:** Sống tốt đạo và trở nên chứng nhân Tin Mừng cho gia đình.

---

## 🤔 GỢI Ý SUY NGHĨ
1. Vì sao Hội Thánh quan tâm đặc biệt đến hôn nhân khác đạo?  
2. Những thuận lợi và bất lợi của hôn nhân hỗn hợp là gì?  
3. Tôi có sẵn sàng làm chứng cho đức tin trong gia đình mình không?  

---

## 🙏 CẦU NGUYỆN
Lạy Chúa, xin giúp chúng con xây dựng gia đình theo thánh ý Chúa. Xin nâng đỡ những đôi bạn khác tôn giáo, để họ vượt qua khác biệt và trở nên dấu chỉ yêu thương giữa đời. Amen.
`
},
{
  id: 5,
  title: "Các thủ tục và nghi lễ Hôn phối",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Bài học trình bày các thủ tục dân sự, nghi lễ truyền thống Việt Nam và nghi thức bí tích Hôn phối trong Hội Thánh Công giáo.",
  content: `# 💍 BÀI 5: CÁC THỦ TỤC VÀ NGHI LỄ HÔN PHỐI

“Ta hãy vui mừng hoan hỉ, hãy tôn vinh Chúa! Vì này đã đến rồi, tiệc cưới Chiên Con, và hiền thê của Ngài đã trang điểm sẵn sàng. Và nàng được mặc trúc bâu rạng ngời tinh sạch.” (Kh 19,7-8)

Tự bản chất, hôn nhân mang tính xã hội, vì nối kết đôi bạn trước mặt gia đình, bạn bè và toàn thể xã hội. Vì thế, xã hội nào cũng có những quy định và phong tục cưới hỏi riêng.

Đối với Kitô giáo, hôn nhân là một bậc sống trong Hội Thánh và đã được Đức Kitô nâng lên hàng bí tích. Do đó, Hội Thánh có những thủ tục và nghi lễ nhằm bảo đảm hôn nhân thành sự, đồng thời giúp đôi tân hôn đón nhận dồi dào ơn sủng.

---

## I. CÁC THỦ TỤC VÀ NGHI LỄ DÂN SỰ

### 1. Thủ tục theo dân luật

**– Đăng ký kết hôn:**  
Thực hiện tại Ủy ban Nhân dân xã, phường hoặc thị trấn nơi một trong hai bên cư trú.

Sau khi kiểm tra đủ điều kiện hợp pháp, cơ quan hữu trách sẽ tổ chức đăng ký và trao Giấy chứng nhận kết hôn.

**– Tổ chức đăng ký kết hôn:**  
Hai bên nam nữ phải có mặt và tự nguyện xác nhận ý muốn kết hôn.

---

### 2. Nghi lễ theo truyền thống Việt Nam

Ngày xưa gồm sáu lễ: Nạp thái, Vấn danh, Nạp cát, Nạp tệ, Thỉnh kỳ, Thân nghinh.  
Ngày nay thường thu gọn thành ba lễ chính:

#### 2.1. Lễ dạm (chạm ngõ)

Gia đình hai bên gặp gỡ chính thức, xác nhận việc tìm hiểu và cho phép đôi bạn đi lại.

#### 2.2. Lễ đính hôn (lễ hỏi)

Nhà trai mang lễ vật (trầu cau, rượu, chè, bánh trái) đến nhà gái để xin cưới.  
Nhà gái đặt lễ lên bàn thờ gia tiên và chia lại quả cho nhà trai.

#### 2.3. Lễ cưới

**– Lễ Vu Quy (nhà gái):**  
Chú rể đến đón dâu, làm lễ gia tiên, lạy ông bà cha mẹ, nhận lời dặn dò.

**– Lễ Thành Hôn (nhà trai):**  
Rước dâu về nhà trai, làm lễ trước bàn thờ gia tiên, nhập tiệc chung vui.

---

## II. CÁC THỦ TỤC VÀ NGHI LỄ TÔN GIÁO

### 1. Thủ tục theo giáo luật

Khi quyết định kết hôn, đôi bạn cần:

**– Gặp cha xứ:****  
Làm tờ khai hôn phối và học giáo lý hôn nhân.

**– Chuẩn bị thiêng liêng:**  
Lãnh nhận bí tích Giao hòa và Thánh Thể.  
Nếu chưa Thêm sức thì nên lãnh nhận trước khi kết hôn.

**– Rao hôn phối:**  
Rao trong ba Chúa nhật tại giáo xứ mỗi bên để cộng đoàn cầu nguyện và xem có ngăn trở nào không.

**– Hoàn tất dân luật:**  
Phải đăng ký kết hôn trước khi làm lễ tại nhà thờ.

---

### 2. Cử hành Bí tích Hôn phối

**– Địa điểm:** tại nhà thờ giáo xứ.  
**– Nhân chứng:** cần hai người làm chứng.  
**– Người chứng hôn:** thường là cha xứ hoặc linh mục được ủy quyền.

Sau lễ, đôi tân hôn và nhân chứng ký vào Sổ Hôn phối.

---

## III. NGHI THỨC BÍ TÍCH HÔN PHỐI

Bí tích Hôn phối thường được cử hành trong Thánh lễ.

Nghi thức gồm ba phần:

### 1. Thẩm vấn

Chủ tế hỏi về:
- Sự tự do
- Lòng chung thủy
- Việc đón nhận và giáo dục con cái

### 2. Trao đổi lời thề hứa

Đôi tân hôn cam kết yêu thương và trung thành suốt đời.

### 3. Làm phép và trao nhẫn

Nhẫn là dấu chỉ của tình yêu và lòng trung tín.

Sau đó ký sổ Hôn phối.

---

## 📌 GHI NHỚ

**1. Khi quyết định tiến tới hôn nhân cần làm gì?**  
– Làm tờ khai hôn phối  
– Học giáo lý hôn nhân  
– Rao hôn phối  
– Ấn định ngày cưới  

**2. Về mặt dân sự cần làm gì?**  
– Đăng ký kết hôn tại Ủy ban Nhân dân.

**3. Vì sao phải cử hành theo nghi thức Hội Thánh?**  
– Vì là hành vi phụng vụ  
– Vì hôn nhân là bậc sống trong Hội Thánh  
– Vì cần người làm chứng  
– Vì sự công khai giúp sống trung tín

**4. Nghi thức bí tích gồm mấy phần?**  
– Thẩm vấn  
– Lời thề hứa  
– Trao nhẫn

---

## 🤔 GỢI Ý SUY NGHĨ

“Hôm nay tôi nhận anh (em) làm chồng (vợ) và hứa giữ lòng chung thủy với anh (em) khi thịnh vượng cũng như lúc gian nan, khi ốm đau cũng như lúc mạnh khỏe, để yêu thương và tôn trọng anh (em) suốt đời tôi.”

Anh chị sẽ sống lời hứa này thế nào trong đời sống hôn nhân?

---

## 🙏 CẦU NGUYỆN

Lạy Chúa, xin tuôn đổ ơn phúc trên các đôi vợ chồng, giúp họ sống trọn tình vẹn nghĩa và trở nên chứng nhân cho tình yêu của Chúa giữa trần gian. Amen.
`
},
{
  id: 6,
  title: "Sống thời kỳ đính hôn",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Thời kỳ đính hôn là giai đoạn chuẩn bị quan trọng giúp đôi bạn trưởng thành, tự do và chín chắn trước khi bước vào Bí tích Hôn phối.",
  content: `# 💍 BÀI 6: SỐNG THỜI KỲ ĐÍNH HÔN

“Đây là ý muốn của Thiên Chúa, là anh em nên thánh: anh em phải xa lánh hẳn tà dâm! Mỗi người trong anh em phải biết làm chủ bản thân mình, trong sự thánh thiện và danh dự. Đừng buông theo dục tình đam mê, như dân ngoại không biết Thiên Chúa.” (1Tx 4, 3-5).

Hôn nhân là chuyện hệ trọng, liên quan đến hạnh phúc cả đời. Chính vì thế, để bước vào đời sống hôn nhân đôi bạn cần được chuẩn bị về nhiều mặt, để được thực sự tự do và chín chắn khi quyết định. Thời gian đính hôn chính là thời gian cần thiết giúp đôi bạn chuẩn bị cho mình một cuộc hôn nhân hạnh phúc. “Kinh nghiệm cho thấy rằng những bạn trẻ nào được chuẩn bị chu đáo cho đời sống hôn nhân và gia đình, cách chung, sẽ thành công hơn các bạn khác[1].”

---

## 1. Những giai đoạn chuẩn bị

Việc chuẩn bị bước vào đời sống hôn nhân và gia đình cần được thực hiện theo một tiến trình tuần tự và liên tục, bao gồm ba giai đoạn chính: chuẩn bị xa, chuẩn bị gần và chuẩn bị liền trước bí tích[2].

### 1.1. Chuẩn bị xa

Việc chuẩn bị xa bắt đầu từ thời thơ ấu trong gia đình. Đây là giai đoạn hình thành nhân cách. Các em cần được giáo dục và đào tạo về mặt nhân bản để biết quý chuộng các giá trị nhân bản đích thực, biết làm chủ bản thân và tôn trọng người khác phái. Ngoài ra, cũng cần giúp các em hiểu hôn nhân là một ơn gọi và là một sứ mạng đích thực, để từ đó các em dần dần khám phá ra ơn gọi của mình: hoặc tận hiến cho Thiên Chúa trong đời sống tu trì hoặc hướng về cuộc sống hôn nhân và gia đình.

### 1.2. Chuẩn bị gần

Việc chuẩn bị gần là một công cuộc lâu dài, bao gồm một chương trình giáo lý thích hợp. Người trẻ cần được đào sâu những vấn đề về tính dục, hôn nhân, bổn phận làm chồng, làm vợ, trách nhiệm giáo dục con cái, đồng thời tạo điều kiện thuận lợi để họ có được những yếu tố căn bản giúp xây dựng một cuộc sống gia đình ổn định.

Ngoài ra, họ cũng cần học hỏi để biết làm việc tông đồ trong gia đình, sống tình huynh đệ, cộng tác với các gia đình khác, tích cực tham gia các nhóm, các hiệp hội, các phong trào và các sáng kiến có mục đích đem lại lợi ích cho các gia đình về mặt nhân bản cũng như về mặt đức tin.

### 1.3. Chuẩn bị liền trước bí tích

Đôi bạn cần đào sâu về mầu nhiệm Đức Kitô và Hội Thánh, về ý nghĩa của ân sủng và trách nhiệm gắn liền với hôn nhân Kitô giáo, về ý nghĩa các thủ tục và các lễ nghi phụng vụ hôn phối.

Việc chuẩn bị liền trước Bí tích Hôn phối này cần thiết cho mọi trường hợp, nhất là đối với những đôi bạn còn nhiều thiếu sót và khó khăn về mặt giáo lý và nếp sống đạo.

---

## 2. Đính hôn

Đính hôn là kết thúc giai đoạn sơ khởi của gặp gỡ, quen biết, để đưa tình yêu lứa đôi lên một mức nghiêm túc hơn và hướng đến một quyết định quan trọng là thành hôn. Lễ đính hôn là một truyền thống văn hóa của nhiều dân tộc trên thế giới. Ở Việt Nam, thường có lễ dạm rồi đến đính hôn hay lễ ăn hỏi và sau cùng là lễ thành hôn hay lễ cưới. Tuy nhiên hiện nay nhiều nơi chỉ còn lễ hỏi và lễ cưới.

Lễ đính hôn công khai hóa tình yêu của hai người với họ hàng đôi bên, bà con lối xóm và bạn bè thân hữu. Từ ngày đính hôn đôi bạn có tư cách chính thức để công khai gặp gỡ tìm hiểu nhau cũng như tìm hiểu gia đình của nhau. Sau lễ đính hai bên gia đình sẽ trình với cha xứ biết để ngài hướng dẫn đôi bạn về giáo lý hôn nhân cũng như chuẩn bị những thủ tục cần thiết cho việc cử hành bí tích hôn phối.

---

## 3. Tại sao cần phải có thời kỳ đính hôn?

Thời gian đính hôn là thời gian chuẩn bị. Việc chuẩn bị này là điều quan trọng, giúp cho đôi bạn chín chắn và trưởng thành khi đưa ra lời cam kết, cũng như giúp cho hôn ước của đôi bạn có được nền tảng tự nhiên và siêu nhiên, vững chắc và lâu dài. Hội Thánh nhắc nhở những bậc có trách nhiệm: “Phải biết giáo dục thanh thiếu niên hợp thời và hợp cách về phẩm giá, phận sự và hành vi thể hiện tình yêu vợ chồng, nhất là trong chính khung cảnh gia đình; nhờ đó, một khi đã được rèn luyện để giữ đức khiết tịnh, đến tuổi thích hợp, họ có thể tiến tới hôn nhân sau khi đã sống đúng đắn giai đoạn đính hôn[3].”

Thời gian đính hôn là thời gian quý báu giúp đôi bạn có thêm cơ hội thích hợp để tìm hiểu nhau và gia đình của nhau, chứng tỏ cho nhau về tình yêu của mình, và xem thử những tình cảm ban đầu có thể trở thành tình yêu vợ chồng suốt đời không.

Thời gian đính hôn dài hay ngắn là tùy theo mức độ hiểu biết của đôi bạn về hôn nhân và gia đình, và tùy theo đôi bạn có tâm đầu ý hợp không. Nói chung, không nên vội vàng, hấp tấp; cũng không nên kéo dài quá lâu.

---

## 4. Sống thời kỳ đính hôn như thế nào?

Để cuộc hôn nhân được tốt đẹp và hạnh phúc, việc quan trọng trước hết cần phải làm trong thời gian đính hôn là gia tăng cầu nguyện, lắng nghe ý Chúa, xin Chúa Thánh Thần soi sáng hướng dẫn để mình có thể tìm hiểu và chọn lựa đúng đắn.

Cần học giáo lý hôn nhân để hiểu rõ về ý nghĩa, mục đích của bí tích hôn phối cũng như những đòi hỏi của bậc sống hôn nhân và gia đình.

Đôi bạn cần tìm hiểu nhau và gia đình của nhau để xem có hợp với nhau hay không; đồng thời cần giúp nhau sửa đổi những thiếu sót, khuyết điểm trong tinh thần khiêm tốn và biết phục thiện.

Đôi bạn cũng cần trao đổi với nhau về những vấn đề quan trọng, chẳng hạn vấn đề sinh sản và giáo dục con cái, công việc làm ăn, sử dụng tiền bạc, sống đạo, làm việc tông đồ… Bởi vì, sau khi kết hôn mà không nhất trí được với nhau về những vấn đề quan trọng, hoặc phát hiện ra những chuyện tình cảm của quá khứ bị giấu giếm, thì hạnh phúc có nguy cơ bị đổ vỡ.

Đặc biệt đôi bạn cần chứng tỏ cho nhau một tình yêu chân thành, trong sáng và chung thủy. Trong thời gian thử thách này, họ phải biết tự chủ, tự trọng và tôn trọng lẫn nhau, tập chung thủy và hy vọng được đón nhận nhau như quà tặng của Thiên Chúa. Họ sẽ dành những hành động biểu lộ tình yêu vợ chồng cho thời gian sau ngày thành hôn. Họ phải giúp nhau sống khiết tịnh bằng một quyết tâm dứt khoát, can đảm từ chối mọi nhượng bộ dù rất nhỏ mọn và xa tránh những hoàn cảnh dễ đưa đến vấp ngã[4].

Món quà tuyệt vời nhất đôi bạn có thể dành cho nhau trong ngày cưới chính là giúp nhau giữ được sự trong trắng của thời kỳ đính hôn. Những phim ảnh và sách báo lệch lạc đã khiến nhiều bạn trẻ nghĩ rằng không thể giữ được sự khiết tịnh và dễ buông theo bản năng. Thế nhưng, nếu có can đảm tự chủ trong những điều nhỏ mọn, họ có thể vượt thắng cám dỗ. Cụ thể là họ cần phải làm chủ đôi mắt, xúc giác và trí tưởng tượng.

Cách riêng, họ phải luôn sống trước nhan thánh Chúa trong tâm tình kính sợ, tin cậy và yêu mến. Tự sức riêng, họ thật yếu đuối nhưng Chúa luôn mạnh mẽ. Do đó, họ cần bám víu vào ơn Chúa bằng kinh nguyện. Nên nhớ rằng thời kỳ đính hôn là thời gian rất cần ơn Chúa để sự chuẩn bị mọi mặt được chu đáo. Từ đó, đôi bạn sẽ cố gắng hết sức để luôn giữ mình trong tình trạng đẹp lòng Chúa và được Ngài chúc phúc. Nếu lỡ sa ngã vì yếu đuối, họ cần mau mắn lãnh nhận bí tích tha thứ. Cả hai bên đều phải ý thức và giúp nhau đứng vững, vì hạnh phúc lâu bền của cả hai người.

Thời kỳ đính hôn vừa giúp đôi bạn chuẩn bị bước vào cuộc sống mới vừa giúp họ suy nghĩ cân nhắc thật kỹ lưỡng trước sự quyết định quan trọng cho cả một đời. Bao lâu chưa cử hành bí tích Hôn phối, họ vẫn còn có thể chia tay trong bình an.

---

## 📌 GHI NHỚ :

### 1. H. Tại sao phải có thời kỳ đính hôn?

T. Phải có thời kỳ đính hôn:  
– Một là vì hôn nhân là việc rất quan trọng, ảnh hưởng đến hạnh phúc cả cuộc đời.  
– Hai là vì đôi bạn cần có thời gian để tìm hiểu về ý nghĩa, mục đích và những đòi hỏi của hôn nhân và gia đình Kitô giáo.  
– Ba là vì đôi bạn cần có cơ hội để tìm hiểu về bản thân và gia đình của nhau để xem có hợp với nhau hay không.

### 2. H. Phải sống thời kỳ đính hôn như thế nào?

T. Trong thời kỳ đính hôn, đôi bạn cần gia tăng cầu nguyện, tích cực học hỏi về đời sống hôn nhân và gia đình, chứng tỏ cho nhau một tình yêu chân thành, trong sạch và chung thủy.

---

## 🤔 GỢI Ý SUY NGHĨ:

1. Người Nga có câu: “Trước khi ra trận, hãy cầu nguyện một lần; trước khi xuống tàu, hãy cầu nguyện hai lần; trước khi kết hôn, hãy cầu nguyện ba lần.” Anh chị nghĩ gì về câu nói đó?

2. Ngày nay có khá nhiều cuộc hôn nhân bị đổ vỡ. Theo anh chị, đâu là những nguyên nhân chính?

3. Để yêu thương, không phải chỉ muốn là đủ, nhưng còn phải học cách yêu thương. Anh chị nghĩ gì về điều đó?

---

## 🙏 CẦU NGUYỆN:

Lạy Chúa Thánh Thần, Chúa biết rõ tình yêu và thiện chí của chúng con. Chúng con đang sống thời kỳ đính hôn để chuẩn bị bước vào đời sống hôn nhân và gia đình. Chúng con rất cần được Chúa soi sáng và hướng dẫn, hầu biết tận dụng thời gian đính hôn này để học hỏi và tìm hiểu thật chu đáo; nhờ đó cuộc sống hôn nhân và gia đình của chúng con mai sau sẽ được thành công như ý Chúa muốn. Amen
`
},
{
  id: 7,
  title: "Tình yêu vợ chồng",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Tình yêu vợ chồng là sự kết hợp nên một, trao hiến trọn vẹn, chung thủy suốt đời và mở ngỏ cho sự sống, theo khuôn mẫu tình yêu giữa Đức Kitô và Hội Thánh.",
  content: `# 💍 BÀI 7: TÌNH YÊU VỢ CHỒNG

“Giờ đây, lạy Chúa, Chúa biết không phải vì dục tình mà tôi cưới em này làm vợ, song chỉ vì muốn có con cái nối dòng, để danh Chúa được chúc tụng muôn đời”. Sara cũng nguyện rằng: “Lạy Chúa, xin thương xót chúng tôi, xin thương xót chúng tôi, xin cho hai chúng tôi được an khang trường thọ” (Tb 8, 7).

Tình yêu vợ chồng mang tính cách một cam kết quyết liệt. Đôi bạn thời đính hôn cần hiểu rõ tình yêu này, để biết mình đang hướng đến điều gì và phải chuẩn bị tâm hồn nghiêm túc như thế nào? Thật vậy, trong tình yêu vợ chồng, “mình với ta tuy hai mà một”. “Một” ở đây muốn nói lên sự kết hợp mật thiết đến độ không chỉ dừng ở việc ý hợp tâm đầu, mà còn đón nhận và trao ban cho nhau trọn vẹn, trở thành một xương một thịt suốt đời. Trao ban trọn cả con người, đón nhận nhau trọn cả cuộc sống, để trở thành một xương một thịt suốt đời và từ đó làm nảy sinh những sự sống mới. Đây chính là đặc tính của tình yêu vợ chồng.

## 1. Đặc tính của tình yêu vợ chồng

### 1.1. Tình yêu kết hợp nên một

Tình yêu vợ chồng trước hết hướng đến việc kết hợp nên một: “Người đàn ông sẽ lìa bỏ cha mẹ mà kết hợp với vợ mình, và cả hai nên một thân thể” (St 2,24; Mt 19,5; Mc 10,8). 

Trước khi lấy nhau, họ là hai thế giới khác biệt với những vấn đề, những khát vọng, những niềm vui, nỗi buồn riêng tư. Giờ đây, khi đã lấy nhau, hai thế giới đó được hoà trộn vào nhau, thành một xương một thịt và một tâm hồn, chia sẻ một vận mệnh và một cuộc sống. Sự kết hợp đó sâu xa đến nỗi chỉ cái chết mới có thể chia lìa. Chính vì vậy, tình yêu hôn nhân đòi hỏi sự đơn nhất và bất khả phân ly.

### 1.2. Tình yêu trao hiến trọn vẹn

Nhờ khả năng tính dục, người nam và người nữ hiến thân cho nhau qua những hành vi ân ái dành riêng cho vợ chồng. Tính dục không chỉ là hành vi sinh lý, mà còn liên can đến những điều thâm sâu nhất của nhân vị.

Những hành vi thực hiện sự kết hợp thân mật và thanh khiết của đôi vợ chồng đều cao quý và chính đáng. Chúng biểu hiện và khích lệ sự hiến thân cho nhau, nhờ đó hai người làm cho nhau thêm phong phú trong hoan lạc và biết ơn.

Sự trao hiến trọn vẹn toàn thể con người dẫn đôi bạn đến sự kết hợp mật thiết với nhau thành một trái tim, một tâm hồn, một cuộc sống. Nhờ sự kết hợp nên một và trao hiến trọn vẹn của vợ chồng, hai mục đích của hôn nhân được thực hiện: lợi ích của chính đôi vợ chồng và lưu truyền sự sống.

### 1.3. Tình yêu chung thủy

Tình yêu hôn nhân đòi hỏi hai vợ chồng phải dứt khoát, không được tạm bợ, nghĩa là phải luôn chung thuỷ với nhau, bởi vì do giao ước hôn nhân, họ không còn là hai, nhưng đã trở thành một thân thể duy nhất.

Thiên Chúa đã yêu thương chúng ta bằng một tình yêu vĩnh viễn không lay chuyển. Tình yêu vợ chồng được tham dự vào tình yêu này và được tình yêu này hướng dẫn và nâng đỡ. Nhờ chung thủy với nhau, vợ chồng trở thành chứng nhân cho tình yêu trung tín của Thiên Chúa.

### 1.4. Tình yêu mở ngỏ cho sự sống

Truyền sinh vừa là một ân huệ, vừa là một mục tiêu căn bản của hôn nhân, vì tự bản chất, tình yêu vợ chồng hướng tới việc sinh sản con cái. Con cái là hoa quả của tình yêu vợ chồng.

Hội Thánh luôn nhắc rằng hành vi ân ái mang hai giá trị bất khả phân ly: kết hợp và truyền sinh. Trong khi thi hành bổn phận truyền sinh và giáo dục, đôi vợ chồng biết rằng mình cộng tác với tình yêu của Thiên Chúa và trở thành như những người diễn đạt tình yêu của Ngài.

Một khía cạnh đặc biệt của trách nhiệm là điều hòa sinh sản. Khi có lý do chính đáng, đôi vợ chồng có quyền kéo dài khoảng cách giữa những lần sinh con, nhưng phải theo những tiêu chuẩn khách quan của luân lý.

## 2. Nhiệm vụ vợ chồng

### 2.1. Nhiệm vụ của người chồng

Trong gia đình, người nam được mời gọi sống sự tự hiến của mình trong vai trò là chồng và là cha.

Người chồng phải thực sự tôn trọng phẩm giá của người vợ, yêu thương vợ như Đức Kitô đã yêu thương Hội Thánh. Đối với vợ, người chồng phải trở nên người bạn đời và người bạn đạo.

Tình yêu đối với vợ và con cái giúp người chồng hiểu và thể hiện tư cách làm cha. Sự hiện diện tích cực, yêu thương và trách nhiệm của người cha là điều không thể thay thế trong gia đình.

Người chồng cần quảng đại lãnh lấy trách nhiệm đối với sự sống, cùng vợ giáo dục con cái, xây dựng gia đình hiệp nhất và ổn định, trở thành chứng tá sống động của đời sống Kitô hữu.

### 2.2. Nhiệm vụ của người vợ

Người nữ được mời gọi sống sự tự hiến trong vai trò là vợ và là mẹ. Người vợ bình đẳng với người chồng về phẩm giá và trách nhiệm.

Vai trò làm mẹ và làm nội trợ có giá trị lớn lao. Đồng thời, người nữ cũng có thể dấn thân vào các vai trò xã hội, tùy hoàn cảnh và khả năng, miễn là vẫn bảo đảm sự hiệp nhất và hạnh phúc gia đình.

Nam giới cần biết trân trọng và yêu thương người phụ nữ với tất cả sự tôn trọng phẩm giá cá nhân của họ.

Tại tiệc cưới Cana (Ga 2,1-12), khi rượu đã hết, Đức Kitô đã biến nước thành rượu ngon. Hình ảnh đó nhắc rằng trong những lúc tình yêu tưởng chừng cạn khô, Đức Kitô vẫn có thể làm cho tình yêu vợ chồng trở nên dồi dào và tươi mới.

Trong đời sống hôn nhân và gia đình, đôi vợ chồng Công giáo được mời gọi noi gương Đức Kitô và Hội Thánh để sống yêu thương, tôn trọng, tha thứ và hy sinh cho nhau.

---

## 📌 GHI NHỚ

**1. H. Tình yêu vợ chồng có những đặc tính nào?**  
T. Tình yêu vợ chồng có những đặc tính này là:  
– Một là kết hợp nên một.  
– Hai là trao hiến trọn vẹn.  
– Ba là chung thủy suốt đời.  
– Bốn là đón nhận con cái.

**2. H. Vợ chồng có những bổn phận nào?**  
T. Người nam được mời gọi chu toàn bổn phận làm chồng và làm cha; người nữ được mời gọi chu toàn bổn phận làm vợ và làm mẹ.

**3. H. Khuôn mẫu của tình yêu vợ chồng là gì?**  
T. Khuôn mẫu của tình yêu vợ chồng chính là sự kết hợp giữa Đức Kitô và Hội Thánh.

---

## 💬 GỢI Ý SUY NGHĨ

1. Nếu trong cuộc sống hôn nhân, cả hai vợ chồng đều cố gắng sống tinh thần hiến thân, tha thứ và yêu thương vô vị lợi, gia đình sẽ thay đổi như thế nào?

2. Làm chứng về giá trị bất khả phân ly và lòng chung thủy hôm nay có còn cần thiết không? Vì sao?

---

## 🙏 CẦU NGUYỆN

Lạy Chúa Giêsu, Chúa đã yêu thương Hội Thánh đến nỗi hiến mình vì Hội Thánh. Xin giúp chúng con biết sống thông cảm, nhân hậu, khiêm tốn, hiền hòa và nhẫn nại đối với nhau; biết tha thứ cho nhau như Chúa đã tha thứ cho chúng con. Xin Chúa luôn ở bên chúng con, ban cho chúng con sức mạnh để chúng con có thể bước theo con đường yêu thương của Chúa cho đến cùng. Amen.
`
},
{
  id: 8,
  title: "Tính dục và hôn nhân",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Giáo huấn Công giáo về tính dục trong đời sống hôn nhân, vai trò của tính dục trong tình yêu vợ chồng và các nguyên tắc luân lý cần tuân giữ.",
  content: `# 💞 BÀI 8: TÍNH DỤC VÀ HÔN NHÂN

> “Vợ không có quyền trên thân xác mình, nhưng là chồng; cũng vậy, chồng không có quyền trên thân xác mình, nhưng là vợ...” (1 Cr 7,4-5)

Hôn nhân là giao ước giữa một người nam và một người nữ, tự do và có trách nhiệm, để yêu thương nhau suốt đời, sinh sản và giáo dục con cái. Vì thế, đời sống hôn nhân liên hệ mật thiết đến giới tính, tính dục và tình dục.

Để có cái nhìn đúng đắn, chúng ta cùng tìm hiểu 4 nội dung chính:

---

## I. VẤN ĐỀ TÍNH DỤC

### 1. Giới tính
Giới tính là những đặc điểm phân biệt người nam và người nữ.

### 2. Tính dục
Tính dục là khuynh hướng tự nhiên nơi con người sử dụng giới tính để gặp gỡ, hiểu biết và yêu thương nhau.

### 3. Tình dục
Tình dục là việc người nam và người nữ vận dụng bản năng giới tính để kết hợp với nhau trong tình yêu vợ chồng.

👉 Theo Lời Chúa và giáo huấn Hội Thánh, giới tính và tính dục là ân huệ Thiên Chúa ban để bổ sung cho nhau và hướng tới đời sống hôn nhân gia đình.

---

## II. VAI TRÒ CỦA TÍNH DỤC TRONG TÌNH YÊU VỢ CHỒNG

- Con người gồm xác và hồn, nên hành vi vợ chồng không chỉ là sinh lý mà còn là hành vi yêu thương sâu xa.
- Tính dục là ngôn ngữ của tình yêu.
- Nó giúp vợ chồng trao hiến và đón nhận nhau trọn vẹn suốt đời.

Tính dục chỉ có giá trị đích thực khi đặt trong tình yêu hôn nhân chung thủy và mở ra cho sự sống.

---

## III. TÍNH DỤC PHỤC VỤ TÌNH YÊU

### 1. Đem lại niềm vui chính đáng
Việc vợ chồng trao hiến cho nhau:
- Giúp tăng trưởng tình yêu.
- Nâng đỡ sự chung thủy.
- Tạo sự quân bình tâm lý và sức khỏe.

### 2. Mở ngỏ cho sự sống
Tình yêu vợ chồng không khép kín nơi hai người mà mở ra cho việc cộng tác với Thiên Chúa trong việc sinh thành con cái.

### 3. Xây dựng nền văn minh tình yêu
Khi tính dục được sống đúng ý nghĩa:
- Tôn trọng phẩm giá con người.
- Xây dựng gia đình bền vững.
- Góp phần xây dựng xã hội yêu thương.

---

## IV. CÁC NGUYÊN TẮC LUÂN LÝ TÍNH DỤC

### 1. Hành vi vợ chồng trong hôn nhân là cao quý
- Là dấu hiệu của tình yêu.
- Là dấu hiệu của sự sống.
- Là dấu hiệu của lòng trung tín.

### 2. Tôn trọng thân xác nhưng không thần tượng hóa nó
Thân xác có giá trị, nhưng không phải là tất cả con người. Hành vi tính dục phải phù hợp với luật Thiên Chúa.

### 3. Sống trong sạch và tiết độ
- Khiết tịnh là làm chủ bản thân.
- Trong sạch và tiết độ là biểu hiện của trưởng thành và yêu thương thật sự.

---

## V. NHỮNG LỖI PHẠM ĐẾN ĐỨC KHIẾT TỊNH

Hội Thánh cảnh báo các hành vi xúc phạm đến phẩm giá hôn nhân như:
- Dâm ô
- Thủ dâm
- Tà dâm
- Khiêu dâm
- Mại dâm
- Hiếp dâm
- Đồng tính luyến ái
- Ngoại tình
- Ly dị và tái hôn
- Đa thê
- Loạn luân
- Sống chung không hôn phối
- Hôn nhân thử

Những hành vi này đi ngược lại phẩm giá con người và ý định của Thiên Chúa về hôn nhân.

---

## 📌 GHI NHỚ

**H. Tính dục là gì?**  
**T.** Tính dục là khuynh hướng tự nhiên Thiên Chúa đặt nơi con người để gặp gỡ, yêu thương và hiệp thông với nhau, đặc biệt trong đời sống hôn nhân.

---

🙏 Xin Chúa giúp mỗi đôi bạn biết sống ơn gọi hôn nhân trong sự trong sạch, trung tín và yêu thương trọn vẹn.`
},
{
  id: 9,
  title: "Hòa hợp vợ chồng: Sự khác biệt giữa nam và nữ",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Tìm hiểu sự khác biệt giữa nam và nữ về thể xác, tâm lý, tình cảm và đời sống thiêng liêng, để xây dựng sự hòa hợp, cảm thông và nâng đỡ nhau trong hôn nhân.",
  content: `# 💞 BÀI 9: HÒA HỢP VỢ CHỒNG – SỰ KHÁC BIỆT GIỮA NAM VÀ NỮ

> “Anh em hãy hết lòng khiêm tốn, hiền hậu, nhẫn nại, chịu đựng nhau trong đức ái; hãy lo bảo vệ sự hợp nhất do Thần khí mang lại, lấy bình an hoà thuận làm giây ràng buộc.” (Ep 4,2-3)

Thiên Chúa dựng nên con người có nam có nữ. Tự bản chất, nam và nữ khác biệt nhau không chỉ về vóc dáng bên ngoài, mà còn về tâm tính, cách cảm nhận và hành động.

Giới tính ảnh hưởng trên toàn bộ con người, đặc biệt liên quan đến đời sống tình cảm, khả năng yêu thương, truyền sinh và năng lực thực hiện các mối tương quan hiệp thông với người khác.

Sự hòa hợp của đôi vợ chồng và của xã hội tùy thuộc vào việc hai bên biết bổ túc, đáp ứng và nâng đỡ nhau.

---

## I. NHỮNG KHÁC BIỆT CƠ BẢN GIỮA NAM VÀ NỮ

### 1. Về thể xác
- Nam có cơ bắp to, thích hợp lao động nặng; tập trung sức mạnh nhưng cần nghỉ ngơi sau đó.
- Nữ có cơ bắp nhỏ hơn, bền bỉ; có thể làm liên tục nhiều việc; chịu đựng tốt và tuổi thọ thường cao hơn.

### 2. Về nhận thức
- Nam chú ý điều tổng quát, lý luận theo nguyên tắc, phán đoán khách quan, coi trọng việc làm.
- Nữ chú ý chi tiết, suy nghĩ bằng trực giác, phán đoán theo cảm xúc, coi trọng lời nói.

### 3. Về tình yêu
- Nam coi tình yêu là một điều quan trọng trong nhiều điều quan trọng; chủ động, dễ bị kích động.
- Nữ coi tình yêu là tất cả; sẵn sàng dâng hiến; xúc cảm đến chậm nhưng kéo dài.

### 4. Về tôn giáo và luân lý
- Nam đạo đức có thể kém sốt sắng nhưng bền vững; khó giữ tiết độ.
- Nữ đạo đức nồng nhiệt, tình cảm, nhưng dễ thay đổi; khó giữ bác ái trong lời nói.

---

## II. NĂM ĐỊNH LUẬT TÂM LÝ GIỮA NAM VÀ NỮ

### 1. Luật ưu tiên
- Nam: thể xác ưu tiên.
- Nữ: trái tim ưu tiên.

👉 Anh cần quan tâm, dịu dàng và bảo vệ chị.  
👉 Chị cần chăm sóc vẻ ngoài, sự duyên dáng và quan tâm đời sống gia đình.

---

### 2. Luật phân cách
- Trái tim người nữ: chỉ có một ngăn.
- Trái tim người nam: có nhiều “ngăn” (gia đình, công việc, lý tưởng, giải trí).

👉 Hai người cần tôn trọng và hiểu ưu tiên của nhau để tránh hiểu lầm.

---

### 3. Luật chi tiết
- Nam quan tâm điều cốt yếu.
- Nữ chú trọng chi tiết, kỷ niệm, cảm xúc nhỏ bé.

👉 Cần tế nhị, bỏ qua thiếu sót nhỏ và trân trọng những điều tưởng như rất nhỏ.

---

### 4. Luật bất đồng cảm
- Nam phản ứng nhanh nhưng mau nguội.
- Nữ phản ứng chậm nhưng kéo dài.

👉 Hãy kiên nhẫn, dịu dàng và đừng “đổ thêm dầu vào lửa”.

---

### 5. Luật thính giác
- Nữ thích nghe lời yêu thương.
- Nam ít nói hơn.

👉 Hãy nói lời tích cực, tránh trách móc, biết lắng nghe và khơi gợi đối thoại.

---

## III. BÍ QUYẾT HÒA HỢP TRONG HÔN NHÂN

Tình yêu chân thật:
- Thấy rõ khiếm khuyết nhưng vui vẻ đón nhận.
- Khám phá ưu điểm và khéo léo phát huy.
- Cùng nhau tha thứ và nâng đỡ.

Sống lâu năm, vợ chồng không chỉ giống nhau ở khuôn mặt mà còn giống nhau trong tâm hồn — đó là hoa trái của yêu thương và tha thứ.

> “Nếu ở dưới đất, hai người trong anh em hợp lời cầu xin bất cứ điều gì, thì Cha Thầy… sẽ ban cho.” (Mt 18,19-20)

---

## 📌 GHI NHỚ

**1. H. Giới tính là gì?**  
**T.** Giới tính là tất cả những đặc điểm phân biệt người nam với người nữ.

**2. H. Giới tính ảnh hưởng thế nào?**  
**T.** Ảnh hưởng trên toàn bộ con người, đặc biệt đời sống tình cảm, yêu thương và truyền sinh.

**3. H. Nam và nữ khác nhau thế nào?**  
**T.** Không chỉ khác vóc dáng mà còn khác tâm tính, nhận thức và hành động.

**4. H. Sự khác biệt tâm lý được diễn tả thế nào?**  
**T.** Qua năm định luật: ưu tiên, phân cách, chi tiết, bất đồng cảm, thính giác.

**5. H. Làm sao tạo hòa hợp?**  
**T.** Hiểu rõ khác biệt để cảm thông, chia sẻ và nâng đỡ nhau trong yêu thương.

---

## 🤔 GỢI Ý SUY NGHĨ

1. Tôi cần thay đổi điểm yếu nào của bản thân để đem lại hạnh phúc cho người bạn đời?
2. Làm sao để vừa thấy khuyết điểm của nhau mà vẫn yêu thương và nâng đỡ?
3. Khi gặp thử thách, vợ chồng làm sao trở thành tri kỷ và nguồn an ủi cho nhau?

---

## 🙏 CẦU NGUYỆN

Lạy Chúa, Chúa đã ban cho chúng con giới tính để gặp gỡ, yêu thương và hiệp thông với nhau. Xin giúp chúng con biết làm chủ bản thân và sử dụng ân huệ ấy theo thánh ý Chúa. Amen.`
},
{
  id: 10,
  title: "Hoà hợp vợ chồng: Triển nở trong tình yêu",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Tình yêu vợ chồng cần được vun xới mỗi ngày qua sự tôn trọng, hy sinh, đối thoại, cầu nguyện và làm tròn bổn phận, để ngày càng triển nở bền vững trong ân sủng Thiên Chúa.",
  content: `# 💞 BÀI 10: HOÀ HỢP VỢ CHỒNG – TRIỂN NỞ TRONG TÌNH YÊU

> “Lòng mến tha thứ tất cả, tin tưởng tất cả, hy vọng tất cả, chịu đựng tất cả” (1 Cr 13,7).

Với lời cam kết trong ngày thành hôn, đôi bạn chính thức trở thành vợ chồng và bước vào đời sống hôn nhân – một hành trình yêu thương, hy sinh và trưởng thành suốt đời.

Gia đình có hạnh phúc hay không tùy thuộc vào việc hai vợ chồng có biết chăm sóc tình yêu thuở ban đầu để tình yêu ấy trở thành ân sâu nghĩa nặng, không bao giờ tàn phai.

---

## I. TÔN TRỌNG NHAU

Yêu thương và tôn trọng phải đi đôi với nhau.

- Nhìn nhận nhau là bạn đời, bình đẳng trong phẩm giá vì đều là hình ảnh Thiên Chúa.
- Đón nhận nhau trọn vẹn với ưu điểm và khuyết điểm.
- Tôn trọng trong lời nói, cách cư xử, nhất là khi gian nan, bệnh tật.
- Tránh lời nói thô lỗ, xúc phạm hoặc nói xấu nhau.
- Giữ “tương kính như tân”.

---

## II. HY SINH CHO NHAU

> “Không có tình thương nào cao cả hơn tình thương của người đã hy sinh tính mạng vì bạn hữu” (Ga 15,13).

- Yêu thật là biết hy sinh, quên mình.
- Trung thành trong lúc thịnh vượng cũng như gian nan.
- Xây dựng hạnh phúc bằng những hy sinh nhỏ hằng ngày.
- “Một nhịn chín lành” khi có bất đồng.
- Biết tha thứ như Chúa đã tha thứ.

Hy sinh không phải là đồng lõa với điều xấu, nhưng là cùng nhau hướng về điều thiện.

---

## III. ĐỐI THOẠI VỚI NHAU

Đối thoại là nói và nghe bằng cả trí óc lẫn con tim.

- Chia sẻ suy nghĩ, ước muốn.
- Bàn bạc các quyết định quan trọng.
- Tôn trọng ý kiến của nhau.
- Không độc đoán, áp đặt.

“Thuận vợ thuận chồng tát bể Đông cũng cạn.”

---

## IV. DÀNH THỜI GIỜ CHO NHAU

Tình yêu cần sự hiện diện.

- Ưu tiên thời gian cho nhau.
- Chuyện trò, tâm sự, chia sẻ niềm vui nỗi buồn.
- Nâng đỡ, an ủi và khích lệ nhau.

Nhiều gia đình đổ vỡ vì thiếu thời gian dành cho nhau.

---

## V. NÓI VỚI NHAU NHỮNG LỜI ÂU YẾM

Tình yêu cần được diễn tả mỗi ngày.

- Những lời đơn sơ như: “Anh yêu em”, “Em yêu anh”.
- Lời biết ơn, khích lệ, xây dựng.
- Cử chỉ ân cần, tế nhị.

Đừng chỉ bày tỏ tình yêu khi cần, nhưng hãy làm điều đó mỗi ngày.

---

## VI. LÀM TRÒN BỔN PHẬN VỢ CHỒNG

> “Chồng hãy làm tròn bổn phận đối với vợ, và vợ đối với chồng cũng vậy” (1 Cr 7,3-5).

- Sự hiệp nhất không chỉ tâm hồn mà cả thân xác.
- Tôn trọng, trao hiến cho nhau.
- Làm cho đời sống vợ chồng luôn phong phú và mới mẻ.
- Học hỏi thêm về tâm sinh lý để hiểu nhau hơn.

---

## VII. CẦU NGUYỆN VỚI NHAU VÀ CHO NHAU

Thiên Chúa là nguồn mạch của tình yêu.

- Cầu nguyện chung trong gia đình.
- Phó thác mọi biến cố vui buồn cho Chúa.
- Xin Chúa gìn giữ và nâng đỡ.

“Ở đâu có hai ba người họp lại nhân danh Thầy, thì có Thầy ở đấy, giữa họ.” (Mt 18,20)

---

# 📌 GHI NHỚ

**H. Vợ chồng phải làm gì để tình yêu luôn được triển nở?**

**T. Vợ chồng cần phải:**
1. Tôn trọng lẫn nhau.  
2. Hy sinh cho nhau.  
3. Đối thoại và chia sẻ tâm tình.  
4. Dành thời giờ cho nhau.  
5. Nói với nhau những lời âu yếm.  
6. Làm tròn bổn phận vợ chồng.  
7. Cầu nguyện với nhau và cho nhau.

---

# 🤔 GỢI Ý SUY NGHĨ

1. Vì sao Thiên Chúa dựng nên người nam và người nữ khác biệt mà lại mời gọi họ sống chung với nhau?
2. Đâu là yếu tố quan trọng nhất giúp tình yêu của anh chị được triển nở?

---

# 🙏 CẦU NGUYỆN

Lạy Chúa, qua Bí tích Hôn phối, Chúa đã kết hợp hai người nam và nữ thành một gia đình duy nhất và bền vững. Xin giúp chúng con biết từ bỏ ý riêng, sửa đổi tính hư tật xấu, để cùng nhau xây dựng gia đình ngày càng triển nở trong tình yêu của Chúa. Amen.
`
},
{
  id: 11,
  title: "Hoà hợp vợ chồng: Giải quyết những xung đột",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Xung đột trong đời sống hôn nhân là điều khó tránh, nhưng nếu biết tự chủ, đối thoại, chấp nhận khuyết điểm và cầu nguyện chung, vợ chồng sẽ biến mâu thuẫn thành cơ hội giúp tình yêu trưởng thành và bền vững hơn.",
  content: `
“Chúa Giêsu giáng sinh trong hoàn cảnh sau đây: Mẹ Ngài là Maria đính hôn với Giuse, trước khi về chung sống với nhau, đã thụ thai bởi phép Chúa Thánh Thần. Giuse, bạn của bà là người công chính, không muốn tố cáo bà, định tâm lìa bỏ bà cách kín đáo.” (Mt 1, 18-19)

Cuộc sống gia đình không phải lúc nào cũng êm ả. Có những lúc hạnh phúc tràn đầy, nhưng cũng có những khi bất hoà, cơm chẳng lành, canh chẳng ngọt. Ngay cả Thánh gia cũng từng trải qua thử thách. Vì thế, xung đột không phải là dấu chấm hết của tình yêu, nhưng có thể trở thành cơ hội để hai người hiểu nhau hơn và trưởng thành hơn.

1. Những nguyên nhân gây xung đột
– Khác biệt tâm sinh lý giữa nam và nữ.
– Khác biệt về cá tính, tính cách.
– Khác biệt về quan điểm sống, bậc thang giá trị.
– Khác biệt về nền giáo dục.
– Trục trặc trong đời sống vợ chồng.
– Những yếu đuối, lầm lỗi và thói quen xấu.
– Thiếu tổ chức, thiếu chia sẻ trong gia đình.
– Bất đồng trong quản lý tài chính.
– Bất đồng trong giáo dục con cái.
– Bất đồng trong cách cư xử với họ hàng hai bên.

Những xung đột này nếu không được giải quyết có thể dẫn đến lạnh nhạt, đổ vỡ, thậm chí ly thân, ly dị.

2. Nguyên tắc giúp giải quyết xung đột

2.1. Phòng ngừa:
– Tìm hiểu kỹ trước khi kết hôn.
– Trang bị kiến thức nuôi dưỡng tình yêu.
– Không ngừng hoàn thiện bản thân.

2.2. Khi xảy ra xung đột:

* Thái độ cần có:
– Tự chủ, tránh nóng nảy.
– Có thiện chí muốn giải quyết, không hơn thua.

* Phương cách thực hiện:
– Đối thoại chân thành, biết lắng nghe.
– Không nhắc lại chuyện cũ, không bới móc.
– Can đảm nhận lỗi và sửa đổi.
– Chủ động làm hoà, hàn gắn.
– Nhờ người trung gian khôn ngoan khi cần.
– Cầu nguyện chung để tìm ý Chúa và giữ bình an.

Giải quyết xung đột là hành trình đòi hỏi sự cố gắng của cả hai. Nếu ngay từ đầu biết tập thói quen ngồi lại với nhau để giải quyết những chuyện nhỏ, thì sau này sẽ đủ kinh nghiệm vượt qua những thử thách lớn hơn. Chính trong những lần va chạm đó, tình yêu được thanh luyện và trưởng thành hơn.
`
},
{
  id: 12,
  title: "Sự phân ly vợ chồng",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Giáo Hội trung thành với giáo huấn của Đức Kitô về tính bất khả phân ly của hôn nhân, đồng thời mục vụ đồng hành với những gia đình đang sống trong hoàn cảnh ly thân, ly dị hay tái hôn.",
  content: `
“Còn những ai đã kết hôn, thì tôi truyền – thật ra không phải tôi, mà là Chúa – là vợ không được bỏ chồng, và giả như đã bỏ chồng thì phải ở độc thân, hay phải làm hòa với chồng; và chồng cũng không được rẫy vợ.” (1 Cr 7,10-11)

Hội Thánh luôn quan tâm đến đời sống cụ thể của các gia đình: khi họ hạnh phúc, Hội Thánh vui mừng; khi họ tan vỡ, Hội Thánh đau xót và tìm cách nâng đỡ, hàn gắn. Dựa trên giáo luật, chúng ta tìm hiểu về những trường hợp phân ly trong hôn nhân.

1. Những trường hợp Hội Thánh có thể tháo gỡ dây hôn phối

1.1. Trường hợp không thể tháo gỡ:
Giữa hai người đã lãnh nhận bí tích Rửa tội, nếu hôn nhân đã thành sự và hoàn hợp thì không thể bị tháo gỡ bởi bất cứ quyền lực nhân loại nào, ngoại trừ cái chết.

Hôn nhân trọn vẹn là:
– Đã thành sự.
– Là bí tích.
– Đã ăn ở với nhau.

Nếu thiếu một trong ba điều trên thì là hôn nhân không trọn vẹn.

1.2. Trường hợp có thể tháo gỡ:
Hội Thánh có quyền tháo gỡ những hôn nhân không trọn vẹn trong các trường hợp:
– Hôn nhân đã thành sự nhưng chưa ăn ở với nhau.
– Hôn nhân giữa hai người chưa rửa tội, sau đó một người trở lại đạo và người kia không muốn chung sống (đặc ân thánh Phaolô).
– Hôn nhân vốn không thành sự ngay từ đầu vì mắc ngăn trở.

2. Ly thân

Hội Thánh không cho phép ly dị, nhưng trong một số hoàn cảnh đặc biệt có thể cho ly thân, ví dụ:
– Ngoại tình.
– Gây nguy hiểm nghiêm trọng về tinh thần hay thể xác.
– Làm cho đời sống chung không thể chịu đựng được.

Ly thân nghĩa là không còn chung sống, nhưng vẫn là vợ chồng trước mặt Thiên Chúa. Vì thế, họ không được tự do kết hôn với người khác khi người phối ngẫu còn sống.

3. Vấn đề ly dị

Dù luật đời cho phép ly dị, Hội Thánh trung thành với lời Đức Kitô dạy nên không chấp nhận việc ly dị nếu hôn nhân đã thành sự và hoàn hợp. Hội Thánh cũng không công nhận liên kết mới là thành sự.

4. Tái hôn sau khi ly dị

Những người ly dị và tái hôn theo luật đời ở trong tình trạng khách quan đi ngược luật Chúa. Vì vậy, họ không được rước lễ và không thể đảm nhận một số trách nhiệm trong Hội Thánh, bao lâu còn sống trong tình trạng đó.

Tuy nhiên, Hội Thánh không loại trừ họ, nhưng mời gọi:
– Lắng nghe Lời Chúa.
– Tham dự Thánh lễ.
– Cầu nguyện.
– Làm việc bác ái.
– Giáo dục con cái trong đức tin.
– Hoán cải và sống theo tinh thần Tin Mừng.

GHI NHỚ:

1. Hôn nhân trọn vẹn là hôn nhân đã thành sự, là bí tích và đã ăn ở với nhau.
2. Hội Thánh không có quyền tháo gỡ hôn nhân trọn vẹn.
3. Hội Thánh có quyền tháo gỡ hôn nhân không trọn vẹn trong một số trường hợp.
4. Ly thân là không còn chung sống nhưng vẫn là vợ chồng.
5. Người ly thân không được kết hôn với người khác.
6. Hội Thánh không chấp nhận ly dị và không công nhận hôn nhân mới là thành sự.
7. Hội Thánh vẫn ân cần đồng hành và mời gọi hoán cải.

CẦU NGUYỆN:

Lạy Chúa, Chúa đã mời gọi chúng con sống giao ước tình yêu qua đời sống hôn nhân và gia đình. Xin ban Thánh Thần Tình Yêu đến để chữa lành những rạn nứt, củng cố sự trung thành và giúp các gia đình sống hiệp nhất trong ân sủng của Chúa. Amen.
`
},
{
  id: 13,
  title: "Gia đình là Hội Thánh tại gia",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Gia đình Kitô hữu được gọi là Hội Thánh tại gia vì tham dự vào sự sống và sứ mạng của Hội Thánh: sống hiệp thông Ba Ngôi, đón nhận và thông truyền ơn cứu độ, trở nên cộng đồng tin, cầu nguyện và phục vụ con người.",
  content: `Phần hai: Gia đình là Hội Thánh tại gia – Bài 13: Gia đình là Hội Thánh tại gia

“Anh em là dòng giống được tuyển chọn, là hàng tư tế vương giả, là dân tộc thánh thiện, dân riêng của Chúa, để rao giảng quyền năng của Đấng đã gọi anh em ra khỏi tối tăm mà vào ánh sáng kỳ diệu của Người.” (1Pr 2, 9).

Ngay từ đầu, Hội Thánh thường được hình thành từ những người “cùng với cả gia đình” trở thành tín hữu[1]. Khi theo Đạo, họ ao ước cho “cả nhà” được ơn cứu độ[2]. Những gia đình tín hữu này là những hòn đảo nhỏ mang sự sống Kitô giữa một thế giới ngoại giáo, và mỗi gia đình đã thực sự là một Hội Thánh tại gia.

1. Gia đình là Hội Thánh tại gia
Ngày nay, chúng ta đang sống trong một thế giới xa lạ và đôi khi thù nghịch với đức tin. Gia đình tín hữu có vai trò quan trọng nhất, vì là những ngọn đuốc đức tin sống động và chiếu sáng. Trong gia đình như một Hội Thánh nhỏ, ước gì cha mẹ là những người đầu tiên dùng gương lành và lời nói mà truyền dạy đức tin cho con cái, cũng như cổ võ ơn gọi riêng của từng đứa con và đặc biệt chăm sóc đến ơn gọi linh mục[3].

Gia đình là nơi thể hiện đặc biệt chức tư tế cộng đồng của người cha, người mẹ, con cái và mọi phần tử trong gia đình, nhờ lãnh nhận các bí tích, nhờ kinh nguyện, tạ ơn và chứng từ đời sống thánh thiện, hy sinh và đức ái hữu hiệu. Gia đình là trường học đầu tiên về đời sống Kitô giáo, và là một trường học phát triển nhân tính. Chính trong gia đình, người ta học biết làm việc với sự nhẫn nại và vui thích, học biết tình bác ái huynh đệ, sự quảng đại tha thứ, nhất là sự phụng thờ Thiên Chúa qua kinh nguyện và hy lễ đời sống[4].

2. Gia đình tham dự vào cuộc sống của Hội Thánh
Cũng như Hội Thánh, gia đình Kitô hữu được mời gọi:
– Sống mầu nhiệm hiệp thông của Chúa Ba Ngôi.
– Đón nhận và thông truyền ơn cứu rỗi.

2.1. Sống mầu nhiệm hiệp thông của Chúa Ba Ngôi
Nơi Thiên Chúa Ba Ngôi, Thánh Thần là tình yêu của Chúa Cha và Chúa Con, phát xuất từ Chúa Cha và Chúa Con. Còn nơi gia đình nhân loại, người con là kết quả của tình yêu giữa cha và mẹ. Sự so sánh không nhằm nói đến sự song song và tương ứng về quan hệ giữa các ngôi vị, nhưng nhằm nói đến sự tương tự về tình yêu thương hiệp nhất. Nơi mầu nhiệm Thiên Chúa, ba ngôi vị thần linh phân biệt với nhau, ngôi này không phải là ngôi kia, nhưng lại không hề tách rời nhau, mà chỉ là một Thiên Chúa duy nhất. Mầu nhiệm ấy là nguồn gốc và mẫu mực cho các gia đình[5].

2.2. Đón nhận và thông truyền ơn cứu rỗi
“Trước hết chính Mẹ Hội Thánh sinh ra, giáo dục, xây dựng gia đình Kitô hữu, bằng cách thực hiện cho nó sứ mạng mà Hội Thánh đã nhận được từ nơi Chúa mình. Khi loan báo Lời Chúa, Hội Thánh mặc khải cho gia đình Kitô hữu chân tính của nó, nói khác đi, cho biết gia đình là gì và phải trở nên thế nào theo ý định của Thiên Chúa. Khi cử hành bí tích, Hội Thánh làm phong phú và củng cố gia đình Kitô hữu với ơn của Đức Kitô để thánh hoá nó mà tôn vinh Chúa Cha. Khi canh tân lại lời công bố giới răn mới về đức ái, Hội Thánh làm sinh động và hướng dẫn gia đình Kitô hữu vào việc phục vụ tình yêu, để giúp nó bắt chước và sống lại chính tình yêu hiến mình và hy sinh mà Chúa Giêsu đã dành cho toàn thể nhân loại.

Đến lượt mình, gia đình Kitô hữu cũng hoà nhập vào trong mầu nhiệm Hội Thánh đến độ được dự phần vào sứ mạng cứu rỗi đặc biệt của Hội thánh theo cách riêng của mình. Nhờ ơn Bí tích Hôn phối “trong bậc sống và trong lãnh vực của họ, đôi bạn và cha mẹ Kitô hữu cũng có được ơn riêng dành cho họ trong lòng dân Thiên Chúa”. Do đó, không những họ “nhận được” tình yêu của Đức Kitô để trở nên một cộng đồng “được cứu rỗi”, mà còn còn được mời gọi truyền đạt cho anh chị em của họ chính tình yêu của Đức Kitô, và như thế, họ trở nên một cộng đồng cứu rỗi người khác.

Gia đình Kitô hữu không những nhận được tình yêu của Đức Kitô để trở nên một cộng đồng được cứu rỗi, mà còn được mời gọi truyền đạt cho các anh chị em khác chính tình yêu của Đức Kitô. Do đó, một đàng gia đình Kitô hữu là hoa quả và dấu chỉ của sự phong phú siêu nhiên của Hội Thánh, nhưng đàng khác nó còn là biểu tượng, chứng tích và san sẻ thiên chức làm mẹ của Hội Thánh[6].”

3. Gia đình tham dự vào sứ mạng của Hội Thánh
Gia đình Kitô hữu được mời gọi góp phần tích cực và có trách nhiệm vào cuộc sống và sứ mạng của Hội Thánh với tư cách là một cộng đồng thân mật của sự sống và tình yêu, một cộng đồng tham dự vào sứ mạng làm vua, tư tế và tiên tri của Đức Kitô và của Hội Thánh Ngài. Chính tình yêu và sự sống kết thành tâm điểm cho sứ mạng cứu độ của gia đình Kitô hữu trong Hội Thánh và vì Hội Thánh.

3.1. Gia đình Kitô hữu, cộng đồng tin và loan báo Tin mừng (sứ mạng tiên tri)
Trước hết, gia đình Kitô hữu sống vai trò tiên tri của mình bằng cách đón nhận Lời Thiên Chúa là Đấng mặc khải cho họ cái mới mẻ kỳ diệu trong đời sống hôn nhân và gia đình. Chỉ trong đức tin họ mới có thể, với một niềm vui sướng và biết ơn, khám phá và thán phục phẩm giá của hôn nhân và gia đình mà Thiên Chúa đã nâng cao, bằng cách lấy đó làm dấu chỉ và môi trường của giao ước yêu thương giữa Thiên Chúa và con người, giữa Đức Kitô và Hội Thánh.

Ngay việc chuẩn bị hôn nhân đã mang tính cách của một hành trình đức tin. Đó là một thời gian đặc biệt giúp cho những người đính hôn tái khám phá và đào sâu về đức tin của mình, để họ có thể đón nhận một cách tự do ơn gọi sống theo gương Đức Kitô và phục vụ Nước Thiên Chúa trong chính bậc sống hôn nhân và gia đình.

Giây phút quyết liệt mà hai người, trong tư cách đôi bạn, bày tỏ đức tin, là lúc họ cử hành bí tích Hôn phối. Do bản chất sâu xa, việc cử hành này là một sự công bố trong Hội Thánh về Tin mừng của tình yêu hôn nhân: Đó là Lời Thiên Chúa mặc khải và hoàn tất dự định đầy khôn ngoan và yêu thương mà Ngài đã có đối với đôi bạn khi dẫn họ tới chỗ tham dự một cách nhiệm mầu và thực sự vào chính tình yêu của Ngài đối với loài người.

Việc tuyên xưng đức tin này đòi hỏi phải được kéo dài suốt cuộc đời của đôi bạn. Trong và qua các sự kiện, các vấn đề, các khó khăn, các biến cố của cuộc sống thường ngày, Thiên Chúa đến với họ và nêu lên cho họ những đòi hỏi cụ thể, để họ dự phần vào tình yêu của Đức Kitô đối với Hội Thánh.

Khám phá ý định của Thiên Chúa và tuân phục ý định ấy là hai việc phải được thực hiện cùng một lúc trong cộng đồng hôn nhân và gia đình, qua kinh nghiệm nhân bản về tình yêu giữa đôi bạn, cũng như giữa cha mẹ và con cái, khi tình yêu ấy được sống trong Thần Khí Đức Kitô.

Tùy mức độ đón nhận Tin mừng và trưởng thành trong đức tin, mà gia đình Kitô hữu trở nên một cộng đồng loan báo Tin mừng. Sứ mạng loan báo Tin mừng này bắt nguồn từ bí tích Rửa tội và nhận được nơi bí tích Hôn phối một sức đẩy mới, để họ có thể truyền đạt đức tin, thánh hóa và biến đổi xã hội theo ý định của Thiên Chúa.

3.2. Gia đình Kitô hữu, cộng đồng đối thoại với Thiên Chúa (sứ mạng tư tế)
Khi chu toàn sứ mạng hôn nhân và gia đình của mình nhờ sức mạnh của bí tích Hôn phối, gia đình Kitô hữu được đổ tràn tinh thần của Đức Kitô, nhờ đó tất cả đời sống của họ thấm nhuần đức tin, đức cậy, đức mến, ngày càng tiến tới sự trọn lành riêng biệt của họ và sự thánh hóa lẫn nhau, cùng nhau góp phần tôn vinh Thiên Chúa. Đó là vai trò tư tế mà gia đình Kitô hữu có thể và phải chu toàn trong sự kết hợp mật thiết với toàn thể Hội Thánh, qua những thực tại hằng ngày của đời sống hôn nhân và gia đình.

Gia đình Kitô hữu cố gắng chu toàn ơn gọi và vai trò tư tế của mình không những bằng việc cử hành Thánh Thể và các bí tích khác hoặc bằng việc hiến dâng chính mình cho vinh quang Thiên Chúa, nhưng còn bằng đời sống cầu nguyện, tức là đối thoại bằng kinh nguyện với Chúa Cha nhờ Đức Kitô và trong Chúa Thánh Thần.

Kinh nguyện không phải là một sự chạy trốn các trách nhiệm thường ngày, nhưng chính là sức đẩy thôi thúc các gia đình Kitô hữu đến chỗ đảm nhận các trách nhiệm làm tế bào đầu tiên và căn bản của xã hội nhân loại và chu toàn đầy đủ các trách nhiệm ấy. Theo nghĩa đó, việc gia đình Kitô hữu tham dự vào cuộc sống và sứ mạng của Hội Thánh sẽ biến chuyển theo tỷ lệ của sự cầu nguyện trung thành và sâu đậm, nhờ đó gia đình Kitô hữu được kết hợp với cây nho sai trái là Đức Kitô.

3.3. Gia đình Kitô hữu, một cộng đồng phục vụ con người (sứ mạng vương đế)
Hội Thánh có sứ mạng hướng tất cả mọi người tới chỗ đón nhận Lời Thiên Chúa trong đức tin, cử hành và công bố đức tin ấy trong các bí tích và kinh nguyện, sau cùng diễn tả đức tin ấy qua những thực tại cụ thể của đời sống phù hợp với giới răn mới về tình yêu. Cũng vậy, gia đình Kitô hữu được Luật mới của Thánh Thần linh hoạt và hướng dẫn, và được mời gọi sống tình yêu phục vụ đối với Thiên Chúa và tha nhân trong sự hiệp thông mật thiết với Hội Thánh là dân tộc vương giả.

Tinh thần và thái độ phục vụ của gia đình Kitô hữu được thực hiện trước hết giữa đôi bạn và gia đình của họ, rồi được mở rộng cho cộng đồng Hội Thánh, và sau cùng phải vượt qua phạm vi những anh em cùng đức tin, bởi vì “mọi người đều là anh em của tôi”. Đó là một tình bác ái biết nhận ra nơi mỗi người khuôn mặt của Đức Kitô và là một người anh em mà mình phải yêu mến và phục vụ, nhất là khi họ nghèo túng, yếu đuối, đau khổ hoặc bị đối xử bất công.

Để có thể đào tạo những con người biết yêu thương và sống yêu thương trong mọi tương quan với người khác, gia đình Kitô hữu sẽ không tự khép kín, nhưng mở ra cho cộng đồng, hướng tới cộng đồng nhờ ý thức về công lý và nhờ sự quan tâm lo lắng cho người khác, cũng như nhờ bổn phận trong trách nhiệm riêng của gia đình đối với toàn thể xã hội.

Hội Thánh vừa thánh thiện lại vừa gồm những con người bất toàn đang lần bước trên trần thế. Giữa lúc văn hoá tiêu thụ phát triển nhanh đến chóng mặt, khiến nhiều giá trị truyền thống bị sụp đổ, nhiều gia đình đã tan vỡ và nhiều Kitô hữu cũng bị biến chất, gây nên biết bao gương xấu, làm méo mó gương mặt Hội Thánh, làm cho nhiều người phải nản lòng. Tuy nhiên tình thương và quyền năng của Thiên Chúa vẫn mãi mãi còn đó để cho ta tin cậy. Nỗ lực sống tốt lành của một gia đình Kitô hữu có vẻ như chẳng nghĩa lý gì giữa cơn lốc suy đồi đang ào ào thổi đến, nhưng thật ra nó sẽ là hạt men. Nó có thể đem lại niềm hy vọng cho một vòng đai nhỏ chung quanh nó và sẽ dần dần lan rộng. Rồi đến khi có nhiều gia đình Kitô hữu cùng hoà chung một lời chứng, tiếng nói của họ sẽ âm vang, sẽ đem lại niềm hy vọng cho nhân loại, và mọi người sẽ hiểu đúng bản chất của Hội Thánh. Vậy, “giữa một thế hệ ngang trái và tà vạy, anh em phải chiếu rạng như đuốc sáng trên thế gian” (Pl 2,15).

GHI NHỚ:
1. H. Tại sao gia đình Kitô hữu được gọi là Hội Thánh tại gia?

T. Gia đình Kitô hữu được gọi là Hội Thánh tại gia vì được tham dự vào sự sống và sứ mạng của Hội Thánh.

2. H. Gia đình Kitô hữu tham dự vào sự sống của Hội Thánh như thế nào?

T. Cũng như Hội Thánh, gia đình Kitô hữu được mời gọi sống mầu nhiệm hiệp thông của Thiên Chúa Ba Ngôi, đón nhận và thông truyền ơn cứu rỗi.

3. H. Gia đình Kitô hữu tham dự vào sứ mạng của Hội Thánh như thế nào?

T. Cũng như Hội Thánh, gia đình Kitô hữu được mời gọi trở nên một cộng đồng tin và loan báo Tin mừng, đối thoại với Thiên Chúa và phục vụ con người.

GỢI Ý SUY NGHĨ:
1. Tại sao “Gia đình lại được gọi là Hội Thánh tại gia”? Giữa gia đình và Hội Thánh có liên hệ như thế nào?

2. Hội Thánh một cách cụ thể chính là giáo xứ của anh chị. Anh chị đã tham dự và đóng góp vào đời sống của giáo xứ như thế nào? Đâu là những trở ngại khiến anh chị đứng ngoài lề giáo xứ?

CẦU NGUYỆN:
Lạy Thánh Gia Nadarét, là gương mẫu của đời sống thánh thiện, công bình và yêu thương, xin cho gia đình chúng con trở nên nơi đào tạo nhân đức, trong hiền hòa, phục vụ và cầu nguyện.

Xin cho chúng con biết cố gắng xây dựng gia đình thành nơi an ủi giữa cuộc đời đầy thử thách. Xin cho chúng con biết làm cho mọi người trong gia đình được thăng tiến, để góp phần vào việc phát triển xã hội và cộng tác trong việc xây dựng Giáo hội.

Xin Ba Đấng luôn hiện diện trong gia đình chúng con, khi vui cũng như lúc buồn, khi làm việc cũng như lúc nghỉ ngơi, khi lo âu cũng như lúc hy vọng, khi sinh con cũng như lúc có kẻ qua đời, để dù gặp phải những thăng trầm của cuộc sống, chúng con vẫn luôn chúc tụng Chúa, cho đến ngày được sum họp với Ba Đấng trong Nước Trời. Amen.`
},
{
  id: 14,
  title: "Linh đạo hôn nhân và gia đình",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Nhờ Bí tích Hôn phối, đôi vợ chồng Kitô hữu được mời gọi nên thánh trong đời sống gia đình qua tình yêu sáng tạo, giao ước, thập giá, phục sinh và đời sống bí tích.",
  content: `# 💒 Bài 14: Linh đạo hôn nhân và gia đình
“Ý muốn của Thiên Chúa là anh em nên thánh” (1 Tx 4, 3).

Trong ngày thành hôn, đôi tân hôn nào cũng được cầu chúc: “Trăm năm hạnh phúc”. Một gia đình hạnh phúc, theo truyền thống văn hoá Việt Nam, là một gia đình “trên thuận dưới hoà, con cái hiếu thảo, vợ chồng yêu thương nhau”. Tuy nhiên, đối với người Kitô hữu, một gia đình hạnh phúc còn phải là một gia đình có Chúa Giêsu ở cùng, bởi vì Ngài chính là tình yêu nối kết tất cả gia đình.

“Ơn Đức Giêsu Kitô ban khi cử hành bí tích Hôn phối không bị múc cạn, nhưng vẫn theo sát đôi bạn trong suốt cả đời sống. Công đồng Vaticanô II nhắc lại điều ấy khi nói rằng Đức Giêsu Kitô “còn ở lại với họ để hai vợ chồng cũng mãi mãi trung thành yêu thương nhau bằng sự tự hiến cho nhau như Ngài đã yêu thương Hội Thánh và đã nộp mình vì Hội Thánh…” Khi chu toàn sứ mạng hôn nhân và gia đình của họ với sức mạnh của bí tích này, họ được đổ tràn tinh thần của Đức Kitô, nhờ đó tất cả đời sống của họ thấm nhuần đức tin, đức cậy, đức mến và càng ngày họ càng tiến tới sự trọn lành riêng biệt của họ và sự thánh hoá lẫn nhau; và bởi đó, họ cùng nhau góp phần tôn vinh Thiên Chúa[1]“.

Như vậy, nhờ Bí tích Hôn phối, đôi vợ chồng Kitô hữu nhận được những ơn riêng để sống ơn gọi hôn nhân và gia đình. Những ơn đó giúp họ cùng nhau xây dựng một gia đình hạnh phúc, đồng thời cũng giúp họ nên thánh trong đời sống hôn nhân và gia đình.

## 1. Mọi Kitô hữu được mời gọi nên thánh

### 1.1. Bổn phận nên thánh
Khi chịu phép Rửa tội, người tín hữu không những được rửa sạch mọi tội lỗi mà còn trở nên “một thụ tạo mới” (2 Cr 5,17), thành nghĩa tử của Thiên Chúa (x. Gl 4,5-7), “được thông phần bản tính Thiên Chúa” (2 Pr 1,4), thành chi thể Đức Kitô (x. 1 Cr 6,15; 12,27) và thành đền thờ Chúa Thánh Thần (x. 1 Cr 6,19)[2]. Nói cách khác, nhờ phép Rửa, người Kitô hữu đã chết đối với tội lỗi để sống một cuộc sống mới. Đó là cuộc sống làm con cái Chúa Cha trong Chúa Giêsu Kitô[3], dưới sự hướng dẫn của Chúa Thánh Thần[4]. Bởi vậy, mọi Kitô hữu đều được mời gọi nên thánh: “Anh em hãy sống thánh thiện trong cách ăn nết ở, để nên giống Đấng Thánh đã kêu gọi anh em, vì có lời Kinh Thánh chép: Hãy sống thánh thiện, vì Ta là Đấng Thánh” (1 Pr 1,15-16).

Việc nên thánh không phải chỉ dành riêng cho các linh mục và tu sĩ mà còn dành cho mọi tín hữu. Thánh Phanxicô Salêsiô nói: “Mọi giáo dân đều được mời gọi nên thánh và họ có thể nên thánh như là chồng, là vợ, như là nông dân, là công nhân, là lính, là thương gia, y sĩ, thầy giáo, nghĩa là theo đủ mọi ngành nghề và hoàn cảnh trong xã hội”. Công đồng Vaticanô II nhắc lại: “Tất cả các Kitô hữu, bất kể thuộc bậc sống hay địa vị nào, đều được kêu gọi tiến đến sự viên mãn của đời sống Kitô giáo và đến sự trọn lành của Đức Ái[5]“. “Đạt tới viên mãn của đời sống Kitô giáo và sự trọn lành của Đức Ái”, đó chính là nên thánh[6].

### 1.2. Linh đạo: con đường nên thánh
Trong Hội Thánh, có nhiều bậc sống khác nhau, nên cũng có nhiều con đường nên thánh khác nhau tuỳ theo mỗi bậc sống. Linh mục, tu sĩ có cách nên thánh của linh mục, tu sĩ. Giáo dân cũng có cách nên thánh riêng của mình. Con đường nên thánh dành cho mỗi bậc sống như vậy được gọi là linh đạo. Con đường này do Chúa Thánh Thần khơi dậy, để giúp người tín hữu bước theo Đức Kitô và đạt tới đức ái trọn hảo theo bậc sống của mình.

Từ xưa cho tới nay, Chúa Thánh Thần đã khơi dậy rất nhiều linh đạo khác nhau trong Hội Thánh. Chẳng hạn linh đạo Augustinô, linh đạo Bênêđictô, linh đạo Camêlô, linh đạo Phanxicô, linh đạo Đaminh, linh đạo Inhaxiô, linh đạo Anphongxô, linh đạo Salêdiêng… Tất cả tạo nên sự phong phú và đa dạng trong Hội Thánh, để giúp cho từng người tìm được con đường nên thánh phù hợp với khả năng, hoàn cảnh và bậc sống của mình.

## 2. Linh đạo Hôn nhân và Gia đình

Đối với các đôi vợ chồng, Công đồng Vaticanô II nói: “Nhờ sức thiêng của bí tích Hôn phối, các đôi vợ chồng Kitô hữu biểu hiện và tham dự vào mầu nhiệm hiệp nhất và tình yêu phong phú giữa Đức Kitô và Hội Thánh[7]; họ giúp nhau nên thánh trong đời sống hôn nhân, trong việc đón nhận và giáo dục con cái; nhờ đó, họ nhận được những ơn riêng cho bậc sống của mình trong Dân Chúa. Được ban cho những phương tiện cứu rỗi dồi dào như thế, mọi Kitô hữu, dù ở địa vị nào, bậc sống nào cũng, đều được Chúa kêu gọi đạt tới sự trọn lành thánh thiện như Chúa Cha là Đấng trọn lành, tuỳ theo con đường của mỗi người[8].

Trong Tông huấn Gia đình, Đức Thánh Cha Gioan Phaolô II nhắc lại: “Ơn gọi mọi người nên thánh cũng được ngỏ với các vợ chồng và cha mẹ Kitô hữu. Đối với họ, ơn gọi này được nêu bật trong việc cử hành bí tích Hôn phối và được thực hiện cách cụ thể trong thực tế riêng của cuộc sống hôn nhân và gia đình. Chính cuộc sống này làm nẩy sinh ra ân sủng và đòi hỏi phải có một linh đạo đích thực và sâu xa cho đời sống hôn nhân và gia đình. Linh đạo này được gợi hứng từ các chủ đề về sáng tạo, giao ước, thập giá, phục sinh và dấu hiệu bí tích[9]“.

Nếu linh đạo hôn nhân và gia đình cốt tại Tình yêu, “yêu như Thiên Chúa yêu” và được gọi hứng từ các chủ đề về Sáng tạo, Giao ước, Thập giá, Phục sinh và dấu hiệu bí tích, ta có thể diễn tả những nét chính của linh đạo hôn nhân và gia đình như sau:

### 2.1. Tình yêu sáng tạo
Vì yêu thương, Thiên Chúa đã sáng tạo vũ trụ và muốn cho con người được làm con của Ngài, sống hạnh phúc với Ngài mãi mãi[10]. Thiên Chúa dựng nên con người có nam có nữ, để yêu thương, chia sẻ, bổ túc nhau, đồng thời làm chủ những gì Chúa đã dựng nên. Vì thế, Ngài đã truyền cho họ: “Hãy sinh sản cho đầy mặt đất”(St 1,28).

Qua bí tích Hôn phối, đôi bạn được mời gọi cộng tác vào công trình sáng tạo của Thiên Chúa bằng việc sẵn sàng đón nhận con cái và giáo dục chúng nên người, tạo nên một tổ ấm phục vụ cho sự sống. Mỗi lần trao cho nhau những hành vi âu yếm, mở ngỏ cho sự sống, đôi bạn ý thức mình đang cộng tác vào công trình sáng tạo của Thiên Chúa và nên thánh trong chính nếp sống đó. Khi chiêm ngắm tình yêu dịu dàng Thiên Chúa dành cho dân Israel, đôi vợ chồng biết luôn đổi mới tình yêu của mình qua những cử chỉ, lời nói, việc làm để đem lại hạnh phúc cho nhau và cho con cái. Trong việc giáo dục, cha mẹ ý thức mình là những người cộng tác của Thiên Chúa, nhờ đó không ngã lòng hoặc buông xuôi trước những đứa con bướng bỉnh, ngược lại, biết cậy trông vào ơn Chúa để luôn nhẫn nại, kiên trì và yêu thương.

### 2.2. Tình yêu Giao ước
Thời Cựu Ước, Thiên Chúa đã ký kết giao ước với dân Israel và ban cho họ Mười điều răn để hướng dẫn họ sống trung thành với giao ước. Ngài mời gọi họ: “Nếu các ngươi thực sự nghe tiếng Ta và giữ giao ước của Ta, thì giữa hết mọi dân, các ngươi sẽ là sở hữu riêng của Ta. Ta sẽ coi các ngươi là một vương quốc tư tế, một dân thánh” (Xh 19,5-6).

Thiên Chúa luôn trung thành với giao ước. Dù dân Israel bất trung, bội phản, Thiên Chúa vẫn một mực trung tín, xót thương và tha thứ. “Núi có dời có đổi, đồi có chuyển có lay, tình nghĩa của Ta đối với người vẫn không thay đổi” (Is 54,10). “Ta đã yêu ngươi bằng mối tình muôn thuở, nên Ta vẫn dành cho ngươi lòng xót thương” (Gr 31,3).

Khi cử hành bí tích Hôn phối, đôi bạn trao đổi với nhau lời thề hứa sẽ yêu thương và trung thành với nhau suốt đời: “Tôi là…. nhận (anh / em) làm (chồng / vợ) và hứa giữ lòng chung thuỷ với (anh / em), khi thịnh vượng cũng như lúc gian nan, khi ốm đau cũng như lúc mạnh khoẻ, để yêu thương và tôn trọng (anh / em) suốt đời tôi”.

Ơn bí tích Hôn phối giúp hai vợ chồng nên thánh trong việc sống lời cam kết trên mỗi ngày một trọn vẹn hơn. Khi nỗ lực sống yêu thương và trung thành với nhau, đôi vợ chồng phản ánh tình yêu của Thiên Chúa đối với con người, cũng như tình yêu của Đức Kitô đối với Hội Thánh. Đó là một tình yêu son sắt không đổi thay. Tình yêu đó tạo nên sự hiệp thông thâm sâu giữa vợ chồng với nhau, cũng như giữa cha mẹ và con cái, phản ánh mầu nhiệm hiệp thông trong Hội Thánh.

Thư Mục vụ HĐGM VN năm 1992 cũng viết: “Sống Phúc Âm trong đời sống gia đình chính là sống tình yêu chung thuỷ mà con người đời nào cũng khát khao ca tụng và đã được Chúa Giêsu củng cố bằng bí tích Hôn phối. Chính Chúa Giêsu còn dựa vào sách Sáng thế để tái lập quyền bình đẳng nam nữ và tinh thần bất khả phân ly của hôn nhân (St 2,18-24; Mt 19,6). Trong một xã hội mà đời sống gia đình đang bị đe dọa bởi nạn ly dị và những lối sống trái với luân lý đạo đức Việt Nam, sự trung thành giữa vợ chồng Kitô hữu sẽ là một ánh lửa soi sáng và sưởi ấm, một sự khuyến khích cho các gia đình khác”.

### 2.3. Tình yêu Thập giá
Trong bữa Tiệc ly, Chúa Giêsu nói: “Không có tình yêu nào lớn hơn tình yêu của người thí mạng sống mình vì bạn hữu” (Ga 15,13). Ngài đã dùng cái chết trên thập giá để minh chứng Tình yêu của Thiên Chúa và để đem lại ơn cứu độ cho nhân loại. Con đường thập giá là con đường tình yêu, chấp nhận đau khổ để xoá bỏ tội lỗi và mang lại hạnh phúc cho người mình yêu. Thánh Phaolô đã khuyên nhủ các người làm chồng hãy nhìn vào gương Đức Kitô: “Người làm chồng, hãy yêu thương vợ, như chính Đức Kitô yêu thương Hội Thánh và hiến mình vì Hội Thánh…, để trước mặt Người, có một Hội Thánh xinh đẹp lộng lẫy, không tỳ ố, không vết nhăn hoặc bất cứ một khuyết điểm nào, nhưng thánh thiện và tinh tuyền” (Ep 5,25.27).

Đời sống hôn nhân và gia đình có rất nhiều thập giá: những khuyết điểm và tính xấu của nhau, những va chạm và xung khắc, những thất bại và rủi ro, những khi gặp tai ương và bệnh hoạn, cảnh hiếm muộn cũng như việc chấp nhận từ bỏ ý riêng để sống theo giáo huấn Hội Thánh về việc sinh sản có trách nhiệm v.v…. Đó là những thập giá cần được đón nhận với tình yêu. “Đời sống Kitô hữu mà không qua thập giá thì không thể đạt tới sự phục sinh. Như thế phải hiểu rằng không thể loại bỏ sự hy sinh trong đời sống gia đình, nhưng trái lại phải sẵn sàng đón nhận nó để tình yêu vợ chồng thêm sâu lắng và trở thành nguồn vui thân mật”[11].

Trong đời sống hôn nhân và gia đình, đôi bạn được mời gọi ngước nhìn lên thập giá Đức Kitô để học yêu thương, sống hi sinh, đón nhận nhau và tha thứ cho nhau. “Anh em hãy có lòng thương cảm, nhân hậu, khiêm nhu, hiền hoà và nhẫn nại. Hãy chịu đựng và tha thứ cho nhau, nếu trong anh em người này có điều gì phải trách móc người kia. Chúa đã tha thứ cho anh em, thì anh em cũng vậy, anh em phải tha thứ cho nhau” (Cl 3,12-13).

Chính khi chấp nhận đi theo “con đường hẹp”, từ bỏ mình vác thập giá mình hằng ngày mà bước theo Đức Kitô, đôi vợ chồng cộng tác vào công trình cứu độ cho mình và cho mọi người trong gia đình.

### 2.4. Tình yêu Phục sinh
Đức Kitô phục sinh đã ra khỏi mồ. Ngài đã chiến thắng tội lỗi và sự chết, mang lại sự sống mới cho nhân loại cùng giao hoà tội nhân với Chúa Cha.

Trong đời sống hôn nhân và gia đình, mầu nhiệm Tử nạn và Phục sinh mời gọi đôi bạn luôn canh tân tình yêu của mình, không để những ích kỷ, ghen tương len lỏi vào tình yêu đôi lứa. Phương thế để canh tân tình yêu chính là siêng năng đọc Lời Chúa, cầu nguyện, lãnh nhận các Bí tích, học hỏi thêm những kiến thức bổ ích để nuôi dưỡng tình yêu gia đình.

Ngoài ra, gia đình Kitô hữu còn có sứ mạng truyền giáo, rao giảng Tin Mừng[12]. Gia đình phải cởi mở đón nhận Lời Chúa rồi loan báo cho mọi người. Việc làm chứng trước hết là trong chính gia đình: cha mẹ loan báo Tin Mừng cho con cái bằng lời dạy và gương sáng. Con cái cũng có bổn phận góp phần làm cho cha mẹ nên thánh.

Thư chung của Hội Đồng Giám Mục Việt Nam năm 1980 cũng nói: “Gia đình của anh chị phải trở nên như một trường học về đức tin, một nơi để cầu nguyện, một môi trường sống bác ái yêu thương và rèn luyện tinh thần tông đồ để làm chứng cho Chúa”.

Gia đình Kitô hữu làm tông đồ bằng chứng tá. Nhìn vào gia đình ấy, người ta có thể tự hỏi: “Tại sao họ có thể sống hiệp nhất, yêu thương và trung thành với nhau như thế?”

### 2.5. Tình yêu Bí tích
Nhờ bí tích Hôn phối, gia đình Kitô hữu trở thành dấu chỉ hữu hình của tình yêu Thiên Chúa giữa trần gian.

Cũng như mọi bí tích đều nhằm thánh hoá con người và xây dựng Hội Thánh, Bí tích Hôn phối giúp đôi bạn sống lại chính tình yêu của Thiên Chúa đối với loài người và tình yêu của Đức Kitô đối với Hội Thánh.

Qua lời cam kết chung thủy và việc trao nhẫn cưới, đôi bạn được nhắc nhớ mỗi ngày về giao ước tình yêu của mình. Tuy nhiên, để có thể trung thành với giao ước ấy, gia đình cần không ngừng đối thoại với Thiên Chúa qua cầu nguyện, lắng nghe Lời Chúa và lãnh nhận các Bí tích.

## 3. Noi gương Thánh Gia

Thánh Gia là mẫu gương cho mọi gia đình Kitô hữu. Gia đình Giuse – Maria có Chúa Giêsu ở cùng, sống trong yêu thương, vâng phục và hiệp nhất.

Mỗi gia đình Kitô hữu hôm nay cũng được mời gọi trở thành một “Hội Thánh tại gia”, biết noi gương Thánh Gia để xây dựng cộng đoàn yêu thương, hiệp nhất và mở ra với mọi người.

---

## GHI NHỚ

**H. Nên thánh là gì?**  
T. Nên thánh là sống trọn vẹn tình yêu Thiên Chúa và tha nhân theo ơn gọi của mình, nhờ ơn Chúa và sự cộng tác trung thành mỗi ngày.
`
},
{
  id: 15,
  title: "Các bí tích trong đời sống Hôn nhân và gia đình",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Các bí tích thánh hóa và nuôi dưỡng đời sống hôn nhân gia đình, giúp vợ chồng sống trung tín, yêu thương, giáo dục con cái và xây dựng Hội Thánh trong ân sủng Thiên Chúa.",
  content: `# BÀI 15: CÁC BÍ TÍCH TRONG ĐỜI SỐNG HÔN NHÂN VÀ GIA ĐÌNH

“Các tín hữu chuyên cần tham dự những buổi giáo lý của các tông đồ, hiệp thông huynh đệ, bẻ bánh và cầu nguyện. Hằng ngày họ hợp nhất một lòng một ý cùng nhau ở trong đền thờ, bẻ bánh ở nhà, họ dùng bữa cách vui vẻ đơn sơ.” (Cv 2,42.46)

Đức Kitô đã để lại cho Hội Thánh những bí tích, là những dấu chỉ hữu hình diễn tả và đem lại ơn thánh cho các tín hữu. Các bí tích có mục đích thánh hoá con người, xây dựng thân thể Đức Kitô và thờ phượng Thiên Chúa[1].

Bảy Bí tích liên quan đến các giai đoạn và các thời điểm quan trọng của đời sống người Kitô hữu: Bí tích sinh ra (Rửa tội), lớn lên (Thêm sức, Thánh Thể), chữa lành (Hoà giải, Xức dầu) và lãnh nhận sứ mạng xây dựng cộng đoàn (Truyền chức, Hôn phối). Nhờ lãnh nhận các bí tích, đời sống Kitô hữu được nuôi dưỡng và mỗi ngày một tăng trưởng hơn.

## 1. Hôn phối và Rửa tội

Nhờ bí tích Rửa tội, người Kitô hữu được tái sinh làm con cái Thiên Chúa, làm chi thể Đức Kitô và Đền thờ Chúa Thánh Thần[2]. Họ được tháp nhập vào Hội Thánh là Thân Thể Đức Kitô và là Gia Đình con cái Thiên Chúa. Như vậy, bí tích Rửa tội chính là cánh cửa dẫn vào đời sống hiệp thông: hiệp thông với nhau và Hiệp thông với Thiên Chúa.

Bí tích Hôn phối tăng cường và cụ thể hoá sự hiệp thông mà bí tích Rửa Tội đã đem lại.

### 1.1. Đối với hai vợ chồng:

Nhờ bí tích Hôn phối, đôi bạn được thông phần giao ước tình yêu của Đức Kitô và Hội Thánh: “Bởi thế, người ta sẽ lìa bỏ cha mẹ mình mà kết hợp với vợ mình và cả hai nên một thân xác. Mầu nhiệm này thật lớn lao, tôi muốn nói về Đức Kitô và Hội Thánh” (Ep 5,31-32). Như vậy, lòng trung thành và tình yêu, mà đôi bạn trao cho nhau trong giao ước Hôn nhân, cũng chính là lòng trung thành trong đức tin và đức mến, mà mỗi người đã tuyên hứa khi chịu phép Rửa Tội. Vì thế, khi cùng sống Bí tích Rửa tội, họ cũng thực hiện chính lời giao ước Hôn nhân của mình.

### 1.2. Đối với con cái:

Bí tích Rửa tội rất cần cho được sống đời đời: “Ai không sinh lại bởi nước và Thánh Thần, thì không thể vào được Nước Thiên Chúa” (Ga 3,5). Phép Rửa tha tội tổ tông và cả những tội riêng ta phạm trước đó, ban ơn thánh hoá, sinh ta làm con Thiên Chúa và con Hội Thánh. Do đó, hai vợ chồng cần đặc biệt quan tâm thực hiện việc Rửa tội cho con cái tùy theo các trường hợp sau đây:

a) Trường hợp thông thường:

Khi cháu bé được chừng một tháng, cha mẹ và người đỡ đầu đưa cháu đến nhà thờ xin cha xứ rửa tội cho. Đây là dịp tốt để mọi người ý thức và sống ơn gọi Kitô hữu của mình, nên rất khuyến khích mọi người trong gia đình và trong giáo xứ tham dự. Có thể tổ chức việc mừng “đầy tháng” cho con vào ngày Rửa tội.

b) Trường hợp nguy tử:

Nếu con chưa được rửa tội mà đau nặng, thì cha mẹ cần lo liệu cho con được rửa tội ngay, bằng cách:
– Hoặc chính cha hay mẹ, hoặc nhờ người khác, rửa tội cho con như sau: lấy nước lã đổ trên trán con, vừa đổ vừa đọc: “T. (tên thánh và tên gọi), cha (mẹ) rửa con: nhân danh Cha và Con và Thánh Thần”. Khi làm việc này cần làm theo ý của Hội Thánh.
– Ghi vào sổ gia đình Công giáo và sớm trình cho cha xứ.
– Khi con khỏe lại, nên đưa con tới cha xứ xin lãnh nhận các nghi thức bổ túc.

c) Trường hợp tối khẩn:

– Khi khó sinh: Mọi bào thai phải được rửa tội dù nó được bao nhiêu tháng. Nếu bào thai chắc chắn còn sống, thì rửa tội cách tuyệt đối: “…., cha (mẹ) rửa con: nhân danh Cha và Con và Thánh Thần”.

– Nếu không biết rõ thai còn sống hay chết, thì rửa tội hồ nghi: “…., nếu con còn sống, cha (mẹ) rửa con, nhân danh Cha và Con và Thánh Thần”.

– Khi sẩy thai, thì xé bọc thai rồi đổ nước hoặc dìm vào nước, và đọc: “Nếu thành, ta rửa con, nhân danh Cha và Con và Thánh Thần”.

## 2. Hôn phối và Thêm sức

Bí tích Thêm sức làm cho người tín hữu được đầy ơn Chúa Thánh Thần, để trở nên chứng tá đức tin, có nhiệm vụ bảo vệ và mở mang Nước Chúa.

Khi lãnh Bí tích Hôn phối, đôi bạn trở thành nhân chứng cho tình yêu tự hiến của Đức Kitô và xây dựng Nước Chúa trong chính bậc sống hôn nhân của mình. Những hy sinh, đau khổ và thử thách trong cuộc sống chung, sự giáo dục con cái nên người con Chúa, đều là những công việc quý giá góp phần mở mang Nước Chúa. Chính ơn sức mạnh của Chúa Thánh Thần sẽ giúp đôi bạn chu toàn những nhiệm vụ trên. Nơi Bí tích Hôn phối, “chính Chúa Thánh Thần là dấu ấn hôn ước của hai vợ chồng, là nguồn mạch tình yêu của họ, là sức mạnh giúp họ chung thuỷ[3]“.

Đối với gia đình Kitô hữu, sống bí tích Thêm sức là:
– Quý trọng ơn Chúa Thánh Thần, quan tâm lo cho mọi người trong gia đình lãnh nhận bí tích Thêm sức.
– Liệu cho chính gia đình mình có một kế hoạch truyền giáo, quan tâm thực hiện và thường xuyên kiểm điểm để thực hiện tốt hơn.

## 3. Hôn phối và Hoà giải

Trước khi lãnh bí tích Hôn phối, Hội Thánh khuyên đôi bạn xưng tội để tâm hồn được trong sạch, xứng đáng đón nhận dồi dào ân huệ Chúa ban trong ngày thành hôn.

Suốt quá trình chung sống, đôi bạn sẽ không sao tránh hết mọi khuyết điểm, sai sót. Những sai sót về tình yêu, về lòng trung thành, về đức nhẫn nại… có thể làm họ chán nản. Bấy giờ, Bí tích Hoà giải sẽ xóa đi những lỗi lầm ấy và ban nhiều ơn giúp đôi bạn phấn khởi vững bước trong cuộc sống hôn nhân, với nhiều cố gắng mới. Cũng nhờ Bí tích Hoà giải, họ ý thức được những buồn phiền đã gây ra cho nhau, từ đó trở nên xả kỷ và quảng đại hơn; họ cũng phấn đấu sống hoà hợp với các phần tử khác trong gia đình và lối xóm. Bí tích Hoà giải mời gọi gia đình luôn hoán cải theo Tin Mừng.[4]

Người sạch sẽ thay quần áo trước khi bẩn và giặt ủi liền sau khi thay. Cũng thế, người tín hữu tốt, dù không có sai lỗi gì trầm trọng, vẫn cố gắng xưng tội thường xuyên, khoảng hai hay ba tháng một lần. Đàng khác, không chờ đến ngày xưng tội mới xét mình, nhưng nên kiểm điểm đời sống hằng ngày: Xét mình mỗi tối, để đáp lại tiếng Chúa cách quảng đại hơn. Muốn chiến thắng tội lỗi, cần dứt khoát ngay từ đầu, tránh xa các dịp tội và loại trừ cả những lệch lạc nhỏ bé nhất, ngay khi nó chỉ mới là một ý tưởng manh nha.

## 4. Hôn phối và Thánh Thể

Ơn vô giá mà đôi bạn được hưởng trong thánh lễ Hôn nhân là Hiệp lễ. Lúc ấy, hai vợ chồng được tham dự vào chính giao ước tình yêu giữa Đức Kitô và Hội Thánh. Nhờ kết hợp mật thiết với Chúa Giêsu, họ được Ngài làm bạn đồng hành, được Ngài trợ lực suốt cuộc đời để họ nên một trong Ngài và để họ có thể yêu nhau, không phải bằng một tình yêu đầy giới hạn của mình, nhưng bằng chính tình yêu vô biên của Ngài.

Bí tích Thánh Thể là nguồn mạch tình yêu, mời gọi vợ chồng trở nên một thân thể duy nhất và chia sẻ cho nhau. Năng đến với Bí tích Thánh Thể, vợ chồng sẽ được Chúa Giêsu biến đổi để trở nên tấm bánh tình yêu bẻ ra trao tặng cho nhau: tấm bánh của sự sống, của niềm vui, của tha thứ và của sự tâm đầu ý hợp. Bí tích Thánh Thể chính là sức sống nuôi dưỡng, củng cố và đổi mới tình yêu của đời sống hôn nhân và gia đình. Nhờ tình yêu siêu nhiên ấy, họ dễ lướt thắng những bực bội, buồn phiền. Nhờ thánh lễ, cuộc sống hằng ngày của gia đình trở thành “hy lễ thiêng liêng đẹp lòng Thiên Chúa[5]“.

Để được khoẻ mạnh, chẳng những phải tránh bệnh tật, mà còn phải ăn uống đầy đủ và tập thể dục. Đối với người tín hữu, dinh dưỡng là năng rước lễ và chăm đọc Lời Chúa, tập thể dục là cầu nguyện sâu xa và kiểm điểm đời sống hằng ngày.

## 5. Hôn phối và Truyền Chức thánh

Hôn phối và Truyền Chức thánh là hai bí tích phục vụ cộng đoàn do chính Đức Kitô thiết lập, là Hội Thánh.

Bí tích Hôn Phối gia tăng số con cái trong Hội Thánh, bí tích Truyền Chức tuyển chọn các tác viên phục vụ Hội Thánh. Chính ơn gọi làm linh mục được gieo mầm từ trong gia đình, nên gia đình được gọi là “Chủng viện sơ khởi[6]“.

Hội Thánh ước mong rằng không những các đôi vợ chồng quan tâm nâng đỡ các ơn gọi linh mục và tu sĩ, mà còn tha thiết muốn dâng con cái mình làm việc tông đồ phụng sự Chúa. Do đó, Công đồng Vaticanô II khuyên: “Cha mẹ hãy thận trọng giúp đỡ con cái lựa chọn ơn gọi. Nếu thấy chúng có ơn thiên triệu, họ hãy thận trọng nuôi dưỡng ơn thiên triệu đó[7]“.

Trong phạm vi gia đình, cha mẹ có trách nhiệm thánh hoá con cái, và đáp lại chính con cái cũng góp phần thánh hoá cha mẹ. Trong phạm vi giáo xứ, các chủ chăn có trách nhiệm thánh hoá giáo dân, và đáp lại chính giáo dân cũng góp phần thánh hoá các chủ chăn (Ga 17,19). Giáo dân có thể thực hiện công việc này bằng cách:
– Tích cực cộng tác với các chủ chăn trong việc xây dựng Hội Thánh, cách riêng trong các sáng kiến truyền giáo.
– Cảm thông những giới hạn và yếu đuối của các ngài.
– Cầu nguyện cho các ngài.
– Nâng đỡ các ngài về tinh thần và vật chất.
– Khiêm tốn góp ý xây dựng cho các ngài trong tình bác ái và liên đới trách nhiệm.

## 6. Hôn phối và Xức dầu bệnh nhân

Trong ngày cưới, đôi bạn hứa chung thủy với nhau cho đến chết. Cái chết niêm ấn lòng trung tín trọn vẹn của họ. Trước biên giới sự sống và sự chết, bí tích Xức dầu giúp người tín hữu kết thúc đoạn đường lữ hành và sẵn sàng bước vào cuộc sống vĩnh cửu. Thánh Thể lúc ấy là của ăn đàng giúp người tín hữu đủ sức đi tới Bàn Tiệc muôn đời của giao ước tình yêu giữa Đức Kitô và Hội Thánh khải hoàn. Trên giường hấp hối, đôi bạn thấu triệt được vẻ cao đẹp cuộc sống chung đầy ý nghĩa của mình. Đó là cuộc đồng hành với Đức Kitô, là thời gian thử thách và tinh luyện tình yêu, là đoạn đường dẫn tới cuộc sống vĩnh cửu mai sau đầy hạnh phúc.

Hãy liệu cho bệnh nhân được lãnh nhận bí tích Xức dầu lúc còn tỉnh táo. Những người thân yêu nên có mặt trong giờ phút ấy để cầu nguyện cho bệnh nhân; để hỗ trợ tâm lý cho bệnh nhân, vì lúc ấy bệnh nhân thường rất sợ cô độc.

Bí tích Xức dầu cũng nhắc nhớ đến sự hiện diện của những người cao niên trong gia đình. Đừng coi sự hiện diện của họ như một gánh nặng, nhưng hãy coi đó là một ơn Chúa: người già là hiện thân của kinh nghiệm quá khứ, có thể giúp giới trẻ nhận ra lẽ khôn ngoan trong cuộc sống. Đồng thời, người già cũng dễ mang tâm trạng cô đơn, sợ bị bỏ rơi. Do đó, cần quan tâm chăm sóc những người già cả trong gia đình mình cũng như trong lối xóm.

---

## GHI NHỚ:

1. H. Các bí tích giúp ích gì cho đời sống Hôn nhân và gia đình?

T. Các bí tích, đặc biệt là bí tích Hôn phối, Thánh Thể và Hoà giải thánh hoá tình yêu vợ chồng, ban nhiều ơn sủng giúp họ chu toàn trách nhiệm đối với nhau và đối với con cái.

2. H. Ai được quyền cử hành Bí tích Rửa tội?

T. Bình thường là Giám mục, Linh mục và phó tế, nhưng khi khẩn cấp thì bất cứ ai cũng có thể cử hành, miễn là làm theo ý muốn và cách thức của Hội Thánh.

3. H. Trong trường hợp khẩn cấp, phải rửa tội như thế nào?

T. Phải lấy nước lã, là nước tự nhiên, không pha thứ gì vào, như nước sông, nước biển, nước giếng, nước mưa, rồi đổ trên đầu kẻ chịu phép Rửa tội và đọc: (tên thánh) ta rửa con, nhân danh Cha và Con và Thánh Thần.

4. H. Gia đình Kitô hữu sống bí tích Thêm sức như thế nào?

T. Gia đình Kitô hữu sống bí tích Thêm sức bằng cách lo cho mọi người nhiệt thành sống đức tin, để trở nên nhân chứng của Đức Kitô và góp phần xây dựng Hội Thánh.

5. H. Vì sao gia đình Kitô hữu phải năng lãnh nhận Bí tích Hoà giải?

T. Nhờ Bí tích Hoà giải, mọi người nhận ra những lỗi phạm của mình và đón nhận lòng khoan dung của Thiên Chúa, nhờ đó sẽ dễ sống hoà hợp và tha thứ cho nhau.

6. H. Vì sao gia đình Kitô hữu phải năng lãnh nhận Bí tích Thánh Thể?

T. Vì Bí tích Thánh Thể là nguồn mạch tình yêu và là sức sống nuôi dưỡng, củng cố và đổi mới tình yêu của đời sống hôn nhân và gia đình.

7. H. Cha mẹ có bổn phận nào đối với ơn thiên triệu của con cái?

T. Cha mẹ phải thận trọng giúp đỡ con cái nhận biết ơn gọi. Nếu thấy chúng có ơn thiên triệu thì phải lo nuôi dưỡng ơn thiên triệu ấy.

8. H. Bí tích Xức dầu bệnh nhân có liên hệ nào đối với đời sống hôn nhân và gia đình?

T. Bí tích Xức dầu bệnh nhân nhắc nhở ta quan tâm đến những người đau yếu, bằng cách lo cho họ lãnh nhận bí tích này, để được ơn Chúa nâng đỡ. Đồng thời quan tâm đến những người già cả trong gia đình và lối xóm, bằng cách giúp đỡ và chăm sóc họ, đặc biệt là những người neo đơn.

---

## GỢI Ý SUY NGHĨ:

1. Bí tích Hoà giải và bí tích Thánh Thể đem lại cho gia đình anh chị những ơn ích nào?
2. Tương quan giữa bí tích Rửa tội và bí tích Hôn phối?

---

## CẦU NGUYỆN:

Lạy Chúa, Chúa đã dùng bí tích Hôn phối liên kết chúng con nên duyên vợ chồng. Xin thương đổ ơn thánh Chúa xuống trên gia đình chúng con, để chúng con trở thành dấu chỉ sự hiện diện của Chúa cho nhau và cho mọi người. Amen.`
},
{
  id: 16,
  title: "Cầu nguyện trong gia đình",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Gia đình Kitô hữu được gọi là Hội Thánh tại gia, nơi các thành viên gặp gỡ Thiên Chúa qua cầu nguyện chung và riêng, nhờ đó hiệp nhất, yêu thương và lớn lên trong đức tin mỗi ngày.",
  content: `# 🙏 BÀI 16: CẦU NGUYỆN TRONG GIA ĐÌNH

“Hãy dùng những bài thánh vịnh, thánh thi và thánh ca do Thần Khí linh hứng mà đối đáp với nhau và ca tụng Chúa hết lòng anh em. Trong mọi hoàn cảnh và mọi sự, hãy nhân danh Đức Giêsu Kitô, Chúa chúng ta, mà cảm tạ Thiên Chúa là Cha.” (Ep 5,19-20)

Gia đình Kitô hữu được gọi là Hội Thánh tại gia vì gia đình là nơi đặc biệt diễn tả sự hiệp thông trong Hội Thánh: “Gia đình Kitô giáo bày tỏ và thể hiện một cách đặc biệt sự hiệp thông trong Hội Thánh vì lẽ đó phải được coi là một Hội Thánh tại gia, là một cộng đoàn đức tin, đức cậy và đức mến. Gia đình Kitô giáo là một hiệp thông nhân vị là dấu chỉ và hình ảnh của sự hiệp thông giữa Chúa Cha và Chúa Con trong Chúa Thánh Thần[1]“.

Sự hiệp thông trong gia đình dẫn đến sự gặp gỡ Thiên Chúa, đồng thời việc gặp gỡ Thiên Chúa sẽ nối kết gia đình bền chặt hơn. Trong Tông huấn Gia đình, Đức Thánh Cha Gioan Phaolô II gọi gia đình là “cộng đồng đối thoại với Thiên Chúa”. Gia đình được lôi cuốn vào cuộc đối thoại với Thiên Chúa bằng việc Lắng nghe Lời Chúa, bằng việc cầu nguyện chung cũng như cầu nguyện riêng, bằng việc lãnh nhận các bí tích, đặc biệt là bí tích Thánh Thể và bí tích Hoà giải.

Thư chung của Hội Đồng Giám Mục VN năm 1980 cũng nhắn nhủ: “Anh chị em hãy tin vào ơn Chúa Thánh Thần đã được đổ xuống trong lòng để nuôi dưỡng đời sống cầu nguyện của anh chị: cầu nguyện riêng, cầu nguyện chung trong gia đình và trong xứ đạo. Và nhất là anh chị em hãy đào sâu đức tin của mình bằng việc học và dạy giáo lý ngay trong gia đình của mình”.

## 1. Cầu nguyện là gì?

Cầu nguyện chính là cuộc gặp gỡ và đối thoại thân mật với Thiên Chúa. Hình ảnh cuộc gặp gỡ và đối thoại giữa Chúa Giêsu với người phụ nữ Samaria bên bờ giếng Giacop (x. Ga 4,1-20) là một hình ảnh tuyệt vời về cầu nguyện. Chính Chúa Giêsu đang khát và đã tìm đến gặp gỡ, ngỏ lời trước với con người, Ngài đã khơi dậy nơi cõi lòng con người nỗi khát khao sâu thẳm, và giúp con người khám phá ra Ngài là Đấng duy nhất có thể lắp đầy nỗi khao khát đó.

Cầu nguyện là lời đáp trả đức tin và tình yêu của con người trước lời hứa cứu độ của Thiên Chúa. Cầu nguyện còn là sự đặt mình trước sự hiện diện của Thiên Chúa, để đi sâu vào mối hiệp thông với Ba Ngôi. Từ sự xác tín trên, các nhà tu đức đã định nghĩa cầu nguyện như sau:

– Cầu nguyện là nâng hồn lên Chúa hay cầu xin Ngài ban cho những ơn cần thiết [2].  
– Cầu nguyện là sự hứng khởi của tâm hồn, là cái nhìn đơn sơ hướng về trời cao, là lời kinh tri ân và yêu mến giữa cơn thử thách cũng như lúc hân hoan [3].

## 2. Phải cầu nguyện như thế nào?

Chúa Giêsu là mẫu gương tuyệt hảo cầu nguyện, là vị Thầy dạy ta cách cầu nguyện. Ngài thường cầu nguyện nơi vắng vẻ (x. Lc 5,16). Kinh nguyện của Ngài đầy tâm tình gắn bó yêu thương, vâng phục thánh ý Chúa Cha, dù phải chấp nhận Thập Giá (x. Mt 26,39), và tuyệt đối tin tưởng là mình sẽ được nhận lời. Ngài còn kêu gọi các môn đệ tỉnh thức cầu nguyện (x. Lc 22,40) và muốn họ dâng những lời cầu khẩn lên Thiên Chúa nhân danh Ngài (x.Mt 18,19-20). Chúa Giêsu đã dạy các môn đệ cầu nguyện với một tâm hồn trong sạch, một đức tin sống động và kiên trì, một sự dạn dĩ của người con.

### 2.1. Kiên trì cầu nguyện

Cầu nguyện kiên trì, không sờn lòng nản chí, chắc chắn sẽ được Thiên Chúa nhận lời. Chẳng hạn như bà goá kêu oan, đòi ông quan toà phân xử; cuối cùng ông cũng phải giải quyết (x. Lc 18,1-8). “Vậy chẳng lẽ Thiên Chúa lại không bênh vực những kẻ Người tuyển chọn, ngày đêm hằng kêu cứu với Người, dù Người có trì hoãn?” (18,7). Hay như người kia quấy rầy bạn mình vào lúc đêm khuya vẫn có được tất cả những thứ gì anh ta cần dùng (x. Lc 11,5-8). Chúa Giêsu khẳng định: “Hễ ai xin thì nhận được, ai tìm thì thấy, ai gõ sẽ mở cho” (Lc 11,10). Và Thiên Chúa còn ban cho hơn cả lòng ta mong ước vì Cha trên trời còn rộng lượng hơn cả người cha trần gian; đó là ban chính Thánh Thần của Ngài cho chúng ta (x. Mt 7,7-11; Lc 11,11-13).

### 2.2. Khiêm tốn cầu nguyện

Khi cầu nguyện, ta phải cầu nguyện bằng tất cả con người của mình: lời nói và cử chỉ, đặc biệt là tấm lòng. Tấm lòng chính là nơi sâu kín của con người, là nơi phát sinh mọi quyết định và gặp gỡ. Khiêm nhường và thống hối là một tâm tình căn bản trong khi cầu nguyện (Tv 130,14), vì chúng ta không biết cầu nguyện thế nào cho phải (Rm 8,26). Khiêm nhường là tâm tình phải có để đón nhận được ơn cầu nguyện vì trước mặt Chúa, con người chỉ là kẻ van xin[4].

Cầu nguyện trong sự hạ mình là cách thức dễ đánh động lòng Thiên Chúa nhất. Dụ ngôn hai người lên đền thờ cầu nguyện cho thấy Thiên Chúa không đoái hoài đến những thành tích đáng nể của người Pharisêu chỉ vì ông hay khoe khoang và coi khinh người khác (x. Lc 18,9-14; 7,6-10). Cầu nguyện khiêm tốn để sám hối về những lầm lỗi, và tạ ơn về tất cả những gì mình đã được lãnh nhận, và đó là điều làm đẹp lòng Thiên Chúa nhất (x. Lc 10,21).

Cầu nguyện còn phải đi đôi với nỗ lực hòa giải và lòng yêu thương, kể cả kẻ thù và người bách hại mình; kinh nguyện phải phát xuất từ đáy lòng với tâm hồn thanh khiết và ước mong tìm kiếm Nước Thiên Chúa trên hết mọi sự.

## 3. Những nguồn mạch của cầu nguyện

Trong đời sống Kitô hữu, có những nguồn mạch, ở đó Đức Kitô đang đợi chờ để ban Thánh Thần cho ta[5]. Sau đây là một số nguồn mạch chính yếu :

### 3.1. Lời Chúa

Công đồng Vaticanô II đã khuyến khích các Kitô hữu: “Mọi người cũng nên nhớ rằng kinh nguyện phải đi đôi với việc đọc Thánh Kinh, để có sự đối thoại giữa Thiên Chúa và con người, vì “chúng ta ngỏ lời với Ngài khi cầu nguyện, và chúng ta nghe Ngài nói lúc chúng ta đọc các sấm ngôn thần linh”[6].

### 3.2. Phụng vụ của Hội Thánh

Kinh nguyện tiếp nhận Phụng vụ và đồng hóa với Phụng Vụ trong khi và sau khi được cử hành. Dù con người cầu nguyện nơi kín đáo (Mt 6, 6), lời nguyện của họ vẫn là lời kinh của Hội Thánh, là sự hiệp thông với Ba Ngôi Chí Thánh[7].

### 3.3. Các nhân đức đối thần

Đức tin giúp ta đón nhận Chúa xuyên qua các dấu chỉ về sự hiện diện thần linh, tìm kiếm và trông mong Thánh Nhan Chúa, lắng nghe và suy niệm lời Ngài.

Đức cậy là thái độ phải có khi cầu nguyện, đồng thời được dưỡng nuôi nhờ cầu nguyện. Vì vậy, Thánh Phaolô đã nguyện xin “Thiên Chúa là nguồn hy vọng, ban cho anh em được chan chứa niềm vui và bình an để nhờ quyền năng Thánh Thần anh em được tràn trề hy vọng” (Rm, 15,13).

Đức mến là suối nguồn của đời cầu nguyện, vì đức mến lôi kéo mọi sự vào trong Tình Yêu Thiên Chúa và làm cho ta có thể yêu mến Ngài như Ngài yêu mến ta. Vì thế, ai để cho đức ái hướng dẫn, người ấy sẽ đi tới đỉnh cao của cầu nguyện.

### 3.4. Cái “hôm nay”

Khi dạy ta cầu nguyện, Chúa Giêsu cũng dạy về sự quan phòng của Chúa Cha (Mt 6, 11.34). Thời gian là của Chúa Cha, chúng ta gặp được Ngài trong hiện tại, không phải hôm qua hay ngày mai, nhưng chính hôm nay: “Ước chi hôm nay các bạn nghe tiếng Chúa! Đừng cứng lòng” (Tv 95, 7-8). Khi ta cầu nguyện khởi đi từ cái hôm nay của đời thường, ảnh hưởng của Nước Chúa thấm vào trong dòng chảy của cuộc đời, và kinh nguyện trở thành men làm cho cả nắm bột cuộc đời dậy lên một sức sống mới.

## 4. Cầu nguyện trong gia đình

Gia đình Kitô hữu là nơi đầu tiên để học cầu nguyện. Được xây dựng trên bí tích Hôn Phối, gia đình là “Hội Thánh thu nhỏ”, là nơi con cái Thiên Chúa học cách cầu nguyện. Đặc biệt với các trẻ nhỏ, kinh nguyện hằng ngày của gia đình là chứng từ đầu tiên về ký ức sống động của Hội Thánh luôn được Chúa Thánh Thần nâng đỡ[8].

Hội Thánh đề ra cho các tín hữu những dịp cầu nguyện để nuôi dưỡng đời sống nội tâm. Nhịp cầu nguyện hằng ngày là kinh tối và kinh sáng, trước và sau các bữa ăn. Trong đời sống gia đình, ta có thể cầu nguyện chung và cầu nguyện riêng.

### 4.1. Cầu nguyện chung

Giờ Kinh chung của gia đình chính là giờ “ngồi bên nhau” và “cùng nhau ngồi bên Chúa” là giờ của chân lý, là một khám phá kỳ diệu, là một liều thuốc thần tiên. “Kinh nguyện chung trong gia đình có nội dung độc đáo là chính cuộc sống của gia đình. Qua những tình huống thay đổi của cuộc sống ấy, chính Thiên Chúa đang mời gọi và gia đình tín hữu đáp trả lại với đầy lòng hiếu thảo. “Những chuyện vui buồn, hy vọng và sầu khổ, ngày sinh và ngày cưới, những người đi vắng trở về, những chọn lựa quan trọng và ngay cả cái chết của người thân yêu… tất cả đều là những dấu hiệu về sự hiện diện ưu ái của Thiên Chúa trong cuộc sống gia đình. Những biến cố ấy phải là những dịp để gia đình tạ ơn, khấn nguyện, tin tưởng phó thác vào bàn tay Cha chung trên trời”[9].

Trong gia đình, các thành viên càng cầu nguyện chung với nhau, càng hiệp nhất bền chặt vì cảm nhận được sự hiện diện sống động của Chúa Giêsu : “Thầy bảo thật anh em: nếu ở dưới đất, hai người trong anh em hợp lời cầu xin bất cứ điều gì, thì Cha Thầy, Đấng ngự trên trời, sẽ ban cho. Vì ở đâu có hai ba người họp lại nhân danh Thầy, thì có Thầy ở đấy, giữa họ” (Mt 18,19-20).

Trong tông thư “Kinh Mân Côi”, Đức Thánh Cha Gioan Phaolô II nói: “Gia đình cùng nhau cầu nguyện là gia đình cùng nhau chung sống… Những phần tử của mỗi gia đình, khi hướng mắt nhìn lên Chúa Giêsu, cũng lấy lại được khả năng nhìn vào mắt của nhau, khả năng nói chuyện với nhau, khả năng tha thứ cho nhau, và khả năng nhìn thấy giao ước yêu thương của họ được canh tân trong Thần Linh Chúa”[10].

Lợi ích của giờ kinh chung: Giờ kinh chung của gia đình là cơ hội để mọi người thánh hoá sinh hoạt hằng ngày:
– Tạ ơn vì các hồng ân lãnh nhận trong ngày.  
– Dâng niềm vui, nỗi buồn, dâng mồ hôi nước mắt, những thành công, thất bại trong ngày như hy tế để xin Chúa đón nhận, thanh tẩy, đỡ nâng và chúc lành.  
– Là cơ hội để vun xới tình gia đình: hiệp thông với những người thân yêu đã khuất, những người vắng mặt; cầu nguyện cho những nhu cầu của nhau; xin lỗi và tha thứ cho nhau, thông cảm, giúp nhau mỗi ngày một hoàn thiện hơn.  
– Và cũng là cơ hội thuận tiện để cha mẹ dạy dỗ, hướng dẫn con cái về mặt nhân bản cũng như về mặt đức tin. Việc giáo dục của cha mẹ không chỉ bằng lời nói mà còn bằng chính gương sống.

Tại Việt Nam, cầu nguyện chung trong gia đình qua các giờ kinh tối và kinh sáng là một truyền thống đạo đức rất tốt đẹp đã ăn rễ sâu trong các gia đình Công giáo. Tuy nhiên, truyền thống này đang bị mai một dần do ảnh hưởng của nếp sống đô thị hoá hiện nay. Để vượt qua những cản trở cho việc cầu nguyện chung trong gia đình, vào buổi tối, cần thu xếp giờ kinh thật sớm để tiện cho mọi người, nhất là trẻ em có thể tỉnh táo. Nếu không được, cần hướng dẫn cho trẻ em cầu nguyện trước. Khi cầu nguyện nguyện chung, cần tạo bầu khí trang nghiêm và ấm cúng, thực sự gặp gỡ và đối thoại với Chúa.

Bàn thờ của gia đình: Để giúp mọi người nhớ tới sự hiện diện của Thiên Chúa trong gia đình, mỗi nhà nên có một bàn thờ nhỏ. Bàn thờ cần sáng sủa, trình bày đơn giản để diễn tả đức tin thật chính xác. Cách chung, đừng để quá nhiều ảnh tượng trên bàn thờ, nên dùng một Thánh giá khá lớn, một bên để một tượng Chúa hay ảnh Đức Mẹ, một bên để cuốn Kinh Thánh. Thay vì cuốn Kinh Thánh, cũng có thể treo một hai tấm liễn ghi Lời Chúa. Bàn thờ cần giữ sạch sẽ, không để những đồ đạc lặt vặt. Bàn thờ tổ tiên có thể đặt bên dưới bàn thờ Chúa, nhưng cần có sự phân biệt rõ ràng và trang trí đơn giản.

### 4.2. Cầu nguyện riêng

Thiên Chúa hiện diện giữa gia đình khi cả nhà cầu kinh chung và cũng hiện diện cách thâm sâu trong tâm hồn mỗi người vì chính nơi đó, Ngài chờ đợi mỗi người trở về gặp gỡ Ngài thật sâu xa. Bởi đó, cầu nguyện chung và cầu nguyện riêng cần đi đôi với nhau. Nhờ cầu nguyện chung, người ta sẽ quen cầu nguyện riêng; đồng thời mỗi người càng cầu nguyện riêng, thì giờ kinh chung sẽ càng tốt đẹp. Mỗi người trong gia đình, đặc biệt các bậc cha mẹ, cần dạy cho con cái sống tinh thần cầu nguyện bằng cách:

– Mỗi sáng vừa thức dậy nhớ dâng ngày cho Chúa và xin Chúa Thánh Thần dạy cho biết sống cả ngày trong sự kết hiệp với Chúa.  
– Tập luôn luôn “thấy Chúa đang nhìn ta”, dù ở đâu, làm gì, cũng sống trong cái nhìn yêu thương của Chúa.  
– Cũng có thể dùng những lời cầu nguyện tắt lặp đi lặp lại nhiều lần trong ngày, như: “Lạy Chúa Giêsu, con yêu mến Chúa”…  
– Khi đã lên giường, sắp sửa ngủ, nên ôn lại những điều đã cảm nhận trong đoạn Lời Chúa vừa đọc trong giờ kinh tối, để tiếp tục suy niệm vào sáng hôm sau.

Ngoài ra, mỗi người cần có những giờ phút dành riêng để cầu nguyện, nhất là tâm nguyện hay nguyện ngắm.

Khi nguyện ngắm, nếu ở trong nhà thờ, ta nên chăm chú nhìn lên Chúa Giêsu Thánh Thể trong nhà tạm. Ở những nơi khác, ta có thể nhìn lên tượng Chúa hoặc hướng về Chúa đang ngự trong lòng. Để dễ tập trung, nên ngồi theo một tư thế thật yên vững, giữ cho cột sống và đỉnh đầu thẳng góc với mặt đất, rồi tha thiết xin ơn Chúa Thánh Thần, gạt bỏ hết mọi âu lo và dự tính để chú tâm vào sự hiện diện của Thiên Chúa và đối thoại với Ngài. Hãy bắt đầu thật nghiêm túc và nghiêm túc cho bằng được, rồi kiên nhẫn cho đến hết giờ quy định. Dần dần, Chúa Thánh Thần sẽ đưa ta tiến sâu vào một kinh nghiệm cầu nguyện sâu xa và thấm thía.

## 5. Nội dung một giờ kinh trong gia đình

Mỗi giờ kinh thường gồm các yếu tố: Lời Chúa, lời ca, lời kinh, lời cầu và sự thinh lặng.

Lời Chúa giữ vai trò quan trọng: đó là lương thực thiêng liêng, là chuẩn mực hướng dẫn đời sống người tín hữu và là phương tiện thông thường Chúa dùng để giúp ta được biến đổi. Bởi vậy, trong mỗi giờ kinh, nên đọc một đoạn Lời Chúa trích từ Kinh Thánh để suy niệm. Nên đọc theo một chương trình. Chẳng hạn đọc một trong các đoạn Kinh Thánh của thánh lễ hôm sau, như được ghi trong lịch Công giáo, hoặc đọc toàn bộ Kinh Thánh trong 3 năm, tuần tự mỗi tối một đoạn.

Sự thinh lặng để xét mình và suy niệm làm cho Lời Chúa thấm vào lòng ta. Nhờ đó, tự đáy lòng, ta có thể nói lên những lời nguyện tự phát để ca tụng, ngợi khen Chúa, để bày tỏ tâm tình thống hối, mến yêu, hay để cầu xin cho những người quen biết và cho những nhu cầu của Hội Thánh và loài người.

Lời kinh: Nên duy trì những kinh cần thiết làm nền cho giờ cầu nguyện: Kinh Truyền tin, kinh Chúa Thánh Thần, Kinh Tin, Cậy, Mến, Ăn năn tội, Lạy Cha, Kính Mừng, Sáng Danh, Lạy Nữ Vương, Cám Ơn, Trông Cậy, kinh Vực sâu. Trước giờ kinh, nên dành một phút xem thử sẽ dùng những kinh nào, chứ đừng vừa cầu nguyện vừa chọn kinh.

Mỗi giờ kinh nên có một chục kinh Mân Côi đọc chung. Thỉnh thoảng cả gia đình nên lần chung trọn chuỗi. Khi đó, nên bỏ bớt một số kinh khác. Còn phần Lời Chúa, nếu chọn theo các mầu nhiệm Mân Côi, chỉ cần đọc một vài câu ngắn.

Điều cần thiết khi cầu nguyện là phải nhớ rằng Chúa đang hiện diện. Ta ở đó để nghe Ngài nói và nói với Ngài. Muốn dễ nhớ sự hiện diện của Chúa, khi cầu nguyện nên ăn mặc nghiêm chỉnh, thu dọn đồ đạc trong phòng và trên bàn cho ngăn nắp.

* * *

Để kết thúc, chúng ta cùng nhau nghe lại lời kêu gọi của Đức Thánh Cha Phaolô VI đã ngỏ với các bậc làm cha làm mẹ. Những lời này đã được Đức Thánh Cha Gioan Phaolô II trân trọng nhắc lại trong Tông huấn Gia đình: “Hỡi các bà mẹ, chị em có dạy cho các con nhỏ của mình những lời kinh của người Kitô hữu không? Chị em có cộng tác với các linh mục để chuẩn bị cho chúng lãnh nhận các bí tích xưng tội, rước lễ, thêm sức hay không? Nếu chúng đau ốm, chị em có tập cho chúng quen nghĩ tới những sự đau khổ của Đức Kitô, quen cầu xin Đức Mẹ Đồng Trinh và các thánh giúp đỡ hay không? Còn anh em, hỡi những người cha, anh em có biết cầu nguyện chung với con cái, với cộng đồng gia đình, ít là thỉnh thoảng không? Gương sống của anh em qua sự ngay thẳng trong tư tưởng và hành động, được hỗ trợ bằng kinh nguyện chung, quả là một bài học sống động nhất cho con cái”.
`
},
{
  id: 17,
  title: "Sinh con có trách nhiệm",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Sinh sản có trách nhiệm là khi vợ chồng ý thức cộng tác với Thiên Chúa trong việc truyền sinh, biết suy xét và quyết định theo lương tâm ngay thẳng, tôn trọng sự sống và giáo huấn của Hội Thánh.",
  content: `# 📖 BÀI 17: SINH CON CÓ TRÁCH NHIỆM

“Hiền thê bạn trong cửa trong nhà, khác nào cây nho đầy hoa trái; và bầy con tựa những cây ô-liu mơn mởn, xúm xít tại bàn ăn. Đó chính là phúc lộc Chúa dành cho kẻ kính sợ Người” (Tv 128, 3-4).

Sách Sáng thế kể: Hai chị em Lêa và Rakhen cùng lấy một chồng là Giacop. Khi thấy chị Lêa sinh được bốn đứa con, còn mình thì mãi không sinh nở, Rakhen đã phát ghen và nói với Giacop: “Hãy cho tôi được có con, không thì tôi chết mất” (St 30,1). Một đứa con sinh ra trong sự mong đợi quả là niềm hạnh phúc lớn lao cho đôi vợ chồng. Tuy nhiên bên cạnh niềm vui cũng có nhiều nỗi lo. Chẳng hạn đối với hai vợ chồng : phải làm sao có đủ khả năng để chăm sóc cho con cái. Đối với xã hội, dân số gia tăng có nghĩa là phải làm sao có thêm lương thực, thêm trường học, thêm bệnh viện, thêm việc làm… Chính vì thế, càng ngày người ta càng ý thức hơn vấn đề sinh con có trách nhiệm. Đây cũng là vấn đề quan trọng mà các anh chị đang chuẩn bị bước vào đời sống hôn nhân cũng như các đôi vợ chồng cần quan tâm suy nghĩ.

## 1. Con cái là ân huệ cao quý nhất của hôn nhân

“Truyền sinh là một ân huệ, một mục tiêu của hôn nhân, vì tình yêu vợ chồng tự nhiên hướng về việc sinh sản con cái. Con cái là hoa quả và thành tựu của tình yêu vợ chồng, hiện diện ngay trong việc vợ chồng hiến thân cho nhau, chứ không phải một cái gì từ bên ngoài được ghép vào. Vì thế Hội Thánh “bảo vệ sự sống[1]“ và dạy rằng “mọi hành vi ân ái phải tự nó mở ngỏ cho việc truyền sinh[2]“. “Giáo lý này đã được Huấn Quyền trình bày nhiều lần, nền tảng của giáo lý này là sự liên kết bất khả phân ly giữa hai ý nghĩa của hành vi ân ái: kết hợp và truyền sinh. Đây là điều chính Thiên Chúa đã muốn và con người không được tách rời[3]“.

## 2. Cần phải sinh con một cách có trách nhiệm

Nhiệm vụ sinh sản và giáo dục con cái là sứ mạng riêng biệt của vợ chồng. Trong khi thực hiện nhiệm vụ ấy, họ biết rằng mình cộng tác vào công trình sáng tạo của Đấng Tạo Hóa và trở thành những kẻ diễn đạt tình yêu của Ngài. Bởi vậy, họ sẽ chu toàn bổn phận của mình với trách nhiệm của một con người và của một Kitô hữu[4].

Hội Thánh cũng nhấn mạnh rằng chính lương tâm trong sáng của đôi bạn là mực thước chỉ dạy họ quyết định về số con của mình[5]. Nhờ vâng phục Thiên Chúa và đồng tâm hiệp lực với nhau, hai vợ chồng sẽ tạo được cho mình một phán đoán ngay thẳng:
– biết xét đến lợi ích riêng của mình cũng như của con cái đã sinh ra hoặc sẽ sinh ra,
– biết nhận định về các hoàn cảnh vật chất và tinh thần,
– biết nghĩ đến lợi ích của gia đình, xã hội và Hội Thánh.

Sự phán đoán ấy, chính đôi vợ chồng phải suy nghĩ trước mặt Thiên Chúa.

Khi hành động, các vợ chồng Kitô hữu luôn ý thức mình không thể làm theo sở thích, nhưng phải tuân theo tiếng nói của một lương tâm được khuôn đúc theo luật Chúa và giáo huấn của Hội Thánh.

## 3. Những tiêu chuẩn để quyết định điều hòa sinh sản

Sinh sản có trách nhiệm là suy nghĩ kỹ lưỡng và phán đoán chín chắn trước khi quyết định sinh con. Đôi vợ chồng cần suy nghĩ và phán đoán dựa vào các tiêu chuẩn thực tế sau đây:

### 3.1. Vì lợi ích của chính vợ chồng

Mỗi đứa con chào đời phải củng cố thêm tình yêu và hạnh phúc của vợ chồng, vì đứa con là kết quả của tình yêu tự hiến của họ. Trước khi quyết định sinh con, vợ chồng phải lưu ý đến những yếu tố giúp mang lại hoặc ảnh hưởng đến hạnh phúc của họ, chẳng hạn sức khỏe của người mẹ, tâm lý, ước vọng tương lai…

### 3.2. Vì lợi ích của con cái

Con cái là ân huệ tốt đẹp nhất của hôn nhân. Sinh một đứa con là tự ý chấp nhận tạo mọi điều kiện để nó có thể sống hạnh phúc, sống xứng đáng với ơn gọi làm người và làm con Thiên Chúa. Do đó, đôi bạn cần lưu ý đến khả năng tài chính, nơi ăn chốn ở, những phương cách giáo dục… và tính toán xem nếu sinh thêm một đứa con, liệu mình có thể nuôi dưỡng và giáo dục nó được chu đáo không.

### 3.3. Vì lợi ích của xã hội và Hội Thánh

Xã hội phát triển là nhờ những phần tử khoẻ mạnh, siêng năng làm việc và có những đức tính cần thiết. Cũng vậy, Hội Thánh chỉ thực sự phát triển khi con cái của mình không những kiên vững về đức tin mà còn trưởng thành về nhân bản nữa. Do đó, sự lượng định về khả năng nuôi dạy và giáo dục con cái trở thành những phần tử hữu ích cho xã hội và Hội Thánh cũng là một tiêu chuẩn mà đôi bạn cần lưu ý khi quyết định về việc điều hòa sinh sản.

## 4. Vấn đề ngừa thai

Do tình trạng tài nguyên trên thế giới phân phối không đều, ngày nay những nước nghèo không đủ sống, trong khi những nước giàu quá thừa thãi. Cũng vì thế, đang khi nhiều nước giàu khuyến khích các gia đình có thêm con cái, thì các nước nghèo bị áp lực phải tìm cách hạn chế dân số. Nhiều gia đình tự thấy chỉ nên sinh con trong khả năng mình có thể nuôi dạy chúng nên người.

Trong việc kế hoạch hóa gia đình, người Công giáo không được phép sử dụng cách ngừa thai nhân tạo mà chỉ được sử dụng cách ngừa thai tự nhiên, khi có lý do chính đáng theo những tiêu chuẩn của Hội Thánh.

“Một khía cạnh đặc biệt của trách nhiệm đó là điều hòa truyền sinh... Đó là điều không thể thực hiện được nếu không thực tâm vun trồng đức khiết tịnh trong bậc vợ chồng”[6].

### 4.1. Cách thức ngừa thai nhân tạo

Ngừa thai nhân tạo là trực tiếp làm cho khả năng sinh sản vô hiệu hoặc làm cho diễn tiến truyền sinh bị ngăn chặn hay không thể đạt kết quả.

Cách thức ngừa thai nhân tạo áp dụng cho nam giới gồm những phương pháp: thắt ống dẫn tinh, bao cao su, xuất tinh ngoài âm đạo, thuốc diệt tinh trùng…

Cách thức ngừa thai nhân tạo áp dụng cho nữ giới gồm những phương pháp : thắt ống dẫn trứng, thuốc tránh thai (uống, tiêm hoặc cấy dưới da), dụng cụ như vòng xoắn, màng ngăn…

Hội Thánh cấm dùng các phương pháp ngừa thai này...

### 4.2. Cách thức ngừa thai tự nhiên

Ngừa thai tự nhiên là tiết dục định kỳ, vợ chồng kiêng giao hợp trong thời kỳ người vợ dễ dàng thụ thai.

– Phương pháp Ogino-Knauss  
– Phương pháp Billings  

## 5. Vấn đề phá thai

Sự sống con người phải được tuyệt đối tôn trọng và bảo vệ từ lúc được thụ thai...  
Phá thai là tội rất nặng...

## 6. Những đôi vợ chồng vô sinh

Thánh Kinh luôn coi những gia đình đông con là một dấu chỉ phúc lành của Thiên Chúa...

* * *

## GHI NHỚ:

1. H. Sinh sản có trách nhiệm nghĩa là gì?  
T. Sinh sản có trách nhiệm nghĩa là khi sinh con, cha mẹ phải lo nuôi dưỡng, giáo dục, để chúng nên người...

2. H. Vì sao cần phải sinh sản có trách nhiệm?  
T. Vì sinh sản có trách nhiệm...

3. H. Để sinh sản có trách nhiệm, vợ chồng Kitô hữu phải có thái độ nào?  
T. Vợ chồng Kitô hữu phải có những thái độ sau đây :  
– Một là phải biết làm chủ bản năng tính dục.  
– Hai là phải biết tôn trọng lẫn nhau.  
– Ba là phải biết rõ hoàn cảnh cụ thể của mình để cùng nhau quyết định sinh con hay tạm ngừng.  
– Bốn là phải dùng cách thức tự nhiên.  
– Năm là phải biết tin tưởng vào Chúa để sẵn sàng đón nhận những đứa con ngoài ý muốn.

4. H. Cách thức ngừa thai tự nhiên là gì?  
T. Cách thức ngừa thai tự nhiên là tiết dục định kỳ...

5. H. Có những phương pháp nào giúp xác định được ngày trứng rụng?  
T. Có hai phương pháp này :  
– Một là phương pháp Ogino.  
– Hai là phương pháp Billings.

6. H. Cách thức ngừa thai nhân tạo là gì?  
T. Cách thức ngừa thai nhân tạo là trực tiếp làm cho khả năng sinh sản ra vô hiệu...

7. H. Để thực hiện cách thức ngừa thai nhân tạo người ta thường dùng những phương pháp nào?  
T. Đối với nam giới gồm có: thắt ống dẫn tinh, dùng bao cao su, xuất tinh ra ngoài, dùng thuốc diệt tinh trùng...  
Đối với nữ giới gồm có: thắt ống dẫn trứng, thuốc tránh thai, vòng xoắn, màng ngăn.

8. H. Phá thai có tội hay không?  
T. Phá thai là tội rất nặng.
`
},
{
  id: 18,
  title: "Giáo dục con cái",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Giáo dục con cái là bổn phận và vinh dự lớn lao của cha mẹ, nhằm giúp con trở thành người trưởng thành về nhân bản và đức tin, sống tốt đời đẹp đạo và trở nên con cái Thiên Chúa.",
  content: `# 📖 BÀI 18: GIÁO DỤC CON CÁI

“Có con cái ư? Hãy dạy dỗ và uốn nắn chúng ngay thuở còn thơ.” (Hc 7,23)

Hạnh phúc của cha mẹ là được thấy con cái nên người. Ngược lại, nếu con cái hư hỏng sẽ là một nỗi đắng cay phiền muộn. Kết quả đáng mừng hay đáng tủi ấy tuỳ vào sự bận tâm giáo dục của cha mẹ ngay từ đầu.

Giáo dục con cái không phải chỉ là một bổn phận quan trọng, mà còn là một vinh dự lớn lao của bậc làm cha làm mẹ, bởi vì được cộng tác với Thiên Chúa trong việc tạo nên những con người mới, những người con của Thiên Chúa. Đó là việc trồng người. Không chỉ trồng nên những người hữu ích cho xã hội, cho Hội Thánh mà còn trồng nên những vị thánh. Vì thế, giáo dục con cái không phải là một việc tuỳ hứng, nhưng cần có một đường hướng, một kế hoạch và những phương pháp.

## 1. Quyền và bổn phận giáo dục con cái

Quyền và bổn phận giáo dục con cái là cái cốt lõi của việc làm cha làm mẹ, bởi vì nó liên quan đến việc lưu truyền sự sống. So với những người khác, thì vai trò giáo dục của cha mẹ là khởi nguồn và là cơ bản vì tương quan yêu thương độc nhất vô nhị giữa cha mẹ và con cái. Vai trò giáo dục của cha mẹ không ai thay thế được và cũng không nhường cho ai được, nên không thể nào khoán trắng cho người khác hoặc để người khác chiếm đoạt.

Yếu tố nền tảng cơ bản nhất đánh dấu vai trò giáo dục của cha mẹ là tình phụ tử và mẫu tử. Chính tình yêu thương này, như nguồn mạch xuất phát, trở thành linh hồn và quy tắc để gợi ra những sáng kiến và hướng dẫn cho mọi hoạt động giáo dục cụ thể, làm cho chúng thấm đượm những giá trị của sự dịu dàng, kiên nhẫn, nhân hậu, phục vụ, vô vị lợi, hy sinh, là những hoa trái quý giá nhất của tình yêu[1].

## 2. Phải dạy từ lúc nào?

Công đồng Vaticanô II ngỏ lời với các bậc làm cha làm mẹ: “Vì đã lãnh nhận ân sủng cũng như bổn phận của bí tích hôn phối nên cha mẹ phải dạy dỗ con cái ngay từ nhỏ[2]“. Cha ông chúng ta cũng thường nói:
Uốn cây từ thuở còn non,
Dạy con từ thuở con còn đương thơ.

“Còn đương thơ” hay “ngay từ nhỏ” ở đây có nghĩa là ngay từ khi còn ở trong bụng mẹ. Khoa học ngày nay cho thấy: Người mẹ ảnh hưởng đến tâm tính và sức khoẻ của đứa con ngay từ lúc phôi thai. Việc giáo dục này được gọi là thai giáo. Trong thời gian này, các tâm tình và thái độ ứng xử của cha mẹ sẽ ghi dấu sâu đậm trên tâm tính đứa con sắp chào đời. Do đó, những bậc cha mẹ thương con sẽ hết sức lưu ý, để trong thời gian mang thai sống thật lành mạnh về luân lý và tâm linh.

Tuy nhiên, thời gian thuận tiện nhất để trực tiếp giáo dục con cái, đó là khi đứa con bắt đầu có trí khôn, bắt đầu nhận biết về những điều cha mẹ dạy bảo. Lúc bấy giờ gia đình sẽ trở nên mái trường đầu tiên dạy cho đứa bé những bài học làm người.

## 3. Phải dạy những gì?

Mục tiêu của giáo dục Kitô giáo là giúp con cái trở thành người và trở thành con Thiên Chúa. Khuôn mẫu là Chúa Giêsu Kitô.

### 3.1. Giáo dục nhân bản

Giáo dục nhân bản gồm ba mặt: đức – trí – thể:

– Thể dục: vệ sinh, sức khoẻ  
– Trí dục: học vấn, nghề nghiệp, tự lập  
– Đức dục: rèn luyện nhân đức, bỏ thói xấu  

Bốn nhân đức trụ cột:
- Khôn ngoan: biết suy nghĩ, cân nhắc, vâng lời, tự kiểm điểm  
- Công bằng: sống thành thật, tôn trọng người khác, lo công ích  
- Tiết độ: kỷ luật, tiết kiệm, chừng mực, biết chọn lựa  
- Dũng cảm: kiên trì điều tốt, nhận trách nhiệm, tự lập  

Đối với người Việt Nam: Trung dung, Nhân – Nghĩa – Lễ – Trí – Tín  
Riêng nữ giới: Công – Dung – Ngôn – Hạnh  

Giáo dục giới tính: giúp hiểu biết đúng đắn, sống trong sạch, biết sử dụng internet và truyền thông phù hợp.

### 3.2. Giáo dục đức tin

Cha mẹ phải dạy con:
– yêu mến Thiên Chúa  
– giữ giới răn  
– tham dự phụng vụ  
– siêng năng bí tích  

Công đồng Vaticanô II dạy: giáo dục Kitô giáo giúp con cái hiểu mầu nhiệm cứu độ, sống đời sống mới trong Đức Kitô và trưởng thành trong đức tin.

## 4. Để việc giáo dục đạt kết quả tốt

### 4.1. Đồng tâm nhất trí
Cha mẹ phải cùng một hướng giáo dục, cùng bàn bạc, cùng cộng tác.

### 4.2. Làm gương sáng
Cha mẹ sống sao, con cái sẽ bắt chước như vậy.

### 4.3. Tạo bầu khí gia đình
Gia đình phải yêu thương, hoà thuận, cầu nguyện và tôn trọng nhau.

### 4.4. Tìm hiểu con cái
Hiểu con để hướng dẫn đúng, tránh áp đặt và hiểu lầm.

### 4.5. Kiên nhẫn
Giáo dục là quá trình lâu dài, cần nhẫn nại, không nản chí.

### 4.6. Cầu nguyện cho con cái
Cha mẹ phải luôn xin Chúa hướng dẫn, nâng đỡ và ban ơn cho con.

* * *

## GHI NHỚ:

1. H. Vì sao giáo dục con cái là bổn phận quan trọng nhất của cha mẹ?  
T. Vì cha mẹ cộng tác với Thiên Chúa trong việc tạo nên con người mới.

2. H. Phải giáo dục con cái những gì?  
T. Giáo dục nhân bản và giáo dục đức tin.

3. H. Làm sao để việc giáo dục đạt kết quả tốt?  
T. Đồng tâm – làm gương – tạo bầu khí gia đình – hiểu con – kiên nhẫn – cầu nguyện.

## SUY NGHĨ:
1. Việc dùng đòn vọt trong giáo dục con cái có nên không?  
2. Những sai lầm cha mẹ hay mắc trong giáo dục là gì?  
3. Yếu tố quan trọng nhất trong giáo dục con cái là gì?

## CẦU NGUYỆN:
Lạy thánh Giuse và Mẹ Maria, xin giúp chúng con biết noi gương Thánh Gia để xây dựng gia đình thánh thiện, biết nuôi dạy con cái trong tình yêu và đức tin, trở nên người cha người mẹ tốt lành và gương mẫu. Amen.`
},
{
  id: 19,
  title: "Đạo hiếu",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Đạo hiếu là bổn phận thảo kính cha mẹ và sống tình gia tộc, thể hiện qua lòng biết ơn, yêu thương, vâng phục và chăm sóc cha mẹ khi còn sống cũng như khi đã qua đời.",
  content: `“Ai không biết lo lắng đến người thân và nhất là gia quyến mình, thì nó đã chối bỏ đức tin, và còn tệ hơn là người không tin.” (1Tm 5,8)

Nói đến gia đình Việt Nam là nói đến đạo hiếu và tình gia tộc. Bước vào cuộc sống hôn nhân, hai vợ chồng không phải chỉ bước vào cuộc sống riêng tư đóng kín chỉ với riêng hai người, mà còn mở ra với cha mẹ đôi bên, cũng như với anh chị em họ hàng.

Như chúng ta đã biết: sau ba điều răn nói về bổn phận đối với Thiên Chúa, điều răn thứ tư nói về bổn phận thảo kính cha mẹ. Như thế, Kinh Thánh coi hiếu thảo là điều răn thứ nhất và quan trọng nhất trong tương quan giữa người với người[1]. “Thiên Chúa muốn rằng sau Ngài, chúng ta phải tôn kính cha mẹ vì đã sinh thành và dạy cho chúng ta biết Thiên Chúa[2]“. Chính Chúa Giêsu, khi đến trần gian đã nêu gương hiếu thảo cho chúng ta: Cuộc sống ở trần gian của Ngài vỏn vẹn chỉ có ba mươi ba năm, nhưng Ngài đã dành ba mươi năm sống hiếu thảo, vâng lời trong gia đình Nadarét[3].

1. Với cha mẹ
1.1. Khi cha mẹ còn sống
Lòng hiếu thảo của con cái đối với cha mẹ phát xuất từ sự biết ơn đối với những bậc đã cộng tác với Thiên Chúa thông truyền cho mình sự sống, cũng như đã chăm lo nuôi dưỡng và giáo dục mình nên người. “Hãy hết lòng tôn trọng cha con và đừng quên những cơn đau đớn của mẹ. Hãy nhớ rằng nhờ cha mẹ, con mới sinh ra. Làm sao con báo đền được điều cha mẹ cho con?” (Hc 7,27-28)

Công đồng Vaticanô II dạy: “Con cái sẽ đáp lại công ơn cha mẹ với lòng biết ơn, tâm tình hiếu thảo và tin cậy, sẽ theo đạo làm con mà phụng dưỡng cha mẹ trong nghịch cảnh cũng như trong tuổi già cô quạnh[4]“.

Khi cha mẹ còn sống, con cái bày tỏ lòng hiếu thảo qua việc: yêu mến, tôn kính, vâng lời, chăm sóc và giúp đỡ cha mẹ.

– Yêu mến và tôn kính cha mẹ. Thiên Chúa muốn ta thật lòng yêu mến và tôn kính cha mẹ trong tư tưởng, lời nói, việc làm.

. Trong tư tưởng, ta thực tình nhìn nhận cha mẹ đáng trọng kính, vì đã sinh thành, nuôi dưỡng, dạy dỗ, hướng dẫn, gây dựng hạnh phúc cuộc đời cho ta.

. Trong lời nói, ta lựa cách xưng hô và chuyện trò thật khiêm cung, êm ái, không bao giờ dùng những lời nói cứng cỏi, nóng nảy đối với cha mẹ.

. Trong việc làm, ta năng thăm viếng, hoặc thư từ, hỏi han, bày tỏ lòng yêu mến bằng quà biếu, tìm cách làm cho cha mẹ được vui. Khi lo liệu việc trọng đại, dù đã ở riêng, ta cũng nên bàn hỏi cha mẹ vì các ngài có ơn Chúa để giúp ta[5]. “Khi trưởng thành, con cái vẫn phải tôn kính cha mẹ, biết đón trước ý muốn của các ngài, sẵn sàng bàn hỏi và chấp nhận những lời khuyến cáo đúng đắn của cha mẹ. Khi không còn chung sống với cha mẹ, con cái vẫn phải tôn kính, vì lòng tôn kính này bắt nguồn từ sự kính sợ Thiên Chúa, một trong bảy ơn Chúa Thánh Thần[6]“.

– Vâng lời cha mẹ. Lòng hiếu thảo được bày tỏ qua sự ngoan ngoãn và vâng phục. “Hỡi con, hãy giữ lấy lời huấn dụ của cha, và đừng ruồng bỏ giáo huấn của mẹ…. Chúng sẽ hướng dẫn con khi con đi, canh giữ con khi con nằm, và khi con thức dậy, chúng chuyện trò với con”(Cn 6,20-22). “Con ngoan mến chuộng lời cha quở mắng, kẻ nhạo báng chẳng nghe lời khiển trách” (Cn 13,1).

Khi chưa trưởng thành, con cái phải mau mắn vâng lời cha mẹ trong tất cả những gì hợp luật Chúa, không nên trách móc phàn nàn. “Hỡi những người con, hãy vâng lời cha mẹ trong mọi sự, vì đó là đẹp lòng Chúa”(Cl 3,20). Ngay cả khi đã trưởng thành và dù đã ở riêng, nếu ta có làm điều gì sai trái mà được cha mẹ nhắc nhở, cần mau mắn vâng theo. Hơn nữa, người con trưởng thành cần biết đón trước điều cha mẹ mong muốn để làm đẹp lòng cha mẹ. Khi cha mẹ lâm chung, có trăn trối điều gì, con cái nên vui lòng tuân giữ. Ngược lại, nếu cha mẹ có ép buộc điều gì trái lương tâm, con cái nên tìm cách giãi bày để cha mẹ cảm thông, chứ không được hùa theo[7].

– Chăm sóc và giúp đỡ cha mẹ. Phải luôn luôn giúp đỡ cha mẹ về phần hồn và phần xác, nhất là khi các ngài già cả, ốm đau, thiếu thốn, cần tận tâm tận lực phụng dưỡng, lo thuốc thang đầy đủ, vui vẻ thăm nom sớm tối. Đây là trách nhiệm của con cái. Đừng vì keo kiệt, ganh tị nhau mà để cha mẹ khổ cực. Phải cầu nguyện cho cha mẹ được mọi ơn lành, lo liệu cho cha mẹ được lãnh các bí tích và dọn mình chết lành. Sách Huấn ca nhắc nhở những người làm con:

Hỡi kẻ làm con, hãy gánh lấy tuổi già cha ngươi,
chớ làm phiền lòng người, khi người còn sống.
Nếu tinh thần người sa sút, thì hãy rộng lượng,
ngươi là kẻ trai tráng, chớ đành khinh dể người.
Vì của dâng cho cha, sẽ không rơi vào quên lãng.
Của biếu cho mẹ, sẽ đền bù tội lỗi,
và xây dựng đức công chính của người.
Ai bỏ rơi cha mình thì khác nào kẻ lộng ngôn,
ai chọc giận mẹ mình, sẽ bị Đức Chúa nguyền rủa.
(Hc 3,12-16)

1.2. Khi cha mẹ qua đời
Khi cha mẹ qua đời, con cái tỏ lòng hiếu kính bằng cách lo an táng chu đáo, cầu nguyện và xin lễ cho cha mẹ. Anh chị em cần hoà thuận yêu thương nhau, noi gương cha mẹ để nên lành nên thánh. Không những cầu nguyện cho cha mẹ, con cái còn xin cha mẹ cầu nguyện cho mình trước mặt Chúa, như khi còn sống, các ngài vẫn cầu nguyện cho mình.

Hội Thánh Công giáo đón nhận việc thờ cúng ông bà như thế nào? Hội Thánh nhìn nhận đó là một hình thức tốt đẹp để bày tỏ lòng tưởng nhớ công ơn tiền nhân. Hội Thánh khuyến khích các tín hữu phát huy những tinh hoa trong văn hoá dân tộc. Tuy nhiên cần loại trừ những hình thức trái ngược với giáo lý Công giáo.

Cũng cần nâng cao ý thức lịch sử về gia đình: Quan tâm bảo tồn gia phả và những kỷ vật của ông bà cha mẹ đã qua đời. Gia đình nào đã thất lạc gia phả, nên tìm cách dựng lại những gì còn biết được, nên làm càng sớm càng tốt khi những bậc cao niên trong dòng họ còn đủ minh mẫn để cung cấp các dữ liệu họ nắm được. Cũng nên quan tâm lưu giữ những hình ảnh và giấy tờ quan trọng của gia đình để các thế hệ sau có sử liệu.

2. Với họ hàng đôi bên
Đối với người Việt Nam, tương quan với họ hàng gia tộc là điều quan trọng. Lấy vợ, lấy chồng không chỉ là lấy một người mà “lấy” cả họ hàng nhà chồng, nhà vợ. Cách cư xử với họ hàng bên chồng hay bên vợ không chỉ liên quan đến bản thân mà còn liên quan đến cả họ hàng bên mình. Bởi vậy, cần yêu mến và học cách cư xử với tất cả mọi người trong dòng họ hai bên, như ông bà, chú bác, cô dì, cậu mợ và anh chị em. Cần sống tình gia tộc bằng cách năng lui tới viếng thăm và giúp đỡ theo khả năng của mình.

GHI NHỚ :
1. H. Tại sao con cái phải hiếu thảo đối với cha mẹ?

T. Vì cha mẹ là những người cộng tác với Thiên Chúa trong việc sinh thành, nuôi dưỡng và giáo dục ta nên người. Ngoài ra, đây còn là điều răn Chúa đã truyền dạy.

2. H. Con cái biểu lộ lòng hiếu thảo với cha mẹ như thế nào?

T. Con cái bày tỏ lòng hiếu thảo qua những việc sau đây:

– Một là khi các ngài còn sống thì phải yêu mến, tôn kính, vâng lời, chăm sóc và giúp đỡ.
– Hai là khi các ngài qua đời phải lo an táng, cầu nguyện và xin lễ.
– Ba là anh chị em trong nhà cần hoà thuận yêu thương nhau, noi gương cha mẹ để nên lành thánh.

3. H. Ta cần cư xử thế nào với họ hàng đôi bên?

T. Ta phải kính trọng và yêu mến mọi người trong gia tộc; năng lui tới và giúp đỡ theo khả năng mình.

GỢI Ý SUY NGHĨ:
1. Có người nói: “Theo đạo Chúa là bỏ ông bà”. Anh chị trả lời thế nào?
2. Anh chị đã biết gì về cha mẹ, anh chị em và họ hàng của bạn mình?

CẦU NGUYỆN:
Lạy Thiên Chúa là Cha chúng con, Cha đã muốn biểu lộ tình Cha yêu thương chúng con qua tấm lòng yêu thương của người cha người mẹ trần thế. Cha còn muốn rằng, sau Cha, chúng con phải tôn kính cha mẹ vì các ngài đã có công sinh thành và dưỡng dục chúng con nên người. Xin Cha chúc lành, nâng đỡ và ban mọi ơn lành hồn xác cho cha mẹ chúng con. Xin giúp chúng con luôn biết biết lấy tình yêu mà đáp lại tình yêu của các ngài bằng cách sống hiếu thảo, yêu mến, tôn kính, vâng lời và phụng dưỡng các ngài.

Xin cho các ngài, ngay ở đời này tìm thấy niềm hạnh phúc được phục vụ Cha và yêu mến Cha. Và xin cho chúng con một ngày kia được sum họp với nhau trên Nước Trời. Amen`
},
{
  id: 20,
  title: "Những ngày lễ của gia đình",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Những ngày lễ của gia đình là dịp để mọi người quây quần bên nhau trong tình yêu thương hiệp nhất, vun xới thêm tình nghĩa, duy trì và phát huy những nét đẹp truyền thống gia đình trong ánh sáng đức tin Kitô giáo.",
  content: `Bài 20: Những ngày lễ của gia đình
“Ngọt ngào tốt đẹp lắm thay,
anh em được sống vui vầy bên nhau.”
(Tv 133,1)

Mỗi gia đình đều có những ngày lễ riêng, đánh dấu những biến cố vui, buồn của gia đình. Chẳng hạn như ngày giỗ của ông bà, cha mẹ, ngày kỷ niệm thành hôn của vợ chồng, ngày sinh nhật, ngày lễ bổn mạng của một người trong gia đình… Những ngày lễ của gia đình là dịp để mọi người trong gia đình quây quần bên nhau trong tình yêu thương hiệp nhất, vun xới thêm tình gia đình.

Đầu năm, mỗi gia đình nên ghi các ngày lễ của gia đình mình vào cuốn lịch Công giáo để dễ nhớ.

1. Lễ Gia tiên
Trong Cựu Ước, Thiên Chúa thường tự xưng là Thiên Chúa của Abraham, của Ixaác, của Giacop, nghĩa là Thiên Chúa các tổ phụ. Ngài không phải là Thiên Chúa của kẻ chết, nhưng là Thiên Chúa của người sống.[1] Bên kia cái chết, các bậc tiền nhân đã thực sự “sống khôn thác thiêng” đều đang sống trong Thiên Chúa. Các tín hữu ở trần gian kết hợp với họ trong mầu nhiệm các thánh thông công. Do đó, khi bày tỏ lòng hiếu kính, nhớ đến gia tiên tổ phụ, người Công giáo không làm một sự thờ phượng nằm ngoài sự thờ phượng Thiên Chúa, nhưng là để nhờ đó mà thêm lòng biết ơn và kính mến Thiên Chúa là nguồn mọi tình phụ tử trên trời dưới đất[2]. Đàng khác, khi nhớ đến tổ tiên theo huyết thống, người Công giáo cũng nhớ đến các tổ phụ trong đức tin.

Người Việt Nam thường có thói quen rất tốt: mỗi khi gia đình có việc buồn vui đều luôn tưởng nhớ gia tiên và biểu lộ tâm tình ấy bằng việc cúng lễ, hoặc đơn giản thắp một nén nhang trên bàn thờ. Người tín hữu Công giáo Việt Nam tiếp nhận truyền thống tốt đẹp ấy với một cái nhìn chính xác, phù hợp với đức tin Kitô giáo.

Mỗi gia đình nên có một bàn thờ gia tiên đơn sơ. Ngày tết, ngày giỗ nên giữ một cây hương cháy suốt ngày. Tránh những chi tiết trái với đức tin và tránh tốn kém không hợp tình hợp lý. Về hình thức, cốt sao biểu lộ được tấm lòng và giúp con cháu trong nhà học được tâm tình biết ơn tổ tiên và biết ơn Thiên Chúa Tạo Hoá.

Khi cúng lễ, cần nhắc cho mọi người trong nhà nhớ: đức tin Công giáo dạy ta biết rằng người quá cố không cần đến thức ăn vật chất, các lễ vật chỉ nhằm bày tỏ lòng biết ơn kính nhớ mà thôi.

Lễ gia tiên thường do vị trưởng tộc hoặc người cha trong gia đình chủ lễ. Nếu vị này vắng mặt, thì vợ hoặc con trai hoặc con dâu trưởng chủ lễ.

2. Dọn tất niên
Tết Nguyên đán là dịp sum họp gia đình, kính nhớ tổ tiên và thăm viếng nhau để gia tăng tình thân ái. Cần loại bỏ những chi tiết phong tục quá rườm rà, cũng như những gì đi ngược lại với Tin mừng, và phải lưu ý phát huy những gì tốt đẹp. Khởi đầu là việc dọn tất niên.

Từ giữa tháng chạp là thời gian thuận tiện để mỗi gia đình tổng kết một năm. Cha mẹ và con cái sẽ cùng nhau:

– Làm xong những việc cần thiết còn đọng lại.
– Tổng kết chi thu, thanh toán nợ nần.
– Tổng kết kinh nghiệm sống, kinh nghiệm làm việc một năm qua.
– Chọn hướng sống hoặc chủ đề giáo dục gia đình trong năm mới.
– Dọn mình xưng tội cuối năm.
– Cha mẹ đỡ đầu thăm nom nhắc nhở con thiêng liêng (các con thiêng liêng thì chúc tết cha mẹ đỡ đầu dịp cuối năm hoặc đầu năm).
– Cũng nên dành một tuần lễ kết bó hoa thiêng liêng tạ ơn Thiên Chúa và cầu cho nhau (gồm: dâng lễ, rước lễ, đọc Lời Chúa, lần hạt, hy sinh…)

Những việc trên đây sẽ làm xong trước ngày ăn bữa tất niên (vào ngày cuối năm hoặc một ngày nào sớm hơn, tùy tiện). Bữa ăn này được coi như để kết toán mọi chuyện: còn gì phải xin lỗi nhau, hoặc góp ý xây dựng đều nói hết trong dịp này, để rồi ngày đầu năm sẽ không còn phải nhắc gì đến chuyện cũ, chỉ chúc tuổi nhau thật vui vẻ.

Cũng nên nhân bữa ăn này mà trình bày chủ đề sống của năm tới và dự tính trước việc vui xuân của gia đình, thu xếp sao để trẻ em khỏi lây nhiễm thói xấu cờ bạc ngoài xã hội.

3. Tưởng nhớ gia tiên dịp Tết Nguyên Đán
Dịp Tết Nguyên Đán, trong những gia đình theo đúng tinh thần Việt Nam, ẩn dưới những niềm vui rộn rã đầu xuân là cả một thực tại linh thiêng trầm mặc đầy ắp không gian: cõi hữu hình và cõi vô hình đan dệt vào nhau, ông bà tổ tiên đã khuất như thể đang có mặt giữa con cháu một cách thân thiết, gần gũi, linh thiêng và đầy an ủi. Có được bầu khí ấy là nhờ các nghi lễ rất nghiêm túc của phụng tự gia đình.

Các nghi lễ này mở đầu với giờ “cúng đón” (đón ông bà về ăn tết với con cháu) vào ngày 29 hoặc 30 tết, và kết thúc với giờ “cúng đưa” (tiễn chân ông bà) vào ngày mùng 3 hay mùng 4 tết (có nhà cúng đưa từ chiều mùng 2). Người Công giáo biết rằng các linh hồn đã về với Thiên Chúa vẫn hiệp thông với các tín hữu ở trần gian thường xuyên, chứ không riêng mấy ngày tết, cho nên không có chuyện đón ông bà về ăn tết và tiễn ông bà đi. Tuy nhiên, thiết tưởng ngày nay cả nơi đại chúng người không có đạo, không mấy ai còn hiểu hai chữ đón đưa này theo nghĩa đen, nhưng hiểu theo một nghĩa tượng trưng sâu sắc, nhằm xác định một thái độ nội tâm và đánh dấu khoảng thời gian họ muốn dành để tưởng nhớ gia tiên một cách thật sâu đậm, khoảng thời gian họ muốn để cho tâm hồn lắng đọng trong niềm cảm mến biết ơn.

Trong khoảng thời gian ấy, bàn thờ gia tiên lúc nào cũng có khói hương, mỗi ngày người ta cúng hai ba lần vào đúng giờ cả nhà quy định trước. Mỗi gia đình có một người trực ở nhà để giữ cho hương đèn được liên tục, và lo nấu thức ăn, đúng giờ thì bày lên bàn thờ, thành tâm cầu nguyện. Người trực đóng vai đại diện gia đình, luôn ở trong tâm tình cung kính trước sự hiện diện của anh linh tiên tổ, để bày tỏ niềm biết ơn và tưởng nhớ. Ngày nay, cả người không có đạo cũng không mấy ai còn nghĩ ông bà tổ tiên cần “ăn tết”, nhưng người ta thấy rằng sự túc trực để bày tỏ lòng thành là điều cần thiết. Đó là một tâm tình rất thiêng liêng cao quý mà bầu khí của các lễ nghi gia tiên đã đem lại.

Khi đón nhận các truyền thống tốt đẹp của dân tộc, người Công giáo nhằm đạt được phần tinh hoa, chứ không vụ vào những hình thức rườm rà. Tuy vậy, trong mức độ vừa phải, hình thức vẫn cần thiết. Để phục hồi và phát huy được bầu khí linh thiêng thuận lợi cho tình cảm và hạnh phúc gia đình, rất cần giữ lấy những hình thức diễn tả tối thiểu và chính yếu.

4. Lễ giao thừa
Tối cuối năm, gia đình đoàn tụ, giải trí chung với nhau, cùng thức đón giao thừa. Giây phút kết thúc năm cũ và bắt đầu năm mới là lúc thật ý nghĩa để ca tụng Chúa, Đấng làm chủ thời gian và lịch sử. Khí xuân mới cũng gợi cho ta nhớ đến công trình sáng tạo của Ngài. Chúng ta xin Chúa chúc lành cho một năm mới đang bắt đầu. Sau khi cầu nguyện, mọi người chúc tuổi nhau rồi đi ngủ.

Lễ giao thừa không phải là lễ gia tiên. Lễ gia tiên đã được thực hiện vào lúc “tiên thừa”, tức là lúc đầu hôm đêm cuối năm. Tuần hương thắp lúc giao thừa là để kính thờ Đấng Tạo Hoá và cầu nguyện với Ngài.

5. Lễ Minh niên
Gia đình sum họp buổi sáng đầu năm là điều rất quý giá. Thánh lễ ở nhà thờ xong, mọi người về nhà ngay. Các cháu mừng tuổi ông bà, con cái mừng tuổi cha mẹ, mọi người mừng tuổi nhau.

6. Lễ bổn mạng một người trong gia đình
Trước ngày lễ, người có tên thánh bổn mạng nên dành vài giờ tĩnh tâm cầu nguyện. Ngày lễ, cả nhà đi dự lễ, rước lễ sốt sắng. Kinh tối, theo chương trình trong tuần (nên hỏi linh mục về lời nguyện ngày lễ, chép sẵn từ trước). Nhớ nhắc con thiêng liêng dọn mừng lễ bổn mạng. Hôm lễ, nên mời các con thiêng liêng dùng cơm.

7. Giáp năm ngày rửa tội
Trước ngày lễ, người có lễ kỷ niệm nên dành vài giờ tĩnh tâm cầu nguyện. Ngày lễ, cả nhà đi dự lễ, rước lễ sốt sắng. Trong giờ Kinh tối, gia đình cùng hiệp ý dâng lời tạ ơn, đồng thời cũng nhắc nhớ nhau sống xứng đáng ơn gọi làm Kitô hữu.

8. Thôi nôi hoặc sinh nhật
Đây là dịp vui của toàn gia đình. Những món quà nho nhỏ của mọi người vào dịp này là một cách bày tỏ sự quan tâm và yêu thương nhau. Nên tổ chức một bữa ăn để tạo thêm bầu khí yêu thương. Giờ kinh tối cũng là dịp để toàn thể gia đình cùng hiệp thông với nhau trong niềm vui này.

9. Giáp năm ngày cưới
Mỗi lần phong thánh, Hội Thánh cũng ấn định ngày mừng lễ hằng năm, thường là vào ngày qua đời của vị thánh. Ngày 22-10-2001 vừa qua, Đức Thánh Cha Gioan Phaolô II đã phong chân phước cho đôi vợ chồng người Ý là Luy và Maria Beltrame Quattrocchi. Tuy nhiên, để ấn định ngày mừng lễ, ngài không chọn ngày qua đời của họ như thường lệ, mà lại chọn ngày kỷ niệm lễ thành hôn của họ: ngày 25-11-1905.

Trước ngày kỷ niệm lễ thành hôn, nếu có điều kiện, vợ chồng nên tĩnh tâm vài giờ, nhớ lại tình thương Chúa và kiểm điểm đời sống để tiếp tục xây dựng hạnh phúc gia đình. Ngày kỷ niệm, vợ chồng, con cái cùng đi dự lễ. Ở nhà, trong bữa ăn kỷ niệm, nên nhắc đến niềm vui này. Những dịp khác trong năm có thể mang những hình thức đơn giản, nhưng hôm nay phải là đại lễ của gia đình. Nếu được, cũng nên mời vài đôi bạn thân thiết cùng dự bữa ăn và chia sẻ kinh nghiệm. Giờ kinh tối, nên dành ít phút để dâng lên Chúa tâm tình tạ ơn, xin Chúa chúc lành và củng cố mối giây yêu thương giữa hai vợ chồng và tất cả gia đình.

10. Ma chay
10.1. Trong thánh lễ an táng cũng như trong những dịp cầu nguyện cho các tín hữu đã qua đời, Hội Thánh cử hành mầu nhiệm phục sinh, xác tín rằng những người đã tin vào Đức Kitô và đã chịu phép Rửa tội để nên chi thể Ngài, sẽ được cùng Ngài vượt qua sự chết mà đến sự sống. Vì thế, mọi lời dẫn giải, lời ca, lời kinh trong các dịp ấy phải diễn tả được niềm hy vọng vào đời sống vĩnh cửu. Trong tinh thần đức tin, thân nhân của người mới qua đời cũng cần tỏ ra can đảm, bình an, tránh khóc lóc ai oán.

10.2. Người Công giáo đón nhận tất cả những gì tốt đẹp trong truyền thống dân tộc về việc tôn kính ông bà tổ tiên cũng như về việc mai táng, nhưng dứt khoát loại bỏ những chi tiết không phù hợp với đức tin, như coi ngày giờ, coi phương hướng, rải giấy vàng bạc, vẽ bùa, đập chén bát khi động quan, vv…

10.3. Tang phục: Nên có một dấu hiệu nào đó để nói lên tâm tình đau buồn thương tiếc tự nhiên của ta, nhưng không nên để nó che mờ nỗi vui mừng lớn lao đích thực của người con vừa được gọi về nhà Cha và niềm hy vọng vào một ngày kia sẽ gặp lại người ấy trong hạnh phúc quê trời. Tránh những tang phục rườm rà gây cảm tưởng mình hoàn toàn mất mát, thất vọng ê chề và những gì không rõ ý nghĩa.

10.4. Mọi cách diễn tả trong tang lễ cũng như trong việc thờ kính tổ tiên phải có ý nghĩa rõ ràng chính xác, hợp với đức tin và tình yêu thương. Làm một hành vi, ta phải hiểu ý nghĩa của hành vi đó. Ví dụ, việc rảy nước thánh và vái kính thi hài phải được hiểu đúng:

– Rảy nước thánh trên thi hài là để nhớ rằng nhờ nước rửa tội, người tín hữu đã được ghi tên vào số những người được sống đời đời.

– Thắp nhang đèn, vái kính trước thi hài tín hữu là vì thân xác ấy đáng tôn trọng: lúc còn sống, thân xác ấy đã là đền thờ Chúa Thánh Thần, và giờ đây đang đợi chờ ngày sống lại.

10.5. Trong việc cầu nguyện cho người quá cố, Lời Chúa là phần quan trọng, nên chọn đoạn Kinh Thánh cho thích hợp.

10.6. Người hướng dẫn các giờ cầu nguyện nên làm phấn khởi lòng trông cậy của thân nhân người quá cố, cũng như hun đúc niềm tin của mọi người đang hiện diện, nhưng phải liệu sao để không làm phật lòng những người đang buồn phiền.

11. Lễ giỗ
Việc cầu nguyện trong ngày giỗ vừa để cảm tạ Chúa đã giải thoát các bậc tổ tiên, đưa về hưởng nhan Chúa, vừa để cầu xin Chúa sớm giải thoát những người đang phải ở luyện ngục (thường đối với những người mới qua đời, ta hướng tới việc cầu hồn, còn đối với những người đã qua đời từ lâu, ta có thể tin vào lòng Chúa nhân từ mà dâng lời cảm tạ). Ngay cả những vị đã chết mà không chịu phép Rửa tội, ta vẫn tin rằng Thiên Chúa nhân từ và đầy quyền năng đã có cách cứu vớt họ trong Đức Kitô và nhờ Đức Kitô.

Giờ kinh tối sẽ theo ngày trong tuần, với lời nguyện giỗ. Nếu là cầu hồn, thì theo mẫu canh thức cầu nguyện cho tín hữu đã qua đời.

Cũng đừng quên rằng chúng ta có thể cầu nguyện với những bậc tổ tiên đang được hưởng hạnh phúc với Thiên Chúa. Nói đúng hơn, ta có thể xin họ cầu nguyện với Chúa cho ta. Khi còn sống, họ đã yêu thương cầu nguyện cho ta, thì khi đã về với Chúa, họ còn yêu thương ta hơn và lời cầu nguyện của họ còn hữu hiệu hơn.

GHI NHỚ:
1. H. Những ngày lễ của gia đình mang ý nghĩa gì?

T. Những ngày lễ của gia đình là dịp để mọi người quây quần bên nhau trong tình yêu thương hiệp nhất, vun xới thêm tình nghĩa, duy trì những nét đẹp truyền thống của gia đình mình.

2. H. Đối với các dịp lễ của gia đình, ta nên tổ chức thế nào?

T. Ta nên tổ chức đơn sơ, vừa phù hợp với nét đẹp của văn hoá dân tộc, vừa biểu lộ được đức tin Kitô giáo của mình.

GỢI Ý SUY NGHĨ:
1. Ngày lễ nào trong gia đình đã để lại trong anh chị dấu ấn sâu đậm nhất?
2. Những ngày lễ giỗ trong gia đình anh chị được tổ chức thế nào?
3. Anh chị đã làm gì khi đến ngày sinh nhật hoặc ngày lễ bổn mạng của cha mẹ, hoặc anh chị em trong gia đình?

CẦU NGUYỆN:
Lạy Chúa,
Cha đã làm cho chúng con thành một gia đình.
Chúng con cần đến nhau
Chúng con yêu thương nhau.
Chúng con tha thứ cho nhau.
Chúng con làm việc với nhau.
Chúng con vui đùa có nhau
Chúng con cầu nguyện bên nhau.
Cùng với nhau chúng con lắng nghe Lời Chúa
Cùng với nhau chúng con lớn lên trong Đức Kitô
Cùng với nhau chúng con yêu thương mọi người chung quanh
Cùng với nhau chúng con phụng thờ Chúa
Cùng với nhau chúng con hy vọng Nước Trời.

Lạy Chúa,
Đó là những điều chúng con ước nguyện,
Xin giúp chúng con đạt tới
nhờ Đức Giêsu Kitô, Chúa chúng con. Amen.`
},
{
  id: 21,
  title: "Gia đình và xã hội",
  tag: "HÔN NHÂN & GIA ĐÌNH",
  desc: "Gia đình và xã hội có mối liên hệ mật thiết, trong đó gia đình là tế bào đầu tiên của xã hội và góp phần quan trọng trong việc xây dựng, bảo vệ và phát triển xã hội theo tinh thần Kitô giáo.",
  content: `Bài 21: Gia đình và xã hội
“Sự sáng của các con cũng phải chiếu giải ra trước mặt thiên hạ, để họ xem thấy việc lành của các con mà ngợi khen Cha các con trên trời.” (Mt 5,16)

Giữa gia đình và xã hội có một mối liên hệ mật thiết. “Tương lai của nhân loại sẽ đến qua gia đình[1]“. Ngược lại, xã hội có trật tự yên ổn thì gia đình mới phát triển. Chính vì thế, gia đình và xã hội có bổn phận phải góp phần xây dựng, bảo vệ, củng cố và phát triển lẫn nhau.

Riêng đối với người Kitô hữu, mối quan hệ giữa gia đình và xã hội còn sâu sắc hơn, bởi vì tính cách trần thế là nét riêng biệt và đặc thù của ơn gọi Kitô hữu giáo dân. “Người giáo dân sống giữa trần gian, giữa những cảnh sống thường ngày trong gia đình và ngoài xã hội. Đó là nơi Thiên Chúa mời gọi họ. Nhờ sự hướng dẫn của tinh thần Phúc Âm, như men từ bên trong, họ thánh hoá thế giới bằng việc thi hành những nhiệm vụ của mình[2]“.

1. Gia đình là tế bào đầu tiên và sống động của xã hội
Gia đình là tế bào căn bản của đời sống xã hội, là xã hội tự nhiên, nơi đó người nam và người nữ được mời gọi tận hiến cho nhau trong tình yêu và trong việc thông truyền sự sống. Quyền bính, sự ổn định và đời sống gắn bó trong gia đình là nền tảng cho tự do, an ninh và tình huynh đệ của xã hội.

“Gia đình là cộng đoàn, nơi đó từ thời thơ ấu, con người được học biết tôn trọng những giá trị luân lý, tôn thờ Thiên Chúa và biết sử dụng tự do. Đời sống gia đình chuẩn bị cho đời sống xã hội[3]“.

2. Xã hội phục vụ gia đình
Gia đình có tốt thì xã hội mới tốt. Tuy nhiên, ngày nay đời sống gia đình đang gặp phải nhiều bóng tối. Nề nếp gia phong bị suy giảm. Khuynh hướng hưởng thụï ích kỷ phát triển dẫn đến lối sống buông thả, từ đó làm gia tăng những vụ ly dị, phá thai, không còn ý thức về phẩm giá sự sống. Con số thanh thiếu niên rơi vào xì ke, ma tuý, mại dâm, sống lang thang ngoài đường phố tăng thêm nhiều…

Chính vì thế, mọi người hữu trách và mọi người thiện chí đều phải quan tâm đến việc bảo vệ, củng cố và thăng tiến các giá trị đời sống gia đình. Đặc biệt, cần tôn trọng, trợ giúp và nhất là bảo đảm cho gia đình có được các quyền sau đây:

– “Quyền tự do lập gia đình, quyền sinh con cái và giáo dục chúng theo những xác tín luân lý và tôn giáo của mình”.

– “Quyền bảo toàn dây liên kết vững bền của hôn nhân và cơ chế gia đình”.

– “Quyền tự do tuyên xưng đức tin và thông truyền đức tin, quyền giáo dục đức tin cho con cái bằng những phương tiện và cơ chế cần thiết”.

– “Quyền tư hữu, tự do làm việc, có việc làm, có nhà ở, tự do di cư”.

– “Quyền được chăm sóc y tế trợ cấp tuổi già, phụ cấp gia đình, tùy theo cơ chế của các quốc gia”.

– “Quyền được bảo vệ an ninh và cuộc sống lành mạnh, tránh các nguy cơ như: xì ke ma túy, dâm ô đồi trụy, nghiện rượu…”

– “Quyền tự do liên kết với các gia đình khác để lập hội đoàn và như thế, được đại diện bên cạnh công quyền”[4].

Trên bình diện giáo xứ cũng như giáo phận, trong thư mục vụ năm 2002, Hội Đồng Giám mục VN đề nghị:

– Các Giáo phận nên có Văn phòng Mục vụ về Hôn nhân và Gia đình.

– Các Giáo xứ nên tổ chức các lớp học hỏi về hôn nhân và gia đình. Để các lớp học hỏi về hôn nhân và gia đình có được kết quả tốt đẹp, cần soạn thảo một chương trình giáo lý hôn nhân, đào tạo một đội ngũ giáo lý viên vững vàng, kêu gọi sự cộng tác của giáo dân có khả năng chuyên môn và có kinh nghiệm trong các lãnh vực: tâm lý, xã hội, pháp luật, quản trị, y khoa.

– Ban Mục vụ giáo xứ có một bộ phận chuyên trách về gia đình với sự cộng tác của các Hội đoàn quan tâm đến tình trạng các gia đình trong khu xóm, đặc biệt các gia đình nghèo khổ, bất thuận và các gia đình di dân, để kịp thời giúp đỡ.

– Những ngày lễ gia đình, ngày kỷ niệm thành hôn, những buổi giao lưu giữa các gia đình sẽ rất ích lợi nếu được chuẩn bị chu đáo với tinh thần cầu nguyện và học hỏi.

3. Gia đình góp phần xây dựng và phát triển xã hội
– Tham gia vào các việc chung, các công tác xã hội. “Đối với người tín hữu, xao lãng bổn phận trần thế tức là xao lãng bổn phận đối với tha nhân, và hơn nữa đối với chính Thiên Chúa, khiến phần rỗi đời đời của mình bị đe doạ[5]“.

– Giáo dục con cái nên người. Gia đình là chiếc nôi, là trường học đầu tiên, nơi con cái lớn lên cả về thể xác lẫn tinh thần, nơi con cái không chỉ được dạy dỗ bằng lời nói mà còn bằng gương sáng. Bởi vậy, gia đình còn được gọi là trường đào tạo nhân đức. Cần dạy con cái về nhân, nghĩa, lễ, trí, tín, đặc biệt là các đức tính thành thật, công bằng, tôn trọng sự sống, tôn trọng phẩm giá con người, yêu thương người nghèo, người già cả, neo đơn, ốm đau, tật nguyền…[6]

– Góp phần xây dựng một nền văn minh tình thương. Đó là một xã hội công bằng và yêu thương. “Hội Thánh mong muốn người Công giáo đem tinh thần Kitô giáo thấm nhuần tư tưởng, phong tục, luật lệ và cơ cấu của cộng đoàn nơi họ đang sống…. qua đức tin và đức ái của mình, bằng đời sống lương thiện như ánh sáng trần gian, tìm cách cộng tác với mọi người, đối thoại với họ, để phổ biến những gì là chân thật, công bằng[7]“.

“Trong các việc tông đồ của gia đình, cần phải kể các việc như sau: nhận nuôi trẻ bị bỏ rơi, cho khách trọ nhờ, cộng tác với học đường, giúp thanh thiếu niên, đỡ đầu các đôi hôn nhân, giúp dạy giáo lý, nâng đỡ những gia đình gặp khó khăn về vật chất và tinh thần, lo cho người già những điều cần thiết và tiện nghi chính đáng[8]“.

GHI NHỚ:
1. H. Gia đình nắm giữ vai trò nào đối với xã hội?

T. Gia đình chính là tế bào đầu tiên và sống động của xã hội.

2. H. Xã hội có trách nhiệm thế nào đối với gia đình?

T. Xã hội cần phải quan tâm đến việc bảo vệ, củng cố và thăng tiến các giá trị đời sống gia đình.

3. H. Gia đình góp phần xây dựng xã hội bằng cách nào?

T. Gia đình góp phần xây dựng xã hội bằng cách tuân giữ luật pháp quốc gia, cộng tác trong những công việc chung để phát triển đất nước, giáo dục con cái trở nên người hữu ích và góp phần xây dựng nền văn minh tình thương.

GỢI Ý SUY NGHĨ:
1. Trong Tông huấn về Gia đình, Đức Thánh Cha Gioan Phaolô II nói: “Tương lai của nhân loại sẽ đến qua gia đình”. Anh chị nghĩ sao về điều này? Gia đình của anh chị có trách nhiệm gì đối với tương lai của đất nước và của gia đình nhân loại?

2. Thư mục vụ năm 2002 của HĐGM VN, trong phần kết luận đã viết như sau: “Một gia đình Kitô hữu thực sự tốt đẹp không thể chỉ đóng kín trong những sinh hoạt riêng tư, nhưng cần mở rộng mối quan hệ với những gia đình chung quanh, để kính trọng yêu thương, trao đổi học hỏi và quan tâm giúp đỡ, góp phần phát triển nền văn minh tình thương”. Gia đình của anh chị sẽ góp phần xây dựng nền văn minh tình thương như thế nào?

CẦU NGUYỆN:
Lạy Thánh Gia Nadarét là gương mẫu của đời sống thánh thiện, công bình và yêu thương, xin cho gia đình chúng con trở nên nơi đào tạo nhân đức, trong hiền hoà, phục vụ và cầu nguyện. Xin cho chúng con xây dựng gia đình thành niềm an ủi cho cuộc đời đầy thử thách. Xin cho chúng con biết làm cho mọi người trong gia đình đều được thăng tiến để góp phần vào việc phát triển xã hội, và cộng tác trong việc xây dựng Hội Thánh. Amen`
}
]
export default lessonsHonnhan